<template>

  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  	 viewBox="0 0 800 360" style="enable-background:new 0 0 800 360;" xml:space="preserve">
  <g id="gingive">
  	<g id="gingive_x5F_izmedju">
  		<g>
  			<g>

  					<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="4945.7422" y1="-6287.4346" x2="4945.7422" y2="-6328.4131" gradientTransform="matrix(-1 0 0 -1 5345.7422 -6034.5977)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st0" d="M391,273.3c0-11.3,4-20.5,9-20.5c5,0,9,9.2,9,20.5c0,11.3,4.5,20.5-9,20.5C386.7,293.8,391,284.6,391,273.3
  					z"/>
  			</g>
  			<path class="st1" d="M391,273.3c0-11.3,4-20.5,9-20.5c5,0,9,9.2,9,20.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="2278.8936" y1="-6284.5088" x2="2278.8936" y2="-6329.4189" gradientTransform="matrix(-1 0 0 -1 2713.5293 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st2" d="M424.6,275.3c0-12.4,4.5-22.5,10-22.5c5.5,0,10,10.1,10,22.5s5,22.5-10,22.5
  					C419.9,297.7,424.6,287.7,424.6,275.3z"/>
  			</g>
  			<path class="st1" d="M424.6,275.3c0-12.4,4.5-22.5,10-22.5c5.5,0,10,10.1,10,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="2245.9807" y1="-6284.5088" x2="2245.9807" y2="-6329.4189" gradientTransform="matrix(-1 0 0 -1 2713.5293 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st3" d="M458.7,275.3c0-12.4,4-22.5,8.9-22.5c4.9,0,8.9,10.1,8.9,22.5s4.4,22.5-8.9,22.5
  					C454.5,297.7,458.7,287.7,458.7,275.3z"/>
  			</g>
  			<path class="st1" d="M458.7,275.3c0-12.4,4-22.5,8.9-22.5c4.9,0,8.9,10.1,8.9,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="2205.2998" y1="-6284.5078" x2="2205.2998" y2="-6329.417" gradientTransform="matrix(-1 0 0 -1 2713.5293 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st4" d="M496.7,275.3c0-12.4,5.2-22.5,11.5-22.5c6.4,0,11.5,10.1,11.5,22.5c0,12.4,5.7,22.5-11.5,22.5
  					C491.2,297.7,496.7,287.7,496.7,275.3z"/>
  			</g>
  			<path class="st1" d="M496.7,275.3c0-12.4,5.2-22.5,11.5-22.5c6.4,0,11.5,10.1,11.5,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="2166.4524" y1="-6284.5078" x2="2166.4524" y2="-6329.417" gradientTransform="matrix(-1 0 0 -1 2713.5293 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st5" d="M533.8,275.3c0-12.4,5.9-22.5,13.3-22.5c7.3,0,13.3,10.1,13.3,22.5c0,12.4,6.6,22.5-13.3,22.5
  					C527.5,297.7,533.8,287.7,533.8,275.3z"/>
  			</g>
  			<path class="st1" d="M533.8,275.3c0-12.4,5.9-22.5,13.3-22.5c7.3,0,13.3,10.1,13.3,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="2127.1702" y1="-6284.5068" x2="2127.1702" y2="-6329.416" gradientTransform="matrix(-1 0 0 -1 2713.5293 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st6" d="M571.6,275.3c0-12.4,6.6-22.5,14.8-22.5s14.8,10.1,14.8,22.5c0,12.4,7.3,22.5-14.8,22.5
  					C564.6,297.7,571.6,287.7,571.6,275.3z"/>
  			</g>
  			<path class="st1" d="M571.6,275.3c0-12.4,6.6-22.5,14.8-22.5s14.8,10.1,14.8,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="2063.8225" y1="-6284.5068" x2="2063.8225" y2="-6329.416" gradientTransform="matrix(-1 0 0 -1 2713.5293 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st7" d="M633.6,275.3c0-12.4,7.2-22.5,16.1-22.5c8.9,0,16.1,10.1,16.1,22.5c0,12.4,8,22.5-16.1,22.5
  					C625.9,297.7,633.6,287.7,633.6,275.3z"/>
  			</g>
  			<path class="st1" d="M633.6,275.3c0-12.4,7.2-22.5,16.1-22.5c8.9,0,16.1,10.1,16.1,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_8_" gradientUnits="userSpaceOnUse" x1="2002.7194" y1="-6284.5068" x2="2002.7194" y2="-6329.416" gradientTransform="matrix(-1 0 0 -1 2713.5293 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st8" d="M696.7,275.3c0-12.4,6.3-22.5,14-22.5c7.8,0,14,10.1,14,22.5c0,12.4,7,22.5-14,22.5
  					C690.1,297.7,696.7,287.7,696.7,275.3z"/>
  			</g>
  			<path class="st1" d="M696.7,275.3c0-12.4,6.3-22.5,14-22.5c7.8,0,14,10.1,14,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_9_" gradientUnits="userSpaceOnUse" x1="763.3934" y1="-6428.0615" x2="763.3934" y2="-6472.9697" gradientTransform="matrix(1 0 0 -1 0 -6178.7051)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st9" d="M773.7,271.8c0-12.4-4.6-22.5-10.3-22.5c-5.7,0-10.3,10.1-10.3,22.5c0,12.4-5.1,22.5,10.3,22.5
  					C778.6,294.3,773.7,284.2,773.7,271.8z"/>
  			</g>
  			<path class="st10" d="M753.6,271.8c0,0,0-1.1,0.1-3.1c0.1-1.9,0.4-4.7,1.2-7.9c0.4-1.6,0.9-3.3,1.7-4.9c0.7-1.6,1.7-3.2,3-4.5
  				c1.3-1.2,2.9-2,4.6-1.7c1.6,0.2,3.2,1.4,4.4,3c1.2,1.6,2.2,3.5,2.9,5.5c0.7,2,1.2,4.1,1.6,6.1c0.3,2.1,0.5,4.1,0.6,6
  				c0,1.9,0.1,3.8,0.2,5.5c0.1,1.7,0.3,3.2,0.4,4.6c0.1,1.4,0.2,2.6,0.2,3.6c0,1,0,1.8,0,2.3c0,0.5,0,0.8,0,0.8s0-0.3,0-0.8
  				c0-0.5,0.1-1.3,0-2.3c0-1-0.1-2.2-0.1-3.6c-0.1-1.4-0.2-2.9-0.3-4.6c-0.1-1.7-0.1-3.5-0.1-5.5c0-1.9-0.2-4-0.5-6.1
  				c-0.3-2.1-0.8-4.2-1.5-6.3c-0.7-2.1-1.6-4.1-2.9-5.7c-1.2-1.7-2.9-3-4.7-3.3c-1.8-0.3-3.6,0.5-5,1.8c-1.4,1.3-2.4,3-3.3,4.7
  				c-0.8,1.7-1.4,3.4-1.8,5.1c-0.9,3.3-1.2,6.1-1.3,8.1c-0.1,1-0.1,1.8-0.1,2.3c0,0.5,0,0.8,0,0.8L753.6,271.8z"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="-2266.8621" y1="-6284.5088" x2="-2266.8621" y2="-6329.4189" gradientTransform="matrix(1 0 0 -1 2632.2126 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st11" d="M375.4,275.3c0-12.4-4.5-22.5-10-22.5c-5.5,0-10,10.1-10,22.5s-5,22.5,10,22.5
  					C380.1,297.7,375.4,287.7,375.4,275.3z"/>
  			</g>
  			<path class="st1" d="M375.4,275.3c0-12.4-4.5-22.5-10-22.5c-5.5,0-10,10.1-10,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_11_" gradientUnits="userSpaceOnUse" x1="-2299.7749" y1="-6284.5088" x2="-2299.7749" y2="-6329.4189" gradientTransform="matrix(1 0 0 -1 2632.2126 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st12" d="M341.3,275.3c0-12.4-4-22.5-8.9-22.5c-4.9,0-8.9,10.1-8.9,22.5s-4.4,22.5,8.9,22.5
  					C345.5,297.7,341.3,287.7,341.3,275.3z"/>
  			</g>
  			<path class="st1" d="M341.3,275.3c0-12.4-4-22.5-8.9-22.5c-4.9,0-8.9,10.1-8.9,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_12_" gradientUnits="userSpaceOnUse" x1="-2340.4556" y1="-6284.5078" x2="-2340.4556" y2="-6329.417" gradientTransform="matrix(1 0 0 -1 2632.2126 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st13" d="M303.3,275.3c0-12.4-5.2-22.5-11.5-22.5c-6.4,0-11.5,10.1-11.5,22.5c0,12.4-5.7,22.5,11.5,22.5
  					C308.8,297.7,303.3,287.7,303.3,275.3z"/>
  			</g>
  			<path class="st1" d="M303.3,275.3c0-12.4-5.2-22.5-11.5-22.5c-6.4,0-11.5,10.1-11.5,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_13_" gradientUnits="userSpaceOnUse" x1="-2379.3037" y1="-6284.5078" x2="-2379.3037" y2="-6329.417" gradientTransform="matrix(1 0 0 -1 2632.2126 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st14" d="M266.2,275.3c0-12.4-5.9-22.5-13.3-22.5c-7.3,0-13.3,10.1-13.3,22.5c0,12.4-6.6,22.5,13.3,22.5
  					C272.5,297.7,266.2,287.7,266.2,275.3z"/>
  			</g>
  			<path class="st1" d="M266.2,275.3c0-12.4-5.9-22.5-13.3-22.5c-7.3,0-13.3,10.1-13.3,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_14_" gradientUnits="userSpaceOnUse" x1="-2418.5857" y1="-6284.5068" x2="-2418.5857" y2="-6329.416" gradientTransform="matrix(1 0 0 -1 2632.2126 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st15" d="M228.4,275.3c0-12.4-6.6-22.5-14.8-22.5s-14.8,10.1-14.8,22.5c0,12.4-7.3,22.5,14.8,22.5
  					C235.4,297.7,228.4,287.7,228.4,275.3z"/>
  			</g>
  			<path class="st1" d="M228.4,275.3c0-12.4-6.6-22.5-14.8-22.5s-14.8,10.1-14.8,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_15_" gradientUnits="userSpaceOnUse" x1="-2481.9336" y1="-6284.5068" x2="-2481.9336" y2="-6329.416" gradientTransform="matrix(1 0 0 -1 2632.2126 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st16" d="M166.4,275.3c0-12.4-7.2-22.5-16.1-22.5c-8.9,0-16.1,10.1-16.1,22.5c0,12.4-8,22.5,16.1,22.5
  					C174.1,297.7,166.4,287.7,166.4,275.3z"/>
  			</g>
  			<path class="st1" d="M166.4,275.3c0-12.4-7.2-22.5-16.1-22.5c-8.9,0-16.1,10.1-16.1,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_16_" gradientUnits="userSpaceOnUse" x1="-2543.0364" y1="-6284.5068" x2="-2543.0364" y2="-6329.416" gradientTransform="matrix(1 0 0 -1 2632.2126 -6031.6719)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st17" d="M103.3,275.3c0-12.4-6.3-22.5-14-22.5c-7.8,0-14,10.1-14,22.5c0,12.4-7,22.5,14,22.5
  					C109.9,297.7,103.3,287.7,103.3,275.3z"/>
  			</g>
  			<path class="st1" d="M103.3,275.3c0-12.4-6.3-22.5-14-22.5c-7.8,0-14,10.1-14,22.5"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_17_" gradientUnits="userSpaceOnUse" x1="5309.1494" y1="-6428.0615" x2="5309.1494" y2="-6472.9697" gradientTransform="matrix(-1 0 0 -1 5345.7422 -6178.7051)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st18" d="M26.3,271.8c0-12.4,4.6-22.5,10.3-22.5c5.7,0,10.3,10.1,10.3,22.5c0,12.4,5.1,22.5-10.3,22.5
  					C21.4,294.3,26.3,284.2,26.3,271.8z"/>
  			</g>
  			<path class="st10" d="M46.3,271.8c0,0,0-1.1-0.1-3.1c-0.1-1.9-0.4-4.7-1.2-7.9c-0.4-1.6-0.9-3.3-1.7-4.9c-0.7-1.6-1.7-3.2-3-4.5
  				c-1.3-1.2-2.9-2-4.6-1.7c-1.6,0.2-3.2,1.4-4.4,3c-1.2,1.6-2.2,3.5-2.9,5.5c-0.7,2-1.2,4.1-1.6,6.1c-0.3,2.1-0.5,4.1-0.6,6
  				c0,1.9-0.1,3.8-0.2,5.5c-0.1,1.7-0.3,3.2-0.4,4.6c-0.1,1.4-0.2,2.6-0.2,3.6c0,1,0,1.8,0,2.3c0,0.5,0,0.8,0,0.8s0-0.3,0-0.8
  				c0-0.5-0.1-1.3,0-2.3c0-1,0.1-2.2,0.1-3.6c0.1-1.4,0.2-2.9,0.3-4.6c0.1-1.7,0.1-3.5,0.1-5.5c0-1.9,0.2-4,0.5-6.1
  				c0.3-2.1,0.8-4.2,1.5-6.3c0.7-2.1,1.6-4.1,2.9-5.7c1.2-1.7,2.9-3,4.7-3.3c1.8-0.3,3.6,0.5,5,1.8c1.4,1.3,2.4,3,3.3,4.7
  				c0.8,1.7,1.4,3.4,1.8,5.1c0.9,3.3,1.2,6.1,1.3,8.1c0.1,1,0.1,1.8,0.1,2.3c0,0.5,0,0.8,0,0.8L46.3,271.8z"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_18_" gradientUnits="userSpaceOnUse" x1="4945.7422" y1="126.9082" x2="4945.7422" y2="82.752" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st19" d="M389.4,104.8c0,12.2,4.7,22.1,10.5,22.1c5.8,0,10.5-9.9,10.5-22.1c0-12.2,5.2-22.1-10.5-22.1
  					C384.5,82.8,389.4,92.6,389.4,104.8z"/>
  			</g>
  			<path class="st1" d="M389.4,104.8c0,12.2,4.7,22.1,10.5,22.1c5.8,0,10.5-9.9,10.5-22.1"/>
  		</g>
  		<g>
  			<g>
  				<linearGradient id="SVGID_19_" gradientUnits="userSpaceOnUse" x1="452.8459" y1="126.9072" x2="452.8459" y2="82.751">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st21" d="M464.1,104.8c0,12.2-5,22.1-11.3,22.1c-6.2,0-11.3-9.9-11.3-22.1s-5.6-22.1,11.3-22.1
  					C469.5,82.8,464.1,92.6,464.1,104.8z"/>
  			</g>
  			<path class="st1" d="M464.1,104.8c0,12.2-5,22.1-11.3,22.1c-6.2,0-11.3-9.9-11.3-22.1"/>
  		</g>
  		<g>
  			<g>
  				<linearGradient id="SVGID_20_" gradientUnits="userSpaceOnUse" x1="492.2364" y1="126.9072" x2="492.2364" y2="82.751">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st22" d="M501.3,104.8c0,12.2-4,22.1-9,22.1c-5,0-9-9.9-9-22.1s-4.5-22.1,9-22.1C505.6,82.8,501.3,92.6,501.3,104.8
  					z"/>
  			</g>
  			<path class="st1" d="M501.3,104.8c0,12.2-4,22.1-9,22.1c-5,0-9-9.9-9-22.1"/>
  		</g>
  		<g>
  			<g>
  				<linearGradient id="SVGID_21_" gradientUnits="userSpaceOnUse" x1="536.1365" y1="126.9072" x2="536.1365" y2="82.751">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st23" d="M546.8,104.8c0,12.2-4.7,22.1-10.6,22.1c-5.8,0-10.6-9.9-10.6-22.1s-5.2-22.1,10.6-22.1
  					C551.8,82.8,546.8,92.6,546.8,104.8z"/>
  			</g>
  			<path class="st1" d="M546.8,104.8c0,12.2-4.7,22.1-10.6,22.1c-5.8,0-10.6-9.9-10.6-22.1"/>
  		</g>
  		<g>
  			<g>
  				<linearGradient id="SVGID_22_" gradientUnits="userSpaceOnUse" x1="576.6076" y1="126.9072" x2="576.6076" y2="82.751">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st24" d="M586.8,104.8c0,12.2-4.6,22.1-10.2,22.1c-5.6,0-10.2-9.9-10.2-22.1s-5.1-22.1,10.2-22.1
  					C591.7,82.8,586.8,92.6,586.8,104.8z"/>
  			</g>
  			<path class="st1" d="M586.8,104.8c0,12.2-4.6,22.1-10.2,22.1c-5.6,0-10.2-9.9-10.2-22.1"/>
  		</g>
  		<g>
  			<g>
  				<linearGradient id="SVGID_23_" gradientUnits="userSpaceOnUse" x1="613.9481" y1="126.9072" x2="613.9481" y2="82.751">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st25" d="M624.5,104.8c0,12.2-4.7,22.1-10.5,22.1c-5.8,0-10.5-9.9-10.5-22.1s-5.2-22.1,10.5-22.1
  					C629.5,82.8,624.5,92.6,624.5,104.8z"/>
  			</g>
  			<path class="st1" d="M624.5,104.8c0,12.2-4.7,22.1-10.5,22.1c-5.8,0-10.5-9.9-10.5-22.1"/>
  		</g>
  		<g>
  			<g>
  				<linearGradient id="SVGID_24_" gradientUnits="userSpaceOnUse" x1="665.7634" y1="126.9072" x2="665.7634" y2="82.751">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st26" d="M676.3,104.8c0,12.2-4.7,22.1-10.5,22.1c-5.8,0-10.5-9.9-10.5-22.1s-5.2-22.1,10.5-22.1
  					C681.3,82.8,676.3,92.6,676.3,104.8z"/>
  			</g>
  			<path class="st1" d="M676.3,104.8c0,12.2-4.7,22.1-10.5,22.1c-5.8,0-10.5-9.9-10.5-22.1"/>
  		</g>
  		<g>
  			<g>
  				<linearGradient id="SVGID_25_" gradientUnits="userSpaceOnUse" x1="713.2646" y1="126.9072" x2="713.2646" y2="82.751">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st27" d="M723.3,104.8c0,12.2-4.5,22.1-10,22.1c-5.5,0-10-9.9-10-22.1s-5-22.1,10-22.1
  					C728.1,82.8,723.3,92.6,723.3,104.8z"/>
  			</g>
  			<path class="st1" d="M723.3,104.8c0,12.2-4.5,22.1-10,22.1c-5.5,0-10-9.9-10-22.1"/>
  		</g>
  		<g>
  			<g>
  				<linearGradient id="SVGID_26_" gradientUnits="userSpaceOnUse" x1="763.5087" y1="126.9072" x2="763.5087" y2="82.751">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st28" d="M773.8,104.8c0,12.2-4.6,22.1-10.3,22.1c-5.7,0-10.3-9.9-10.3-22.1s-5.1-22.1,10.3-22.1
  					C778.7,82.8,773.8,92.6,773.8,104.8z"/>
  			</g>
  			<path class="st10" d="M753.8,104.8c0,0,0,1.1,0.1,3c0.1,1.9,0.4,4.6,1.2,7.8c0.4,1.6,0.9,3.2,1.7,4.8c0.7,1.6,1.7,3.2,3,4.4
  				c1.3,1.2,2.9,2,4.6,1.7c1.6-0.2,3.2-1.4,4.4-2.9c1.2-1.5,2.2-3.4,2.9-5.4c0.7-2,1.2-4,1.6-6c0.3-2,0.5-4,0.6-5.9
  				c0-1.9,0.1-3.7,0.2-5.4c0.1-1.7,0.3-3.2,0.4-4.5c0.1-1.3,0.2-2.5,0.2-3.5c0-1,0-1.7,0-2.3c0-0.5,0-0.8,0-0.8s0,0.3,0,0.8
  				c0,0.5,0.1,1.3,0,2.3c0,1-0.1,2.2-0.1,3.5c-0.1,1.3-0.2,2.9-0.3,4.5c-0.1,1.7-0.1,3.5-0.1,5.4c0,1.9-0.2,3.9-0.5,6
  				c-0.3,2.1-0.8,4.1-1.5,6.2c-0.7,2-1.6,4-2.9,5.6c-1.2,1.6-2.9,3-4.7,3.2c-1.8,0.3-3.6-0.5-5-1.7c-1.4-1.3-2.4-2.9-3.3-4.6
  				c-0.8-1.7-1.4-3.4-1.8-5c-0.9-3.2-1.2-6-1.3-8c-0.1-1-0.1-1.8-0.1-2.3c0-0.5,0-0.8,0-0.8L753.8,104.8z"/>
  		</g>
  		<path class="st29" d="M630.4,105.1c0,0-1.8,10.2-2.8,13.3c-1,3.1-5,9.6-7.1,11.6s-4.3,4.6-5,6.8c-0.7,2.3,6.8-19.4,7.5-23.8
  			C623.6,108.7,629.9,106.3,630.4,105.1z"/>
  		<g>
  			<g>

  					<linearGradient id="SVGID_27_" gradientUnits="userSpaceOnUse" x1="4998.603" y1="126.9072" x2="4998.603" y2="82.751" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st30" d="M335.8,104.8c0,12.2,5,22.1,11.3,22.1c6.2,0,11.3-9.9,11.3-22.1s5.6-22.1-11.3-22.1
  					C330.5,82.8,335.8,92.6,335.8,104.8z"/>
  			</g>
  			<path class="st1" d="M335.8,104.8c0,12.2,5,22.1,11.3,22.1c6.2,0,11.3-9.9,11.3-22.1"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_28_" gradientUnits="userSpaceOnUse" x1="5037.9922" y1="126.9072" x2="5037.9922" y2="82.751" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st31" d="M298.7,104.8c0,12.2,4,22.1,9,22.1c5,0,9-9.9,9-22.1s4.5-22.1-9-22.1C294.4,82.8,298.7,92.6,298.7,104.8z"
  					/>
  			</g>
  			<path class="st1" d="M298.7,104.8c0,12.2,4,22.1,9,22.1c5,0,9-9.9,9-22.1"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_29_" gradientUnits="userSpaceOnUse" x1="5081.8926" y1="126.9072" x2="5081.8926" y2="82.751" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st32" d="M253.2,104.8c0,12.2,4.7,22.1,10.6,22.1c5.8,0,10.6-9.9,10.6-22.1s5.2-22.1-10.6-22.1
  					C248.2,82.8,253.2,92.6,253.2,104.8z"/>
  			</g>
  			<path class="st1" d="M253.2,104.8c0,12.2,4.7,22.1,10.6,22.1c5.8,0,10.6-9.9,10.6-22.1"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_30_" gradientUnits="userSpaceOnUse" x1="5122.3633" y1="126.9072" x2="5122.3633" y2="82.751" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st33" d="M213.1,104.8c0,12.2,4.6,22.1,10.2,22.1c5.6,0,10.2-9.9,10.2-22.1s5.1-22.1-10.2-22.1
  					C208.3,82.8,213.1,92.6,213.1,104.8z"/>
  			</g>
  			<path class="st1" d="M213.1,104.8c0,12.2,4.6,22.1,10.2,22.1c5.6,0,10.2-9.9,10.2-22.1"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_31_" gradientUnits="userSpaceOnUse" x1="5159.7041" y1="126.9072" x2="5159.7041" y2="82.751" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st34" d="M175.5,104.8c0,12.2,4.7,22.1,10.5,22.1c5.8,0,10.5-9.9,10.5-22.1s5.2-22.1-10.5-22.1
  					C170.5,82.8,175.5,92.6,175.5,104.8z"/>
  			</g>
  			<path class="st1" d="M175.5,104.8c0,12.2,4.7,22.1,10.5,22.1c5.8,0,10.5-9.9,10.5-22.1"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_32_" gradientUnits="userSpaceOnUse" x1="5211.5205" y1="126.9072" x2="5211.5205" y2="82.751" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st35" d="M123.7,104.8c0,12.2,4.7,22.1,10.5,22.1c5.8,0,10.5-9.9,10.5-22.1s5.2-22.1-10.5-22.1
  					C118.7,82.8,123.7,92.6,123.7,104.8z"/>
  			</g>
  			<path class="st1" d="M123.7,104.8c0,12.2,4.7,22.1,10.5,22.1c5.8,0,10.5-9.9,10.5-22.1"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_33_" gradientUnits="userSpaceOnUse" x1="5259.0205" y1="126.9072" x2="5259.0205" y2="82.751" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st36" d="M76.6,104.8c0,12.2,4.5,22.1,10,22.1c5.5,0,10-9.9,10-22.1s5-22.1-10-22.1C71.9,82.8,76.6,92.6,76.6,104.8
  					z"/>
  			</g>
  			<path class="st1" d="M76.6,104.8c0,12.2,4.5,22.1,10,22.1c5.5,0,10-9.9,10-22.1"/>
  		</g>
  		<g>
  			<g>

  					<linearGradient id="SVGID_34_" gradientUnits="userSpaceOnUse" x1="5309.2646" y1="126.9072" x2="5309.2646" y2="82.751" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  					<stop  offset="0.6667" style="stop-color:#FACCDE"/>
  					<stop  offset="0.807" style="stop-color:#F8DCE7;stop-opacity:0.542"/>
  					<stop  offset="0.9731" style="stop-color:#F4F4F4;stop-opacity:0"/>
  				</linearGradient>
  				<path class="st37" d="M26.2,104.8c0,12.2,4.6,22.1,10.3,22.1c5.7,0,10.3-9.9,10.3-22.1s5.1-22.1-10.3-22.1
  					C21.3,82.8,26.2,92.6,26.2,104.8z"/>
  			</g>
  			<path class="st10" d="M46.2,104.8c0,0,0,1.1-0.1,3c-0.1,1.9-0.4,4.6-1.2,7.8c-0.4,1.6-0.9,3.2-1.7,4.8c-0.7,1.6-1.7,3.2-3,4.4
  				c-1.3,1.2-2.9,2-4.6,1.7c-1.6-0.2-3.2-1.4-4.4-2.9c-1.2-1.5-2.2-3.4-2.9-5.4c-0.7-2-1.2-4-1.6-6c-0.3-2-0.5-4-0.6-5.9
  				c0-1.9-0.1-3.7-0.2-5.4c-0.1-1.7-0.3-3.2-0.4-4.5c-0.1-1.3-0.2-2.5-0.2-3.5c0-1,0-1.7,0-2.3c0-0.5,0-0.8,0-0.8s0,0.3,0,0.8
  				c0,0.5-0.1,1.3,0,2.3c0,1,0.1,2.2,0.1,3.5c0.1,1.3,0.2,2.9,0.3,4.5c0.1,1.7,0.1,3.5,0.1,5.4c0,1.9,0.2,3.9,0.5,6
  				c0.3,2.1,0.8,4.1,1.5,6.2c0.7,2,1.6,4,2.9,5.6c1.2,1.6,2.9,3,4.7,3.2c1.8,0.3,3.6-0.5,5-1.7c1.4-1.3,2.4-2.9,3.3-4.6
  				c0.8-1.7,1.4-3.4,1.8-5c0.9-3.2,1.2-6,1.3-8c0.1-1,0.1-1.8,0.1-2.3c0-0.5,0-0.8,0-0.8L46.2,104.8z"/>
  		</g>
  		<path class="st29" d="M169.5,105.1c0,0,1.8,10.2,2.8,13.3c1,3.1,5,9.6,7.1,11.6s4.3,4.6,5,6.8c0.7,2.3-6.8-19.4-7.5-23.8
  			C176.4,108.7,170.1,106.3,169.5,105.1z"/>
  	</g>
  	<g id="gk4">

  			<linearGradient id="g48_1_" gradientUnits="userSpaceOnUse" x1="5284.3013" y1="333.1807" x2="5284.3013" y2="239.4248" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  			<stop  offset="0.3333" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4946" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g48" class="st38" d="M40.4,273.8c0-14.8-5.8-26-5.8-34.4c0,0,53.5,0,53.7,4.4c0.2,4.3-10.1,19.1-10.1,23.8
  			c0,3.5-0.9,15.4-0.9,15.4c0,22.6-12.4,50.2-15.9,50.2c-2.2,0-2.7-1.8-2.7-2.9c0-1.1,0-3.7,0-3.7c0-1.5-1.3-13.6-1.3-19.8
  			c0-6.2,2.2-30.7,0.6-30.7c-1.2,0-6.2,21-6.7,24.9c-0.5,3.9-5.5,13.5-5.5,21.6c0,2.7-1.5,6.9-3.9,6.9c-3,0-7.4-12.8-7.4-23
  			C34.6,299.5,40.4,286.3,40.4,273.8z"/>

  			<linearGradient id="g47_1_" gradientUnits="userSpaceOnUse" x1="5225.2954" y1="333.1807" x2="5225.2954" y2="239.4248" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  			<stop  offset="0.3441" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4047" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.5" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g47" class="st39" d="M99.4,273.8c0-14.8-5.8-26-5.8-34.4c0,0,53.5,0,53.7,4.4c0.2,4.3-10.1,19.1-10.1,23.8
  			c0,3.5-0.9,15.4-0.9,15.4c0,22.6-12.4,50.2-15.9,50.2c-2.2,0-2.7-1.8-2.7-2.9c0-1.1,0-3.7,0-3.7c0-1.5-1.3-13.6-1.3-19.8
  			c0-6.2,2.2-30.7,0.6-30.7c-1.2,0-6.2,21-6.7,24.9c-0.5,3.9-5.5,13.5-5.5,21.6c0,2.7-1.5,6.9-3.9,6.9c-3,0-7.4-12.8-7.4-23
  			C93.6,299.5,99.4,286.3,99.4,273.8z"/>

  			<linearGradient id="g46_1_" gradientUnits="userSpaceOnUse" x1="5164.0811" y1="336.5957" x2="5164.0811" y2="243.2022" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  			<stop  offset="0.3602" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4313" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.543" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g46" class="st40" d="M156.1,246.8c0,0,5.9,15.8,5.9,21.5c0,8.6-10.1,47.2-10.1,56.7c0,6.6,1.6,10.1,3.2,10.1
  			c1.6,0,5.4-5.8,5.4-8.8c0-1.5,6.3-9.9,12-28.4c2.8-9.2,8.1-10.7,9.2-10.7c2.3,0,4.8,7.2,4.8,15.6c0,8.4-2.8,26-3.2,27.4
  			c-0.4,1.5-0.7,2.7-0.7,3.3c0,0.7,0,2.9,2,2.9c4.4,0,19.6-23.6,19.6-39.1c0-19.4-1.4-17.1-1.4-25.8c0-7,8.8-20.1,8.8-28.5
  			L156.1,246.8z"/>

  			<linearGradient id="g45_1_" gradientUnits="userSpaceOnUse" x1="5112.0405" y1="341.2266" x2="5112.0405" y2="247.2334" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  			<stop  offset="0.4194" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4883" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.5968" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g45" class="st41" d="M220,248.3c1.2,8.8,2,21,1.5,31.6c-0.4,8.3-1.2,15.3-1.2,17.4c0,4.6,1.8,10.1,1.8,29.4
  			c0,4.8-1.8,8.1-1.8,10.7c0,2.1,0.1,3.9,1.8,3.9c3.8,0,8-8,10.6-13.5c1.6-3.5,11.8-19.5,11.8-34.1c0,0,0.5-29.3,0.5-30.8
  			c0-1.5,2.6-15.6,2.6-15.6L220,248.3z"/>

  			<linearGradient id="g44_1_" gradientUnits="userSpaceOnUse" x1="5072.4565" y1="337.1982" x2="5072.4565" y2="248.9463" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  			<stop  offset="0.3602" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4417" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.5699" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g44" class="st42" d="M287.6,248.9l-28.7,0.7c0,0,3.2,11.8,3.6,16.7c0.3,4.9-1.9,15.9-1.9,21.7c0,5.7,3.9,32.8,3.9,36.4
  			c0,3.6-0.7,4.7-0.7,7c0,2.3,0.7,5.7,2.1,5.7c5.5,0,18.9-35.5,18.9-72.1C284.9,254.7,287.6,248.9,287.6,248.9z"/>

  			<linearGradient id="g43_1_" gradientUnits="userSpaceOnUse" x1="5033.2939" y1="339.4541" x2="5033.2939" y2="250.6982" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  			<stop  offset="0.4194" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4883" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.5968" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g43" class="st43" d="M299,250.7c0,0,1.8,11.2,1.8,14.1s-1.3,14.2-1.3,19.2c0,13.1,5,36,5,40.2S303,336,303,337.4
  			c0,1.3,0.8,2.1,1.7,2.1c4.6,0,14.2-19.4,14.2-23.6c0-8.3,5.4-21.4,5.4-25.8c0-4.4,1.7-38.8,1.7-38.8L299,250.7z"/>

  			<linearGradient id="g42_1_" gradientUnits="userSpaceOnUse" x1="4995.6733" y1="339.4482" x2="4995.6733" y2="255.0381" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  			<stop  offset="0.4086" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4922" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.6237" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g42" class="st44" d="M339.9,255c0,0-1.2,49-1.5,51.4c-0.3,2.4,3.7,17.2,4.2,18.6c0.6,1.4,0,11.1,0,11.9
  			c0,0.9,1.5,2.4,2.8,2.4c4.7,0,16.4-26.3,16.4-84.3L339.9,255z"/>

  			<linearGradient id="g41_1_" gradientUnits="userSpaceOnUse" x1="4960.2124" y1="336.4502" x2="4960.2124" y2="252.3281" gradientTransform="matrix(-1 0 0 1 5345.7422 0)">
  			<stop  offset="0.3925" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4761" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.6075" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g41" class="st45" d="M373.8,252.4c0,57.5,8.3,84,21.2,84c1.9,0,2.3-0.8,2.3-2.1c0-0.7-3.4-5.4-3.4-14.2
  			c0-5.8,3.2-12.8,3.2-17.3c0-8-1.2-7.4-2.2-50.6L373.8,252.4z"/>
  	</g>
  	<g id="gk3">

  			<linearGradient id="g38_1_" gradientUnits="userSpaceOnUse" x1="5450.3228" y1="333.1807" x2="5450.3228" y2="239.4248" gradientTransform="matrix(1 0 0 1 -4711.7773 0)">
  			<stop  offset="0.3333" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4946" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g38" class="st46" d="M759.6,273.8c0-14.8,5.8-26,5.8-34.4c0,0-53.5,0-53.7,4.4c-0.2,4.3,10.1,19.1,10.1,23.8
  			c0,3.5,0.9,15.4,0.9,15.4c0,22.6,12.4,50.2,15.9,50.2c2.2,0,2.7-1.8,2.7-2.9c0-1.1,0-3.7,0-3.7c0-1.5,1.3-13.6,1.3-19.8
  			c0-6.2-2.2-30.7-0.6-30.7c1.2,0,6.2,21,6.7,24.9c0.5,3.9,5.5,13.5,5.5,21.6c0,2.7,1.5,6.9,3.9,6.9c3,0,7.4-12.8,7.4-23
  			C765.4,299.5,759.6,286.3,759.6,273.8z"/>

  			<linearGradient id="g37_1_" gradientUnits="userSpaceOnUse" x1="5391.3169" y1="333.1807" x2="5391.3169" y2="239.4248" gradientTransform="matrix(1 0 0 1 -4711.7773 0)">
  			<stop  offset="0.3441" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4047" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.5" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g37" class="st47" d="M706.4,306.5c0,10.2-4.4,23-7.4,23c-2.3,0-3.9-4.1-3.9-6.9c0-8.1-5-17.6-5.5-21.6
  			c-0.5-3.9-5.4-24.9-6.7-24.9c-1.6,0,0.6,24.5,0.6,30.7c0,6.2-1.3,18.3-1.3,19.8c0,0,0,2.6,0,3.7c0,1.1-0.5,2.9-2.7,2.9
  			c-3.5,0-15.9-27.6-15.9-50.2c0,0-0.9-11.9-0.9-15.4c0-4.6-10.3-19.4-10.1-23.8c0.2-4.3,53.7-4.4,53.7-4.4c0,8.4-5.8,19.6-5.8,34.4
  			C700.6,286.3,706.4,299.5,706.4,306.5z"/>

  			<linearGradient id="g36_1_" gradientUnits="userSpaceOnUse" x1="5330.1025" y1="336.5957" x2="5330.1025" y2="243.2022" gradientTransform="matrix(1 0 0 1 -4711.7773 0)">
  			<stop  offset="0.3602" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4313" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.543" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g36" class="st48" d="M588.5,243.2c0,8.4,8.8,21.5,8.8,28.5c0,8.7-1.4,6.3-1.4,25.8c0,15.4,15.2,39.1,19.6,39.1
  			c2,0,2-2.2,2-2.9c0-0.7-0.3-1.9-0.7-3.3c-0.4-1.5-3.2-19-3.2-27.4c0-8.4,2.5-15.6,4.8-15.6c1.1,0,6.3,1.5,9.2,10.7
  			c5.7,18.5,12,26.9,12,28.4c0,3,3.8,8.8,5.4,8.8c1.6,0,3.2-3.5,3.2-10.1c0-9.5-10.1-48.2-10.1-56.7c0-5.7,5.9-21.5,5.9-21.5
  			L588.5,243.2z"/>

  			<linearGradient id="g35_1_" gradientUnits="userSpaceOnUse" x1="5278.0615" y1="341.2266" x2="5278.0615" y2="247.2334" gradientTransform="matrix(1 0 0 1 -4711.7773 0)">
  			<stop  offset="0.4194" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4883" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.5968" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g35" class="st49" d="M552.5,247.2c0,0,2.6,14.1,2.6,15.6c0,1.5,0.5,30.8,0.5,30.8c0,14.6,10.1,30.6,11.8,34.1
  			c2.6,5.5,6.8,13.5,10.6,13.5c1.7,0,1.8-1.7,1.8-3.9c0-2.6-1.8-5.8-1.8-10.7c0-19.3,1.8-24.8,1.8-29.4c0-2.1-0.9-9-1.2-17.4
  			c-0.5-10.7,0.3-22.8,1.5-31.6L552.5,247.2z"/>

  			<linearGradient id="g34_1_" gradientUnits="userSpaceOnUse" x1="5238.4775" y1="337.1982" x2="5238.4775" y2="248.9463" gradientTransform="matrix(1 0 0 1 -4711.7773 0)">
  			<stop  offset="0.3602" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4417" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.5699" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g34" class="st50" d="M515.1,265.1c0,36.7,13.4,72.1,18.9,72.1c1.3,0,2.1-3.4,2.1-5.7c0-2.3-0.7-3.4-0.7-7
  			c0-3.6,3.9-30.7,3.9-36.4c0-5.7-2.3-16.8-1.9-21.7c0.3-4.9,3.6-16.7,3.6-16.7l-28.7-0.7C512.4,248.9,515.1,254.7,515.1,265.1z"/>

  			<linearGradient id="g33_1_" gradientUnits="userSpaceOnUse" x1="5199.3149" y1="339.4541" x2="5199.3149" y2="250.6982" gradientTransform="matrix(1 0 0 1 -4711.7773 0)">
  			<stop  offset="0.4194" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4883" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.5968" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g33" class="st51" d="M474.1,251.3c0,0,1.7,34.4,1.7,38.8c0,4.4,5.4,17.5,5.4,25.8c0,4.2,9.6,23.6,14.2,23.6
  			c0.8,0,1.7-0.8,1.7-2.1c0-1.3-1.5-9.1-1.5-13.2s5-27.1,5-40.2c0-4.9-1.3-16.3-1.3-19.2s1.8-14.1,1.8-14.1L474.1,251.3z"/>

  			<linearGradient id="g32_1_" gradientUnits="userSpaceOnUse" x1="5161.6948" y1="339.4482" x2="5161.6948" y2="255.0381" gradientTransform="matrix(1 0 0 1 -4711.7773 0)">
  			<stop  offset="0.4086" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4922" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.6237" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g32" class="st52" d="M438.2,255.1c0,58,11.7,84.3,16.4,84.3c1.3,0,2.8-1.6,2.8-2.4c0-0.9-0.6-10.5,0-11.9
  			c0.6-1.4,4.5-16.2,4.2-18.6c-0.3-2.4-1.5-51.4-1.5-51.4L438.2,255.1z"/>

  			<linearGradient id="g31_1_" gradientUnits="userSpaceOnUse" x1="5126.2339" y1="336.4502" x2="5126.2339" y2="252.3281" gradientTransform="matrix(1 0 0 1 -4711.7773 0)">
  			<stop  offset="0.3925" style="stop-color:#F4F4F4;stop-opacity:0"/>
  			<stop  offset="0.4761" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.6075" style="stop-color:#FACCDE"/>
  		</linearGradient>
  		<path id="g31" class="st53" d="M405.1,252.3c-1,43.2-2.2,42.6-2.2,50.6c0,4.5,3.2,11.5,3.2,17.3c0,8.7-3.4,13.5-3.4,14.2
  			c0,1.2,0.4,2.1,2.3,2.1c12.9,0,21.2-26.5,21.2-84L405.1,252.3z"/>
  	</g>
  	<g id="gk2">

  			<linearGradient id="g28_1_" gradientUnits="userSpaceOnUse" x1="5206.7998" y1="129.1572" x2="5206.7998" y2="21.8506" gradientTransform="matrix(1 0 0 1 -4469.8047 0)">
  			<stop  offset="0.3065" style="stop-color:#FACCDE"/>
  			<stop  offset="0.5054" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g28" class="st54" d="M740.7,22.2c1.4,0,12.2,3.2,12.2,33.1c0,9.9-0.6,32.4-0.6,39.8c0,4.8,4.7,27.3,4.7,31.2
  			c0,6.5-40.1,0-40.1,0s5.5-21.5,5.5-28.1c0-6.6-5.5-25-5.5-35.4c0-10.4,10.7-35,10.7-37.2c0-2.2,1.9-3.8,2.8-3.8
  			c0.9,0,3.9,2.5,3.9,8.7s-1.5,15-1.5,20.9c0,5.9,3.6,20.4,3.6,20.4s6.1-23,6.1-28.5c0-5.4-3.9-12.7-3.9-16.1
  			C738.6,23.9,739.1,22.2,740.7,22.2z"/>

  			<linearGradient id="g27_1_" gradientUnits="userSpaceOnUse" x1="5158.7939" y1="129.1572" x2="5158.7939" y2="21.8506" gradientTransform="matrix(1 0 0 1 -4469.8047 0)">
  			<stop  offset="0.2849" style="stop-color:#FACCDE"/>
  			<stop  offset="0.4263" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.5161" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g27" class="st55" d="M690.6,27.3c0,3.4,3.9,10.7,3.9,16.1c0,5.4-6.1,28.5-6.1,28.5s-3.6-14.5-3.6-20.4
  			c0-5.9,1.5-14.7,1.5-20.9s-2.9-8.7-3.9-8.7s-2.8,1.6-2.8,3.8c0,2.2-10.8,26.7-10.8,37.2c0,10.4,5.5,28.9,5.5,35.4
  			c0,6.5-5.5,28.1-5.5,28.1s40.1,6.5,40.1,0c0-4-4.7-26.4-4.7-31.2c0-7.4,0.6-29.9,0.6-39.8c0-29.9-10.9-33.1-12.2-33.1
  			C691.1,22.2,690.6,23.9,690.6,27.3z"/>

  			<linearGradient id="g26_1_" gradientUnits="userSpaceOnUse" x1="5109.3916" y1="116.9522" x2="5109.3916" y2="23.3106" gradientTransform="matrix(1 0 0 1 -4469.8047 0)">
  			<stop  offset="0.1989" style="stop-color:#FACCDE"/>
  			<stop  offset="0.3008" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.3656" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g26" class="st56" d="M622,110.2c0,5.3-0.3,6.8-0.3,6.8h35.6c-1.9-8.6,5-35.7,5-43c0-33.6-5.7-50.6-8-50.6
  			c-1.1,0-2.4,2.8-2.4,4c0,2.5,0.6,5.1,0.6,6.7c-0.4,31.5-8.7,47.7-12.2,47.7c-2.6,0-6.1-11.8-6.1-15.4c0-3.6,1.5-16.3,1.5-25.8
  			c0-3-2-17-5.1-17c-1.2,0-3.5,3-3.5,7.3c0,8.2-10.1,35.8-10.1,45.1C616.9,84.2,622,104.9,622,110.2z"/>

  			<linearGradient id="g25_1_" gradientUnits="userSpaceOnUse" x1="5064.1104" y1="130.0889" x2="5064.1104" y2="22.8428" gradientTransform="matrix(1 0 0 1 -4469.8047 0)">
  			<stop  offset="0.3172" style="stop-color:#FACCDE"/>
  			<stop  offset="0.4191" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.4839" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g25" class="st57" d="M580.8,90.1c0,12.9,0.4,40,0.4,40h26.6c0,0-5.1-59.4-5.3-62.6c-0.4-4.8-4.9-19.8-4.9-28
  			c0-6.6,0.5-8.6,0.5-10.7c0-1.8-1.8-6-4.4-6C584.7,22.8,580.8,63.6,580.8,90.1z"/>

  			<linearGradient id="g24_1_" gradientUnits="userSpaceOnUse" x1="5027.0698" y1="128.6455" x2="5027.0698" y2="23.5147" gradientTransform="matrix(1 0 0 1 -4469.8047 0)">
  			<stop  offset="0.3065" style="stop-color:#FACCDE"/>
  			<stop  offset="0.405" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.4677" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g24" class="st58" d="M562.8,21c1.4,0,1.9,1.6,1.9,3.3c0,6.2,4.6,24.7,4.6,43.7c0,7.6-0.3,52.2,0.3,55.6
  			c1,5.7-24.7,0-24.7,0s1.1-39.3,1.1-43.9C546,64,554.6,21,562.8,21z"/>

  			<linearGradient id="g23_1_" gradientUnits="userSpaceOnUse" x1="4984.7568" y1="108.9756" x2="4984.7568" y2="19.7744" gradientTransform="matrix(1 0 0 1 -4469.8047 0)">
  			<stop  offset="0.1344" style="stop-color:#FACCDE"/>
  			<stop  offset="0.2133" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.2634" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g23" class="st59" d="M506.9,56c-0.3,5.1-5.1,12.6-5.1,29.6c0,4.2,0,4.1,0.2,23.4h23.7c0,0,2.3-25.7,2.3-35.3
  			c0-9.6-4.9-35.9-4.9-38.7c0-2.8,2.1-12,2.1-13.2c0-1.1-0.9-2-2.1-2C515.9,19.8,507.4,45.8,506.9,56z"/>

  			<linearGradient id="g22_1_" gradientUnits="userSpaceOnUse" x1="4943.9219" y1="125.2822" x2="4943.9219" y2="19.9512" gradientTransform="matrix(1 0 0 1 -4469.8047 0)">
  			<stop  offset="0.2742" style="stop-color:#FACCDE"/>
  			<stop  offset="0.3761" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.4409" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g22" class="st60" d="M461,125.3h25c0.7-9.3,1.3-43.3,1.3-53.4c0-12.2-3.1-22.4-3.1-25.6c0-1.3,0-20.9,0-23.6
  			c0-2.7-2-2.8-2-2.8c-2,0-3.3,2.4-3.9,3.6c-0.6,1.2-1.3,1.5-2.2,3C460.9,53.3,461,125.3,461,125.3z"/>

  			<linearGradient id="g21_1_" gradientUnits="userSpaceOnUse" x1="4897.5776" y1="129.1885" x2="4897.5776" y2="19.4346" gradientTransform="matrix(1 0 0 1 -4469.8047 0)">
  			<stop  offset="0.3011" style="stop-color:#FACCDE"/>
  			<stop  offset="0.4227" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.5" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g21" class="st61" d="M447.3,129.2c0,0-3.9-25.3-4.1-29.3c-0.2-4,0.3-24.8,0.3-31.9c0-14.6-6.7-34.6-6.7-41.3
  			c0-2.9,0.8-3.2,0.8-5.5c0-1.2-1.4-1.8-2-1.8c-10.7,0-25.3,41.6-25.3,81.7c0,6.2-3.4,12.9-1.5,19.4L447.3,129.2z"/>
  	</g>
  	<g id="gk1">

  			<linearGradient id="g18_1_" gradientUnits="userSpaceOnUse" x1="4807.083" y1="129.1572" x2="4807.083" y2="21.8506" gradientTransform="matrix(-1 0 0 1 4870.0742 0)">
  			<stop  offset="0.3065" style="stop-color:#FACCDE"/>
  			<stop  offset="0.5054" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g18" class="st62" d="M59.3,22.2c-1.4,0-12.2,3.2-12.2,33.1c0,9.9,0.6,32.4,0.6,39.8c0,4.8-4.7,27.3-4.7,31.2
  			c0,6.5,40.1,0,40.1,0s-5.5-21.5-5.5-28.1c0-6.6,5.5-25,5.5-35.4c0-10.4-10.7-35-10.7-37.2c0-2.2-1.9-3.8-2.8-3.8
  			c-0.9,0-3.9,2.5-3.9,8.7s1.5,15,1.5,20.9c0,5.9-3.6,20.4-3.6,20.4s-6.1-23-6.1-28.5c0-5.4,3.9-12.7,3.9-16.1
  			C61.4,23.9,60.9,22.2,59.3,22.2z"/>

  			<linearGradient id="g17_1_" gradientUnits="userSpaceOnUse" x1="4759.0776" y1="129.1572" x2="4759.0776" y2="21.8506" gradientTransform="matrix(-1 0 0 1 4870.0742 0)">
  			<stop  offset="0.2849" style="stop-color:#FACCDE"/>
  			<stop  offset="0.4263" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.5161" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g17" class="st63" d="M107.3,22.2c-1.4,0-12.2,3.2-12.2,33.1c0,9.9,0.6,32.4,0.6,39.8c0,4.8-4.7,27.3-4.7,31.2
  			c0,6.5,40.1,0,40.1,0s-5.5-21.5-5.5-28.1c0-6.6,5.5-25,5.5-35.4c0-10.4-10.7-35-10.7-37.2c0-2.2-1.9-3.8-2.8-3.8s-3.9,2.5-3.9,8.7
  			s1.5,15,1.5,20.9c0,5.9-3.6,20.4-3.6,20.4s-6.1-23-6.1-28.5c0-5.4,3.9-12.7,3.9-16.1C109.4,23.9,108.9,22.2,107.3,22.2z"/>

  			<linearGradient id="g16_1_" gradientUnits="userSpaceOnUse" x1="4709.6748" y1="116.9522" x2="4709.6748" y2="23.3106" gradientTransform="matrix(-1 0 0 1 4870.0742 0)">
  			<stop  offset="0.1989" style="stop-color:#FACCDE"/>
  			<stop  offset="0.3008" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.3656" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g16" class="st64" d="M183.1,76c0-9.3-10.1-36.9-10.1-45.1c0-4.3-2.3-7.3-3.5-7.3c-3.1,0-5.1,14-5.1,17
  			c0,9.4,1.5,22.2,1.5,25.8c0,3.6-3.6,15.4-6.1,15.4c-3.6,0-11.8-16.3-12.2-47.7c0-1.7,0.6-4.2,0.6-6.7c0-1.2-1.3-4-2.4-4
  			c-2.3,0-8,17-8,50.6c0,7.3,7,34.4,5,43h35.6c0,0-0.3-1.5-0.3-6.8C178,104.9,183.1,84.2,183.1,76z"/>

  			<linearGradient id="g15_1_" gradientUnits="userSpaceOnUse" x1="4664.3936" y1="130.0889" x2="4664.3936" y2="22.8428" gradientTransform="matrix(-1 0 0 1 4870.0742 0)">
  			<stop  offset="0.3172" style="stop-color:#FACCDE"/>
  			<stop  offset="0.4191" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.4839" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g15" class="st65" d="M206.3,22.8c-2.6,0-4.4,4.2-4.4,6c0,2,0.5,4.1,0.5,10.7c0,8.1-4.5,23.1-4.9,28
  			c-0.3,3.2-5.3,62.6-5.3,62.6h26.6c0,0,0.4-27.1,0.4-40C219.2,63.6,215.3,22.8,206.3,22.8z"/>

  			<linearGradient id="g14_1_" gradientUnits="userSpaceOnUse" x1="4627.3535" y1="128.6455" x2="4627.3535" y2="23.5147" gradientTransform="matrix(-1 0 0 1 4870.0742 0)">
  			<stop  offset="0.3065" style="stop-color:#FACCDE"/>
  			<stop  offset="0.405" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.4677" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g14" class="st66" d="M254,79.7c0,4.6,1.1,43.9,1.1,43.9s-25.7,5.7-24.7,0c0.6-3.5,0.3-48,0.3-55.6
  			c0-19,4.6-37.4,4.6-43.7c0-1.7,0.5-3.3,1.9-3.3C245.4,21,254,64,254,79.7z"/>

  			<linearGradient id="g13_1_" gradientUnits="userSpaceOnUse" x1="4585.04" y1="108.9756" x2="4585.04" y2="19.7744" gradientTransform="matrix(-1 0 0 1 4870.0742 0)">
  			<stop  offset="0.1344" style="stop-color:#FACCDE"/>
  			<stop  offset="0.2133" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.2634" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g13" class="st67" d="M276.8,19.8c-1.3,0-2.1,0.9-2.1,2c0,1.2,2.1,10.4,2.1,13.2c0,2.8-4.9,29.1-4.9,38.7
  			c0,9.6,2.3,35.3,2.3,35.3H298c0.2-19.3,0.2-19.2,0.2-23.4c0-17.1-4.8-24.5-5.1-29.6C292.6,45.8,284.1,19.8,276.8,19.8z"/>

  			<linearGradient id="g12_1_" gradientUnits="userSpaceOnUse" x1="4544.2061" y1="125.2822" x2="4544.2061" y2="19.9512" gradientTransform="matrix(-1 0 0 1 4870.0742 0)">
  			<stop  offset="0.2742" style="stop-color:#FACCDE"/>
  			<stop  offset="0.3761" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.4409" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g12" class="st68" d="M324,26.6c-0.9-1.5-1.6-1.8-2.2-3c-0.7-1.2-1.9-3.6-3.9-3.6c0,0-2,0.2-2,2.8c0,2.7,0,22.3,0,23.6
  			c0,3.2-3.1,13.4-3.1,25.6c0,10,0.6,44.1,1.3,53.4h25C339,125.3,339.1,53.3,324,26.6z"/>

  			<linearGradient id="g11_1_" gradientUnits="userSpaceOnUse" x1="4497.8613" y1="129.1885" x2="4497.8613" y2="19.4346" gradientTransform="matrix(-1 0 0 1 4870.0742 0)">
  			<stop  offset="0.3011" style="stop-color:#FACCDE"/>
  			<stop  offset="0.4227" style="stop-color:#F6E8ED;stop-opacity:0.3887"/>
  			<stop  offset="0.5" style="stop-color:#F4F4F4;stop-opacity:0"/>
  		</linearGradient>
  		<path id="g11" class="st69" d="M391.2,120.5c2-6.5-1.5-13.2-1.5-19.4c0-40-14.7-81.7-25.3-81.7c-0.6,0-2,0.6-2,1.8
  			c0,2.3,0.8,2.6,0.8,5.5c0,6.6-6.7,26.7-6.7,41.3c0,7.1,0.6,27.9,0.3,31.9c-0.3,4-4.1,29.3-4.1,29.3L391.2,120.5z"/>
  	</g>
  </g>
  <g id="teeth">
  	<g id="k4">
  		<g id="t48">
  			<path class="st1" d="M40.4,273.8c0-14.8-5.8-26-5.8-34.4c0,0,53.5,0,53.7,4.4c0.2,4.3-10.1,19.1-10.1,23.8
  				c0,3.5-0.9,15.4-0.9,15.4c0,22.6-12.4,50.2-15.9,50.2c-2.2,0-2.7-1.8-2.7-2.9c0-1.1,0-3.7,0-3.7c0-1.5-1.3-13.6-1.3-19.8
  				c0-6.2,2.2-30.7,0.6-30.7c-1.2,0-6.2,21-6.7,24.9c-0.5,3.9-5.5,13.5-5.5,21.6c0,2.7-1.5,6.9-3.9,6.9c-3,0-7.4-12.8-7.4-23
  				C34.6,299.5,40.4,286.3,40.4,273.8z"/>
  			<path class="Shade_x0020_9" d="M58.9,278.8c0,0,0.3-7.5,0-8.8c0,0-2.4,7.3-2.6,8.8c-0.2,1.6,0.1,0,0.1,0S57.7,274.9,58.9,278.8z"
  				/>
  			<path class="st70" d="M59.2,268.4c0,0,2.6,6.3,2.6,26c0,7-2.2,22.1-2,24.3c0.2,2.2-1.2,11.5,0.2,13c0,0-0.7,1.2-1.4-7.9
  				c-0.7-9.1-1.1-13-1.1-17c0-4,2.6-30.1,0.1-30c0,0-5,18.9-6,23c-0.9,4.2-3.8,12.6-4,13.3c-0.2,0.7-1.8,9.8-1.8,11.2
  				c0,1.5-2.2,4.3-3.7,4.3c0,0,1.8-3.1,2.5-11.4c0.8-8.3,8.1-28.7,9.1-33.3C54.6,279.3,59.2,268.4,59.2,268.4z"/>
  			<path class="st70" d="M87,248.3c0,0-8.6,14.6-8.6,17.9c0,3.3-1.5,22.1-1.5,24.1c0,1.9-8.3,42.7-16.3,42.7c0,0,8.6-15,11.3-35.6
  				c2.7-20.6,1-32.9,6.3-47.9L87,248.3z"/>
  			<path class="st70" d="M35.2,243.1c0,0,5.2,21.9,5.2,32.6c0,10.7-5.7,23.4-5.7,30.8c0,7.4,4.4,19.8,4.4,19.8s-2-15.8,0-26.2
  				c2-10.4,5.2-14.4,5.2-30.1c0-15.7-3.6-26.8-3.6-26.8L35.2,243.1z"/>
  			<g>
  				<path class="st71" d="M91.4,236.6c0-8.4-4.9-11.4-7.2-13.1c-2.4-1.7-4.4-5.1-8.2-5.1c-4,0-15.3,7.1-15.5,7.1
  					c-0.8,0-8.8-6.1-14.4-6.1c-4.8,0-11.8,4.4-11.8,18c0,14.1,18.6,28.8,24.5,28.8C71.4,266.2,91.4,251,91.4,236.6z"/>
  				<path class="Shade_x0020_6" d="M62.8,224.2c0,0-1.3,6.3-1.3,10.8c0,4.5,2.5,8.2,2.5,8.2s-3-2.3-4.3-7.4c0,0-0.2,4.3-4.2,4.5
  					c0,0,5.2-7.1,3.8-15.3C59.2,224.9,59.3,226.1,62.8,224.2z"/>
  				<path class="st72" d="M62.4,224.7c0,0-1.9,5.4-2.3,9.3c0,0,0.3-6.1-0.3-8.5C59.7,225.5,61.6,225.3,62.4,224.7z"/>
  				<path class="Shade_x0020_6" d="M42.5,220.2c0,0-8.3,3.6-8.3,16.2c0,12.6,17.6,29.9,24.5,29.9c12.3,0,32.7-16.8,32.7-28.2
  					c0-11.4,0-2.7,0-2.7c-2.4,10.4-15.7,23.8-31.2,23.8C53,259.1,39,250.7,39,234C39,223.8,42.5,220.2,42.5,220.2z"/>
  				<path class="Highligh_x0020_6" d="M76.9,221.1c-1.9,0-10.8,3.5-10.8,11.5c0,8,3.6,15.7,6.8,15.7s16.2-5.9,16-13.4
  					c-0.2-7.4-3.2-6.9-4.8-7.7C82.6,226.5,80.9,221.1,76.9,221.1z"/>
  				<path class="st73" d="M64.6,251.9c0,0-8.1,5.1-13.4-1c-5.2-6.1,3.2-6,5.9-6.8C59.7,243.4,68.2,250.4,64.6,251.9z"/>
  				<path class="Highligh_x0020_6" d="M57.5,228.4c0,0-1.2,5.7-5.2,9.6c-4,3.9-7.3,2.1-8.4,0c-3.2-6.3-0.4-16.1,3.1-16.1
  					S58.5,225.2,57.5,228.4z"/>
  				<path class="Shade_x0020_6" d="M71.9,220.2c0,0-9.4,7.2-10.4,13.5c0,0-0.2-7.1-4.8-9.8c0,0,2.1,2.3,5.4,0.9
  					C65.4,223.2,71.9,220.2,71.9,220.2z"/>
  			</g>
  		</g>
  		<g id="t47">
  			<path class="st1" d="M99.4,273.8c0-14.8-5.8-26-5.8-34.4c0,0,53.5,0,53.7,4.4c0.2,4.3-10.1,19.1-10.1,23.8
  				c0,3.5-0.9,15.4-0.9,15.4c0,22.6-12.4,50.2-15.9,50.2c-2.2,0-2.7-1.8-2.7-2.9c0-1.1,0-3.7,0-3.7c0-1.5-1.3-13.6-1.3-19.8
  				c0-6.2,2.2-30.7,0.6-30.7c-1.2,0-6.2,21-6.7,24.9c-0.5,3.9-5.5,13.5-5.5,21.6c0,2.7-1.5,6.9-3.9,6.9c-3,0-7.4-12.8-7.4-23
  				C93.6,299.5,99.4,286.3,99.4,273.8z"/>
  			<path class="st70" d="M118.2,268.4c0,0,2.6,6.3,2.6,26c0,7-2.2,22.1-2,24.3c0.2,2.2-1.2,11.5,0.2,13c0,0-0.7,1.2-1.4-7.9
  				c-0.7-9.1-1.1-13-1.1-17c0-4,2.6-30.1,0.1-30c0,0-5,18.9-6,23c-0.9,4.2-3.8,12.6-4,13.3c-0.2,0.7-1.8,9.8-1.8,11.2
  				c0,1.5-2.2,4.3-3.7,4.3c0,0,1.8-3.1,2.5-11.4c0.8-8.3,8.1-28.7,9.1-33.3C113.6,279.3,118.2,268.4,118.2,268.4z"/>
  			<path class="Shade_x0020_7" d="M117.9,278.8c0,0,0.3-7.5,0-8.8c0,0-2.4,7.3-2.6,8.8c-0.2,1.6,0.1,0,0.1,0
  				S116.7,274.9,117.9,278.8z"/>
  			<path class="st70" d="M146,248.3c0,0-8.6,14.6-8.6,17.9c0,3.3-1.5,22.1-1.5,24.1c0,1.9-8.3,42.7-16.3,42.7c0,0,8.6-15,11.3-35.6
  				c2.7-20.6,1-32.9,6.3-47.9L146,248.3z"/>
  			<path class="st70" d="M94.2,243.1c0,0,5.2,21.9,5.2,32.6c0,10.7-5.7,23.4-5.7,30.8c0,7.4,4.4,19.8,4.4,19.8s-2-15.8,0-26.2
  				c2-10.4,5.2-14.4,5.2-30.1c0-15.7-3.6-26.8-3.6-26.8L94.2,243.1z"/>
  			<g>
  				<path class="st71" d="M150.4,236.6c0-8.4-4.9-11.4-7.2-13.1c-2.4-1.7-4.4-5.1-8.2-5.1c-4,0-15.3,7.1-15.5,7.1
  					c-0.8,0-8.8-6.1-14.4-6.1c-4.8,0-11.8,4.4-11.8,18c0,14.1,18.6,28.8,24.5,28.8C130.4,266.2,150.4,251,150.4,236.6z"/>
  				<path class="Shade_x0020_7" d="M121.8,224.2c0,0-1.3,6.3-1.3,10.8c0,4.5,2.5,8.2,2.5,8.2s-3-2.3-4.3-7.4c0,0-0.2,4.3-4.2,4.5
  					c0,0,5.2-7.1,3.8-15.3C118.2,224.9,118.3,226.1,121.8,224.2z"/>
  				<path class="st72" d="M121.4,224.7c0,0-1.9,5.4-2.3,9.3c0,0,0.3-6.1-0.3-8.5C118.8,225.5,120.6,225.3,121.4,224.7z"/>
  				<path class="Shade_x0020_7" d="M101.5,220.2c0,0-8.3,3.6-8.3,16.2c0,12.6,17.6,29.9,24.5,29.9c12.3,0,32.7-16.8,32.7-28.2
  					c0-11.4,0-2.7,0-2.7c-2.4,10.4-15.7,23.8-31.2,23.8c-7.2,0-21.2-8.5-21.2-25.1C98,223.8,101.5,220.2,101.5,220.2z"/>
  				<path class="Highligh_x0020_7" d="M135.9,221.1c-1.9,0-10.8,3.5-10.8,11.5c0,8,3.6,15.7,6.8,15.7s16.2-5.9,16-13.4
  					c-0.2-7.4-3.2-6.9-4.8-7.7C141.6,226.5,139.9,221.1,135.9,221.1z"/>
  				<path class="st73" d="M123.6,251.9c0,0-8.1,5.1-13.4-1c-5.2-6.1,3.2-6,5.9-6.8C118.8,243.4,127.2,250.4,123.6,251.9z"/>
  				<path class="Highligh_x0020_7" d="M116.5,228.4c0,0-1.2,5.7-5.2,9.6c-4,3.9-7.3,2.1-8.4,0c-3.2-6.3-0.4-16.1,3.1-16.1
  					S117.5,225.2,116.5,228.4z"/>
  				<path class="Shade_x0020_7" d="M130.9,219.8c0,0-9.4,7.6-10.4,13.9c0,0-0.2-7.1-4.8-9.8c0,0,2.4,2.3,5.6,0.9
  					C124.6,223.2,130.9,219.8,130.9,219.8z"/>
  			</g>
  		</g>
  		<g id="t46">
  			<path class="st1" d="M156.1,246.8c0,0,5.9,15.8,5.9,21.5c0,8.6-10.1,47.2-10.1,56.7c0,6.6,1.6,10.1,3.2,10.1
  				c1.6,0,5.4-5.8,5.4-8.8c0-1.5,6.3-9.9,12-28.4c2.8-9.2,8.1-10.7,9.2-10.7c2.3,0,4.8,7.2,4.8,15.6c0,8.4-2.8,26-3.2,27.4
  				c-0.4,1.5-0.7,2.7-0.7,3.3c0,0.7,0,2.9,2,2.9c4.4,0,19.6-23.6,19.6-39.1c0-19.4-1.4-17.1-1.4-25.8c0-7,8.8-20.1,8.8-28.5
  				L156.1,246.8z"/>
  			<path class="st70" d="M183.2,334c0,0,6.5-10.9,6.5-25.2c0-18.5-3.8-30-6.5-34.6c-2.7-4.7-6.8,6.8-7.8,9.6
  				c-1,2.8-9.3,26-11.9,30.5s-6.4,16.8-7.5,17.8c-1.1,1,0.8,2,1.3,1.2c0.6-0.8,2.6-5.6,3.1-7c0.5-1.4,7.3-15.1,8.6-18.6
  				c1.3-3.5,5.4-20.5,12.5-20.5c4.5,0,4.8,14.6,4.8,15.6C186.4,303.9,183.2,334,183.2,334z"/>
  			<path class="Shade_x0020_7" d="M185.3,292.7c0,0-2.1-10.8-9.9-1.1C175.4,291.6,183.2,265.3,185.3,292.7z"/>
  			<path class="st70" d="M167.2,257.6c0,0,1,8.5-3,23.7c-4,15.2-11.2,45.6-12.2,47.4c0,0-0.7-3.1,0-7.2c2.6-15.3,9.9-51.1,9.9-53
  				c0-2.4-5.2-20.8-5.2-20.8L167.2,257.6z"/>
  			<path class="st70" d="M197.2,261.7c0,0-2.3,11.7-1.1,14.7c1.2,2.9,7.4,17.6,4.5,30.4c-2.9,12.8-12.1,26.2-12.8,27.4
  				c0,0,16.2-20,16.2-34.9c0-14.9-1.2-23-1.2-29.1c0-6.1,9.8-22.5,9.8-28.7L197.2,261.7z"/>
  			<g>
  				<path class="st74" d="M174.8,221.5c-4.9,0-7.1,2.2-9.3,6.1c0,0-2.5-3.9-6.4-3.9c-3.4,0-6.3,4.4-6.3,10.6
  					c0,5.6,4.2,17.8,5.1,19.2c7.3,10.5,22,16.6,25.2,16.6c2,0,17-0.5,25-15.4c4.2-7.8,5.3-18.3,5.3-22.5c0-7.3-3.4-8.8-7.2-10.7
  					c-3.8-1.9-4.5-3.1-6.8-3.1c-2.4,0-8.8,2.7-10.5,3.4c-1.7,0.8-3.8,3-3.5,3.9C184.7,223.3,178.9,221.5,174.8,221.5z"/>
  				<path class="Shade_x0020_7" d="M190.5,221.1c0,0-2.4,11.3-1.7,15.6c0.6,4.2,1.6,7.5,1.6,7.5s-4-6.7-4.6-9.8c0,0,0.2,3.5-1.9,5.1
  					c0,0,1.4-12.6-2.8-16.8c0,0,4.4,2,4.3,3.1C185.3,226.8,186.1,222.8,190.5,221.1z"/>
  				<path class="st75" d="M188.9,221.9c0,0-2.2,6.1-2.9,10.7c0,0,0.1-5.2-2.4-8.7c0,0,1.8,0.6,2.3,1
  					C186.3,225.3,186.3,222.4,188.9,221.9z"/>
  				<path class="st72" d="M167.2,225c0,0-3.3,4.7-1.8,10c0,0,0.3,0.9-0.4,0c-0.7-0.9-0.4-8.7-2.7-10.4c-2.3-1.7,0.2,0,0.2,0
  					s2.5,2.6,2.9,2.7C165.6,227.4,166.2,225.6,167.2,225z"/>
  				<path class="Shade_x0020_7" d="M157.3,224.1c0,0-2.7,15.1,3.2,22.7c5.8,7.6,16,13.5,20.5,8.6c7.9-8.6,2.8,1.5,12.6,1.5
  					c6.3,0,13.5-0.2,18-11.8c0,0-6.4,24.9-28.5,24.9c-9.7,0-24.1-14.1-25.2-16.6c-1.1-2.5-5.1-13.1-5.1-20.9
  					C152.8,227.3,157.3,224.1,157.3,224.1z"/>
  				<path class="Highligh_x0020_7" d="M200.2,221.1c0,0,2.7,4.2,3.5,4.4c0.8,0.2,3.2-0.2,5.3,2.7c2.2,2.9-0.2,15.5-3.5,19.2
  					c0,0-5.5,2.2-9.1,2.2s-4.8-16.6-3.9-23.1C193.5,220,198,219.5,200.2,221.1z"/>
  				<path class="Highligh_x0020_7" d="M175.3,224.1c0,0-6.8,1.4-6.8,5.4c0,4.1,0.7,22.3,5.7,22.3s8.1-9.7,8.1-17.4
  					C182.3,226.8,180,224.1,175.3,224.1z"/>
  				<path class="st76" d="M162.2,227.3c0,0-1.3-2.2-3-2c-1.7,0.2-1.3,6.5-0.8,7.3c0.5,0.8,3,2.6,3.8,1.9
  					C163,233.8,163.5,228.7,162.2,227.3z"/>
  				<path class="Shade_x0020_7" d="M198.8,264.9c0,0-8.9,5.2-15.7,5.2c-5.8,0-15.9-6.6-20.2-11C163,259,186.8,269.7,198.8,264.9z"/>
  			</g>
  		</g>
  		<g id="t45">
  			<path class="st1" d="M220,248.3c1.2,8.8,2,21,1.5,31.6c-0.4,8.3-1.2,15.3-1.2,17.4c0,4.6,1.8,10.1,1.8,29.4
  				c0,4.8-1.8,8.1-1.8,10.7c0,2.1,0.1,3.9,1.8,3.9c3.8,0,8-8,10.6-13.5c1.6-3.5,11.8-19.5,11.8-34.1c0,0,0.5-29.3,0.5-30.8
  				c0-1.5,2.6-15.6,2.6-15.6L220,248.3z"/>
  			<path class="st70" d="M230,255.6c0,0-3.2,23.7-2.8,32s-2.9,41.9-6.2,48.8c0,0,0.9-4.9,0.9-7.9s-1.7-26.4-1.7-31.3
  				c0-4.9,1.4-17.4,1.4-22.9c0-5.5-1.4-27.6-1.4-27.6L230,255.6z"/>
  			<path class="st70" d="M246.6,251.9c0,0-1.8,8.8-1.8,11.7c0,2.9-0.6,33.1-0.6,33.1c0,7.9-15.2,44.5-21.7,44.5
  				c0,0,18.5-28.4,18.5-43.8c0-15.4-1.8-34.2-0.6-44.1L246.6,251.9z"/>
  			<g>
  				<path class="st71" d="M232.9,218.4c-3.4,0-5.1,0.7-9.5,3.8c-2.5,1.8-6.6,2.3-7.5,5.5c-0.6,2.4-0.6,4.1-0.6,5.8
  					c0,2.8,6.6,34.8,17.6,34.8c10.3,0,20-27.7,20-37.4c0-7.2-2.9-7.2-8.1-9.2C242.7,220.9,238,218.4,232.9,218.4z"/>
  				<path class="Shade_x0020_7" d="M232.5,220.4c0,0-1.5,0-3.3,2.9c-1.9,2.9-11.1,2-10.2,12.1c0.4,4.8,6.3,26.2,13.5,26.2
  					c7.2,0,15.7-12.1,20.2-27.5c0,0-8.4,34.2-19.7,34.2c-11.4,0-17.6-32.2-17.6-37.2c0-4.9,3.3-6.3,6-7.8
  					C224,221.8,234.8,215.6,232.5,220.4z"/>
  				<path class="Highligh_x0020_7" d="M247.2,228.4c0,0,0.4,10.9-4.4,15.4c-4.8,4.5-13.8,3.3-14.8,0.5c-1-2.8,3.8-12.1,4.4-14.5
  					c0.6-2.3,2.4-6.8,2.2-8.4c-0.1-1.6,2.2-2.2,5.2,0C243,223.6,247.5,224,247.2,228.4z"/>
  			</g>
  		</g>
  		<g id="t44">
  			<path class="st1" d="M287.6,248.9l-28.7,0.7c0,0,3.2,11.8,3.6,16.7c0.3,4.9-1.9,15.9-1.9,21.7c0,5.7,3.9,32.8,3.9,36.4
  				c0,3.6-0.7,4.7-0.7,7c0,2.3,0.7,5.7,2.1,5.7c5.5,0,18.9-35.5,18.9-72.1C284.9,254.7,287.6,248.9,287.6,248.9z"/>
  			<path class="st70" d="M269.7,264.5c0,0-3.3,17.6-2.8,24c0.5,6.4,1.8,26.9,1.4,30.9c-0.4,4-1.2,17-2.4,17c-0.7,0-2.3-2-1.9-6
  				c1.6-13.6-3.3-33.2-3.3-42.4c0-5.7,1.9-15.7,1.9-19.7s-3.2-21.5-3.2-21.5L269.7,264.5z"/>
  			<path class="st70" d="M284.9,254.2c-0.3,17.4-1.3,58.1-14.8,78.8c0,0,18.5-55.6,11.6-78.8H284.9z"/>
  			<g>
  				<path class="st71" d="M274.1,218.4c-3.2,0-4.1,0.6-5.6,2.1c-1.7,1.7-3.6,3.9-6.2,4.9c-2.3,0.9-6.5,6.8-6.5,11.2
  					c0,5.5,5.9,33.3,17,33.3c7.1,0,20.1-24.4,20.1-34.5c0-6.5-5.9-8.3-10.9-12.5C280.5,221.6,277.8,218.4,274.1,218.4z"/>
  				<path class="Shade_x0020_7" d="M272.3,218.7c0,0-0.9,4.5-3.4,7.2c-2.5,2.8-6.9,8.4-7.6,11.5c-0.8,3.1,4.5,23.7,10.8,23.7
  					s15.9-10.1,19.9-19.8c0,0-10.6,28.6-19.1,28.6c-8.5,0-17-23-17-33.3c0-5.5,3.2-9.9,6.5-11.2C266,224,268.2,219.1,272.3,218.7z"
  					/>
  				<path class="Highligh_x0020_7" d="M280.9,225.2c0,0,4.4,3.4,4.9,9.8c0.5,6.4-5.3,18.8-11.9,20.4c-6.6,1.6-8.5-7.1-8-12.9
  					c0.5-5.8,5-8.2,6.4-10.3C275.1,227.8,274.8,219.4,280.9,225.2z"/>
  			</g>
  		</g>
  		<g id="t43">
  			<path class="st1" d="M299,250.7c0,0,1.8,11.2,1.8,14.1s-1.3,14.2-1.3,19.2c0,13.1,5,36,5,40.2S303,336,303,337.4
  				c0,1.3,0.8,2.1,1.7,2.1c4.6,0,14.2-19.4,14.2-23.6c0-8.3,5.4-21.4,5.4-25.8c0-4.4,1.7-38.8,1.7-38.8L299,250.7z"/>
  			<path class="st70" d="M309.8,274.5c0,0-2.5,16.3-1.8,22.8c0.7,6.5,1,25.8-0.8,30.9c-1.8,5.1-3.1,11.6-3.6,10.8
  				c-0.5-0.8,0.8-11.3,0.8-14.9c0-3.6-5-30.8-5-40.2c0-9.4,2.7-29.7,2.7-29.7L309.8,274.5z"/>
  			<path class="st70" d="M325,264.5l-0.8,25.5c0,0-5.4,20.1-5.4,24.3c0,4.1-8.3,19.8-9,20.7c0,0,5.4-14.3,6.7-20.7
  				c1.2-6.4,6-44.7,4.9-48.8L325,264.5z"/>
  			<g>
  				<path class="st71" d="M314.5,216.7c-3.1,0-7.8,2.6-11.6,9.2c0,0-8.1,5.9-8.1,10.5c0,7.7,5.4,20.9,6,24.3c1,5.8,5.3,27,13.7,27
  					c10.3,0,18.8-45.6,18.8-57.5c0-4.8-7.3-7-7.3-7S318,216.7,314.5,216.7z"/>
  				<path class="Shade_x0020_7" d="M313,216.9c0,0-6.5,3.2-10.2,9c-1.4,2.3-2.1,2-2.1,2s-6,4-6,8.5c0,4.5,5.8,23.1,6,24.3
  					c0.2,1.2,5.4,27,13.7,27c8.3,0,17-41.3,17-41.3s-10.2,33.3-16.5,33.3c-6.3,0-14.2-33.1-14.2-42.3
  					C300.7,228.2,309,233.1,313,216.9z"/>
  				<path class="Highligh_x0020_7" d="M316.6,220.3c0,0,5.1,4.1,7.3,6.6c2.2,2.5,5.9,8.7,3.7,17c-2.2,8.3-8,21.7-11,22.2
  					c-3,0.5-3.8-21.9-3.6-29.3C313.1,236.7,311,216.5,316.6,220.3z"/>
  				<path class="st29" d="M331.1,226.4c0,0-2.9-2.1-5.1-3.2c-2-1-5.4-2.6-4.2,0.6C322.9,227,332.4,233.2,331.1,226.4z"/>
  			</g>
  		</g>
  		<g id="t42">
  			<path class="st1" d="M339.9,255c0,0-1.2,49-1.5,51.4c-0.3,2.4,3.7,17.2,4.2,18.6c0.6,1.4,0,11.1,0,11.9c0,0.9,1.5,2.4,2.8,2.4
  				c4.7,0,16.4-26.3,16.4-84.3L339.9,255z"/>
  			<path class="st70" d="M361.8,260.3c0,0-0.3,57.3-14,77.5c0,0,14-40.1,11.4-76L361.8,260.3z"/>
  			<path class="st70" d="M339.7,259c0,0-0.2,40.9-1.3,47.5c-0.5,3,3.3,15.5,4.2,18.6c0.9,3.1,0,11.4,0,11.4c3-2.7,6-33.4,6.4-39.1
  				c0.3-5.7,0.5-26.3,0.5-26.3"/>
  			<g>
  				<path class="st71" d="M361.1,221.4h-19.3c-2.8-0.1-6,0.2-6.5,6.2c-0.5,6.4,3.2,47.3,14.5,47.3c10.5,0,16.9-33.3,16.9-38.1
  					c0-2.2,0-10.4,0-10.4C366.6,224.2,365.6,221.4,361.1,221.4z"/>
  				<path class="Shade_x0020_7" d="M340.6,221.4c0,0-5.4-1.3-5.4,8.7c0,10,4.9,44.8,14.6,44.8c4.9,0,9.3-9.3,9.3-9.3
  					s-4.5,4.2-9.4,4.2s-10.5-22.8-10.5-39C339.2,225,339.1,225.6,340.6,221.4z"/>
  				<path class="Shade_x0020_7" d="M362,221.3c0,0,4.6,0,4.6,6.3c0,6.3-0.2,12.3-1,16.2C365.6,243.8,367.1,228.8,362,221.3z"/>
  				<path class="Highligh_x0020_7" d="M357.9,222.3h-14.7c0,0,0.1,11.9,1.4,19.1c1.2,7.2,3.7,12.3,8.9,12.3
  					C359,253.6,366.7,222.3,357.9,222.3z"/>
  				<path class="st77" d="M355.6,221.4l1.2,0.2l1.7-0.2c0,0-0.8,6.1-1.4,6.1C356.5,227.5,356.7,221.4,355.6,221.4z"/>
  				<path class="st77" d="M346.3,221.4l-1.4,0.2l-1.9-0.2c0,0,0.9,6.1,1.6,6.1C345.3,227.5,345.1,221.4,346.3,221.4z"/>
  			</g>
  		</g>
  		<g id="t41">
  			<path class="st1" d="M373.8,252.4c0,57.5,8.3,84,21.2,84c1.9,0,2.3-0.8,2.3-2.1c0-0.7-3.4-5.4-3.4-14.2c0-5.8,3.2-12.8,3.2-17.3
  				c0-8-1.2-7.4-2.2-50.6L373.8,252.4z"/>
  			<g>
  				<path class="st70" d="M385.5,262.2c0,0,5.4,27.6,4.6,38.8c-2,28.5,3.2,35.5,4.9,35.5c3.7,0,2.3-2.1,2.3-2.1s-3.4-5.9-3.4-13.3
  					c0-7.4,3.2-16,3.2-18.2c0-2.2-2.1-44.7-2.1-44.7L385.5,262.2z"/>
  				<path class="st70" d="M374.3,261.8c0,0-1,51.3,9.8,66.5c0,0-8.1-47.9-5.9-66.5H374.3z"/>
  			</g>
  			<g>
  				<path class="st71" d="M397.2,224.7c0-1.3-0.9-3.1-3.4-3.1c-2.2,0-17.2,0-17.6,0c-2.1,0-7.4,1.6-7.4,3.1
  					c0,24.1,8.2,55.8,15.2,55.8c8.3,0,13.2-30.7,13.2-37.5C397.2,236.3,397.2,224.7,397.2,224.7z"/>
  				<path class="Shade_x0020_7" d="M397.2,228.4c0,31.4-5.8,52.1-13.2,52.1c-3.9,0-7.7-10.4-8.8-14c-1.1-3.6,3.2,7.9,9.5,7.9
  					c8.9,0,12.4-55.1,12.4-50.6C397.1,225.7,397.2,228.4,397.2,228.4z"/>
  				<path class="Highligh_x0020_7" d="M392.9,225c0,0-3,10.6-4.2,15.6c-1.8,7.8-1.2,18.7-7.4,18.7c-5.5,0-8.5-34.7-3.9-35.7
  					C382.1,222.6,392.9,221.4,392.9,225z"/>
  				<path class="st77" d="M386.5,221.7l1.2,0.3l1.7-0.3c0,0-0.8,8.7-1.4,8.7C387.4,230.4,387.6,221.8,386.5,221.7z"/>
  				<path class="st77" d="M379,221.7l-1.3,0.3l-1.8-0.3c0,0,0.8,10,1.5,10C378,231.7,377.8,221.8,379,221.7z"/>
  			</g>
  		</g>
  	</g>
  	<g id="k3">
  		<g id="t38">
  			<path class="st1" d="M759.6,273.8c0-14.8,5.8-26,5.8-34.4c0,0-53.5,0-53.7,4.4c-0.2,4.3,10.1,19.1,10.1,23.8
  				c0,3.5,0.9,15.4,0.9,15.4c0,22.6,12.4,50.2,15.9,50.2c2.2,0,2.7-1.8,2.7-2.9c0-1.1,0-3.7,0-3.7c0-1.5,1.3-13.6,1.3-19.8
  				c0-6.2-2.2-30.7-0.6-30.7c1.2,0,6.2,21,6.7,24.9c0.5,3.9,5.5,13.5,5.5,21.6c0,2.7,1.5,6.9,3.9,6.9c3,0,7.4-12.8,7.4-23
  				C765.4,299.5,759.6,286.3,759.6,273.8z"/>
  			<path class="Shade_x0020_9" d="M741.1,278.8c0,0-0.3-7.5,0-8.8c0,0,2.4,7.3,2.6,8.8c0.2,1.6-0.1,0-0.1,0S742.3,274.9,741.1,278.8
  				z"/>
  			<path class="st70" d="M740.8,268.4c0,0-2.6,6.3-2.6,26c0,7,2.2,22.1,2,24.3c-0.2,2.2,1.2,11.5-0.2,13c0,0,0.7,1.2,1.4-7.9
  				c0.7-9.1,1.1-13,1.1-17c0-4-2.6-30.1-0.1-30c0,0,5,18.9,6,23c0.9,4.2,3.8,12.6,4,13.3c0.2,0.7,1.8,9.8,1.8,11.2
  				c0,1.5,2.2,4.3,3.7,4.3c0,0-1.8-3.1-2.5-11.4c-0.8-8.3-8.1-28.7-9.1-33.3C745.4,279.3,740.8,268.4,740.8,268.4z"/>
  			<path class="st70" d="M713,248.3c0,0,8.6,14.6,8.6,17.9c0,3.3,1.5,22.1,1.5,24.1c0,1.9,8.3,42.7,16.3,42.7c0,0-8.6-15-11.3-35.6
  				c-2.7-20.6-1-32.9-6.3-47.9L713,248.3z"/>
  			<path class="st70" d="M764.8,243.1c0,0-5.2,21.9-5.2,32.6c0,10.7,5.7,23.4,5.7,30.8c0,7.4-4.4,19.8-4.4,19.8s2-15.8,0-26.2
  				c-2-10.4-5.2-14.4-5.2-30.1c0-15.7,3.6-26.8,3.6-26.8L764.8,243.1z"/>
  			<g>
  				<path class="st71" d="M708.6,236.6c0-8.4,4.9-11.4,7.2-13.1c2.4-1.7,4.4-5.1,8.2-5.1c4,0,15.3,7.1,15.5,7.1
  					c0.8,0,8.8-6.1,14.4-6.1c4.8,0,11.8,4.4,11.8,18c0,14.1-18.6,28.8-24.5,28.8C728.6,266.2,708.6,251,708.6,236.6z"/>
  				<path class="Shade_x0020_6" d="M737.2,224.2c0,0,1.3,6.3,1.3,10.8c0,4.5-2.5,8.2-2.5,8.2s3-2.3,4.3-7.4c0,0,0.2,4.3,4.2,4.5
  					c0,0-5.2-7.1-3.8-15.3C740.7,224.9,740.7,226.1,737.2,224.2z"/>
  				<path class="st72" d="M737.6,224.7c0,0,1.9,5.4,2.3,9.3c0,0-0.3-6.1,0.3-8.5C740.2,225.5,738.4,225.3,737.6,224.7z"/>
  				<path class="Shade_x0020_6" d="M757.5,220.2c0,0,8.3,3.6,8.3,16.2c0,12.6-17.6,29.9-24.5,29.9c-12.3,0-32.7-16.8-32.7-28.2
  					c0-11.4,0-2.7,0-2.7c2.4,10.4,15.7,23.8,31.2,23.8c7.2,0,21.2-8.5,21.2-25.1C761,223.8,757.5,220.2,757.5,220.2z"/>
  				<path class="Highligh_x0020_6" d="M723.1,221.1c1.9,0,10.8,3.5,10.8,11.5c0,8-3.6,15.7-6.8,15.7s-16.2-5.9-16-13.4
  					c0.2-7.4,3.2-6.9,4.8-7.7C717.4,226.5,719.1,221.1,723.1,221.1z"/>
  				<path class="st73" d="M735.4,251.9c0,0,8.1,5.1,13.4-1c5.2-6.1-3.2-6-5.9-6.8C740.2,243.4,731.8,250.4,735.4,251.9z"/>
  				<path class="Highligh_x0020_6" d="M742.5,228.4c0,0,1.2,5.7,5.2,9.6c4,3.9,7.3,2.1,8.4,0c3.2-6.3,0.4-16.1-3.1-16.1
  					S741.5,225.2,742.5,228.4z"/>
  				<path class="Shade_x0020_6" d="M728.1,220.2c0,0,9.4,7.2,10.4,13.5c0,0,0.2-7.1,4.8-9.8c0,0-2.1,2.3-5.4,0.9
  					C734.6,223.2,728.1,220.2,728.1,220.2z"/>
  			</g>
  		</g>
  		<g id="t37">
  			<path class="st1" d="M706.4,306.5c0,10.2-4.4,23-7.4,23c-2.3,0-3.9-4.1-3.9-6.9c0-8.1-5-17.6-5.5-21.6
  				c-0.5-3.9-5.4-24.9-6.7-24.9c-1.6,0,0.6,24.5,0.6,30.7c0,6.2-1.3,18.3-1.3,19.8c0,0,0,2.6,0,3.7c0,1.1-0.5,2.9-2.7,2.9
  				c-3.5,0-15.9-27.6-15.9-50.2c0,0-0.9-11.9-0.9-15.4c0-4.6-10.3-19.4-10.1-23.8c0.2-4.3,53.7-4.4,53.7-4.4
  				c0,8.4-5.8,19.6-5.8,34.4C700.6,286.3,706.4,299.5,706.4,306.5z"/>
  			<path class="st70" d="M681.8,268.4c0,0-2.6,6.3-2.6,26c0,7,2.2,22.1,2,24.3c-0.2,2.2,1.2,11.5-0.2,13c0,0,0.7,1.2,1.4-7.9
  				c0.7-9.1,1.1-13,1.1-17c0-4-2.6-30.1-0.1-30c0,0,5,18.9,6,23c0.9,4.2,3.8,12.6,4,13.3c0.2,0.7,1.8,9.8,1.8,11.2
  				c0,1.5,2.2,4.3,3.7,4.3c0,0-1.8-3.1-2.5-11.4c-0.8-8.3-8.1-28.7-9.1-33.3C686.4,279.3,681.8,268.4,681.8,268.4z"/>
  			<path class="Shade_x0020_7" d="M682.1,278.8c0,0-0.3-7.5,0-8.8c0,0,2.4,7.3,2.6,8.8c0.2,1.6-0.1,0-0.1,0S683.2,274.9,682.1,278.8
  				z"/>
  			<path class="st70" d="M654,248.3c0,0,8.6,14.6,8.6,17.9c0,3.3,1.5,22.1,1.5,24.1c0,1.9,8.3,42.7,16.3,42.7c0,0-8.6-15-11.3-35.6
  				c-2.7-20.6-1-32.9-6.3-47.9L654,248.3z"/>
  			<path class="st70" d="M705.8,243.1c0,0-5.2,21.9-5.2,32.6c0,10.7,5.7,23.4,5.7,30.8c0,7.4-4.4,19.8-4.4,19.8s2-15.8,0-26.2
  				c-2-10.4-5.2-14.4-5.2-30.1c0-15.7,3.6-26.8,3.6-26.8L705.8,243.1z"/>
  			<g>
  				<path class="st71" d="M649.6,236.6c0-8.4,4.9-11.4,7.2-13.1c2.4-1.7,4.4-5.1,8.2-5.1c4,0,15.3,7.1,15.5,7.1
  					c0.8,0,8.8-6.1,14.4-6.1c4.8,0,11.8,4.4,11.8,18c0,14.1-18.6,28.8-24.5,28.8C669.6,266.2,649.6,251,649.6,236.6z"/>
  				<path class="Shade_x0020_7" d="M678.2,224.2c0,0,1.3,6.3,1.3,10.8c0,4.5-2.5,8.2-2.5,8.2s3-2.3,4.3-7.4c0,0,0.2,4.3,4.2,4.5
  					c0,0-5.2-7.1-3.8-15.3C681.7,224.9,681.7,226.1,678.2,224.2z"/>
  				<path class="st72" d="M678.6,224.7c0,0,1.9,5.4,2.3,9.3c0,0-0.3-6.1,0.3-8.5C681.2,225.5,679.4,225.3,678.6,224.7z"/>
  				<path class="Shade_x0020_7" d="M698.5,220.2c0,0,8.3,3.6,8.3,16.2c0,12.6-17.6,29.9-24.5,29.9c-12.3,0-32.7-16.8-32.7-28.2
  					c0-11.4,0-2.7,0-2.7c2.4,10.4,15.7,23.8,31.2,23.8c7.2,0,21.2-8.5,21.2-25.1C702,223.8,698.5,220.2,698.5,220.2z"/>
  				<path class="Highligh_x0020_7" d="M664.1,221.1c1.9,0,10.8,3.5,10.8,11.5c0,8-3.6,15.7-6.8,15.7s-16.2-5.9-16-13.4
  					c0.2-7.4,3.2-6.9,4.8-7.7C658.4,226.5,660.1,221.1,664.1,221.1z"/>
  				<path class="st73" d="M676.4,251.9c0,0,8.1,5.1,13.4-1c5.2-6.1-3.2-6-5.9-6.8C681.2,243.4,672.8,250.4,676.4,251.9z"/>
  				<path class="Highligh_x0020_7" d="M683.4,228.4c0,0,1.2,5.7,5.2,9.6c4,3.9,7.3,2.1,8.4,0c3.2-6.3,0.4-16.1-3.1-16.1
  					S682.5,225.2,683.4,228.4z"/>
  				<path class="Shade_x0020_7" d="M669.1,219.8c0,0,9.4,7.6,10.4,13.9c0,0,0.2-7.1,4.8-9.8c0,0-2.4,2.3-5.6,0.9
  					C675.4,223.2,669.1,219.8,669.1,219.8z"/>
  			</g>
  		</g>
  		<g id="t36">
  			<path class="st1" d="M588.5,243.2c0,8.4,8.8,21.5,8.8,28.5c0,8.7-1.4,6.3-1.4,25.8c0,15.4,15.2,39.1,19.6,39.1c2,0,2-2.2,2-2.9
  				c0-0.7-0.3-1.9-0.7-3.3c-0.4-1.5-3.2-19-3.2-27.4c0-8.4,2.5-15.6,4.8-15.6c1.1,0,6.3,1.5,9.2,10.7c5.7,18.5,12,26.9,12,28.4
  				c0,3,3.8,8.8,5.4,8.8c1.6,0,3.2-3.5,3.2-10.1c0-9.5-10.1-48.2-10.1-56.7c0-5.7,5.9-21.5,5.9-21.5L588.5,243.2z"/>
  			<path class="st70" d="M616.8,334c0,0-6.5-10.9-6.5-25.2c0-18.5,3.8-30,6.5-34.6c2.7-4.7,6.8,6.8,7.8,9.6c1,2.8,9.3,26,11.9,30.5
  				s6.4,16.8,7.5,17.8c1.1,1-0.8,2-1.3,1.2c-0.6-0.8-2.6-5.6-3.1-7c-0.5-1.4-7.3-15.1-8.6-18.6c-1.3-3.5-5.4-20.5-12.5-20.5
  				c-4.5,0-4.8,14.6-4.8,15.6C613.6,303.9,616.8,334,616.8,334z"/>
  			<path class="Shade_x0020_7" d="M614.7,292.7c0,0,2.1-10.8,9.9-1.1C624.6,291.6,616.8,265.3,614.7,292.7z"/>
  			<path class="st70" d="M632.8,257.6c0,0-1,8.5,3,23.7c4,15.2,11.2,45.6,12.2,47.4c0,0,0.7-3.1,0-7.2c-2.6-15.3-9.9-51.1-9.9-53
  				c0-2.4,5.2-20.8,5.2-20.8L632.8,257.6z"/>
  			<path class="st70" d="M602.8,261.7c0,0,2.3,11.7,1.1,14.7c-1.2,2.9-7.4,17.6-4.5,30.4c2.9,12.8,12.1,26.2,12.8,27.4
  				c0,0-16.2-20-16.2-34.9c0-14.9,1.2-23,1.2-29.1c0-6.1-9.8-22.5-9.8-28.7L602.8,261.7z"/>
  			<g>
  				<path class="st74" d="M625.2,221.5c4.9,0,7.1,2.2,9.3,6.1c0,0,2.5-3.9,6.4-3.9c3.4,0,6.3,4.4,6.3,10.6c0,5.6-4.2,17.8-5.1,19.2
  					c-7.3,10.5-22,16.6-25.2,16.6c-2,0-17-0.5-25-15.4c-4.2-7.8-5.3-18.3-5.3-22.5c0-7.3,3.4-8.8,7.2-10.7c3.8-1.9,4.5-3.1,6.8-3.1
  					c2.4,0,8.8,2.7,10.5,3.4c1.7,0.8,3.8,3,3.5,3.9C615.3,223.3,621.1,221.5,625.2,221.5z"/>
  				<path class="Shade_x0020_7" d="M609.5,221.1c0,0,2.4,11.3,1.7,15.6c-0.6,4.2-1.6,7.5-1.6,7.5s4-6.7,4.6-9.8c0,0-0.2,3.5,1.9,5.1
  					c0,0-1.4-12.6,2.8-16.8c0,0-4.4,2-4.3,3.1C614.7,226.8,613.9,222.8,609.5,221.1z"/>
  				<path class="st75" d="M611.1,221.9c0,0,2.2,6.1,2.9,10.7c0,0-0.1-5.2,2.4-8.7c0,0-1.8,0.6-2.3,1
  					C613.7,225.3,613.6,222.4,611.1,221.9z"/>
  				<path class="st72" d="M632.8,225c0,0,3.3,4.7,1.8,10c0,0-0.3,0.9,0.4,0c0.7-0.9,0.4-8.7,2.7-10.4c2.3-1.7-0.2,0-0.2,0
  					s-2.5,2.6-2.9,2.7C634.4,227.4,633.7,225.6,632.8,225z"/>
  				<path class="Shade_x0020_7" d="M642.7,224.1c0,0,2.7,15.1-3.2,22.7c-5.8,7.6-16,13.5-20.5,8.6c-7.9-8.6-2.8,1.5-12.6,1.5
  					c-6.3,0-13.5-0.2-18-11.8c0,0,6.4,24.9,28.5,24.9c9.7,0,24.1-14.1,25.2-16.6c1.1-2.5,5.1-13.1,5.1-20.9
  					C647.1,227.3,642.7,224.1,642.7,224.1z"/>
  				<path class="Highligh_x0020_7" d="M599.8,221.1c0,0-2.7,4.2-3.5,4.4c-0.8,0.2-3.2-0.2-5.3,2.7c-2.2,2.9,0.2,15.5,3.5,19.2
  					c0,0,5.5,2.2,9.1,2.2c3.7,0,4.8-16.6,3.9-23.1C606.5,220,602,219.5,599.8,221.1z"/>
  				<path class="Highligh_x0020_7" d="M624.7,224.1c0,0,6.8,1.4,6.8,5.4c0,4.1-0.7,22.3-5.7,22.3s-8.1-9.7-8.1-17.4
  					C617.7,226.8,620,224.1,624.7,224.1z"/>
  				<path class="st76" d="M637.8,227.3c0,0,1.3-2.2,3-2c1.7,0.2,1.3,6.5,0.8,7.3c-0.5,0.8-3,2.6-3.8,1.9
  					C637,233.8,636.5,228.7,637.8,227.3z"/>
  				<path class="Shade_x0020_7" d="M601.2,264.9c0,0,8.9,5.2,15.7,5.2c5.8,0,15.9-6.6,20.2-11C637,259,613.2,269.7,601.2,264.9z"/>
  			</g>
  		</g>
  		<g id="t35">
  			<path class="st1" d="M552.5,247.2c0,0,2.6,14.1,2.6,15.6c0,1.5,0.5,30.8,0.5,30.8c0,14.6,10.1,30.6,11.8,34.1
  				c2.6,5.5,6.8,13.5,10.6,13.5c1.7,0,1.8-1.7,1.8-3.9c0-2.6-1.8-5.8-1.8-10.7c0-19.3,1.8-24.8,1.8-29.4c0-2.1-0.9-9-1.2-17.4
  				c-0.5-10.7,0.3-22.8,1.5-31.6L552.5,247.2z"/>
  			<path class="st70" d="M570,255.6c0,0,3.2,23.7,2.8,32s2.9,41.9,6.2,48.8c0,0-0.9-4.9-0.9-7.9s1.7-26.4,1.7-31.3
  				c0-4.9-1.4-17.4-1.4-22.9c0-5.5,1.4-27.6,1.4-27.6L570,255.6z"/>
  			<path class="st70" d="M553.4,251.9c0,0,1.8,8.8,1.8,11.7c0,2.9,0.6,33.1,0.6,33.1c0,7.9,15.2,44.5,21.7,44.5
  				c0,0-18.5-28.4-18.5-43.8c0-15.4,1.8-34.2,0.6-44.1L553.4,251.9z"/>
  			<g>
  				<path class="st71" d="M567.1,218.4c3.4,0,5.1,0.7,9.5,3.8c2.5,1.8,6.6,2.3,7.5,5.5c0.6,2.4,0.6,4.1,0.6,5.8
  					c0,2.8-6.6,34.8-17.6,34.8c-10.3,0-20-27.7-20-37.4c0-7.2,2.9-7.2,8.1-9.2C557.3,220.9,562,218.4,567.1,218.4z"/>
  				<path class="Shade_x0020_7" d="M567.5,220.4c0,0,1.5,0,3.3,2.9c1.9,2.9,11.1,2,10.2,12.1c-0.4,4.8-6.3,26.2-13.5,26.2
  					c-7.2,0-15.7-12.1-20.2-27.5c0,0,8.4,34.2,19.7,34.2c11.4,0,17.6-32.2,17.6-37.2c0-4.9-3.3-6.3-6-7.8
  					C576,221.8,565.2,215.6,567.5,220.4z"/>
  				<path class="Highligh_x0020_7" d="M552.7,228.4c0,0-0.4,10.9,4.4,15.4c4.8,4.5,13.8,3.3,14.8,0.5c1-2.8-3.8-12.1-4.4-14.5
  					c-0.6-2.3-2.4-6.8-2.2-8.4c0.1-1.6-2.2-2.2-5.2,0C557,223.6,552.5,224,552.7,228.4z"/>
  			</g>
  		</g>
  		<g id="t34">
  			<path class="st1" d="M515.1,265.1c0,36.7,13.4,72.1,18.9,72.1c1.3,0,2.1-3.4,2.1-5.7c0-2.3-0.7-3.4-0.7-7
  				c0-3.6,3.9-30.7,3.9-36.4c0-5.7-2.3-16.8-1.9-21.7c0.3-4.9,3.6-16.7,3.6-16.7l-28.7-0.7C512.4,248.9,515.1,254.7,515.1,265.1z"/>
  			<path class="st70" d="M530.3,264.5c0,0,3.3,17.6,2.8,24c-0.5,6.4-1.8,26.9-1.4,30.9c0.4,4,1.2,17,2.4,17c0.7,0,2.3-2,1.9-6
  				c-1.6-13.6,3.3-33.2,3.3-42.4c0-5.7-1.9-15.7-1.9-19.7s3.2-21.5,3.2-21.5L530.3,264.5z"/>
  			<path class="st70" d="M515.1,254.2c0.3,17.4,1.3,58.1,14.8,78.8c0,0-18.5-55.6-11.6-78.8H515.1z"/>
  			<g>
  				<path class="st71" d="M525.9,218.4c3.2,0,4.1,0.6,5.6,2.1c1.7,1.7,3.6,3.9,6.2,4.9c2.3,0.9,6.5,6.8,6.5,11.2
  					c0,5.5-5.9,33.3-17,33.3c-7.1,0-20.1-24.4-20.1-34.5c0-6.5,5.9-8.3,10.9-12.5C519.5,221.6,522.2,218.4,525.9,218.4z"/>
  				<path class="Shade_x0020_7" d="M527.7,218.7c0,0,0.9,4.5,3.4,7.2c2.5,2.8,6.9,8.4,7.6,11.5c0.8,3.1-4.5,23.7-10.8,23.7
  					S512,251,508.1,241.3c0,0,10.6,28.6,19.1,28.6c8.5,0,17-23,17-33.3c0-5.5-3.2-9.9-6.5-11.2C534,224,531.8,219.1,527.7,218.7z"/>
  				<path class="Highligh_x0020_7" d="M519.1,225.2c0,0-4.4,3.4-4.9,9.8c-0.5,6.4,5.3,18.8,11.9,20.4c6.6,1.6,8.5-7.1,8-12.9
  					c-0.5-5.8-5-8.2-6.4-10.3C524.8,227.8,525.2,219.4,519.1,225.2z"/>
  			</g>
  		</g>
  		<g id="t33">
  			<path class="st1" d="M474.1,251.3c0,0,1.7,34.4,1.7,38.8c0,4.4,5.4,17.5,5.4,25.8c0,4.2,9.6,23.6,14.2,23.6
  				c0.8,0,1.7-0.8,1.7-2.1c0-1.3-1.5-9.1-1.5-13.2s5-27.1,5-40.2c0-4.9-1.3-16.3-1.3-19.2s1.8-14.1,1.8-14.1L474.1,251.3z"/>
  			<path class="st70" d="M490.2,274.5c0,0,2.5,16.3,1.8,22.8c-0.7,6.5-1,25.8,0.8,30.9c1.8,5.1,3.1,11.6,3.6,10.8
  				c0.5-0.8-0.8-11.3-0.8-14.9c0-3.6,5-30.8,5-40.2c0-9.4-2.7-29.7-2.7-29.7L490.2,274.5z"/>
  			<path class="st70" d="M474.9,264.5l0.8,25.5c0,0,5.4,20.1,5.4,24.3c0,4.1,8.3,19.8,9,20.7c0,0-5.4-14.3-6.7-20.7
  				c-1.2-6.4-6-44.7-4.9-48.8L474.9,264.5z"/>
  			<g>
  				<path class="st71" d="M485.5,216.7c3.1,0,7.8,2.6,11.6,9.2c0,0,8.1,5.9,8.1,10.5c0,7.7-5.4,20.9-6,24.3c-1,5.8-5.3,27-13.7,27
  					c-10.3,0-18.8-45.6-18.8-57.5c0-4.8,7.3-7,7.3-7S482,216.7,485.5,216.7z"/>
  				<path class="Shade_x0020_7" d="M487,216.9c0,0,6.5,3.2,10.2,9c1.4,2.3,2.1,2,2.1,2s6,4,6,8.5c0,4.5-5.8,23.1-6,24.3
  					c-0.2,1.2-5.4,27-13.7,27c-8.3,0-17-41.3-17-41.3s10.2,33.3,16.5,33.3c6.3,0,14.2-33.1,14.2-42.3
  					C499.2,228.2,491,233.1,487,216.9z"/>
  				<path class="Highligh_x0020_7" d="M483.4,220.3c0,0-5.1,4.1-7.3,6.6c-2.2,2.5-5.9,8.7-3.7,17c2.2,8.3,8,21.7,11,22.2
  					c3,0.5,3.8-21.9,3.6-29.3C486.9,236.7,489,216.5,483.4,220.3z"/>
  				<path class="st29" d="M468.9,226.4c0,0,2.9-2.1,5.1-3.2c2-1,5.4-2.6,4.2,0.6C477.1,227,467.6,233.2,468.9,226.4z"/>
  			</g>
  		</g>
  		<g id="t32">
  			<path class="st1" d="M438.2,255.1c0,58,11.7,84.3,16.4,84.3c1.3,0,2.8-1.6,2.8-2.4c0-0.9-0.6-10.5,0-11.9
  				c0.6-1.4,4.5-16.2,4.2-18.6c-0.3-2.4-1.5-51.4-1.5-51.4L438.2,255.1z"/>
  			<path class="st70" d="M438.2,260.3c0,0,0.3,57.3,14,77.5c0,0-14-40.1-11.4-76L438.2,260.3z"/>
  			<path class="st70" d="M460.3,259c0,0,0.2,40.9,1.3,47.5c0.5,3-3.3,15.5-4.2,18.6c-0.9,3.1,0,11.4,0,11.4c-3-2.7-6-33.4-6.4-39.1
  				c-0.3-5.7-0.5-26.3-0.5-26.3"/>
  			<g>
  				<path class="st71" d="M438.9,221.4h19.3c2.8-0.1,6,0.2,6.5,6.2c0.5,6.4-3.2,47.3-14.5,47.3c-10.5,0-16.9-33.3-16.9-38.1
  					c0-2.2,0-10.4,0-10.4C433.4,224.2,434.3,221.4,438.9,221.4z"/>
  				<path class="Shade_x0020_7" d="M459.4,221.4c0,0,5.4-1.3,5.4,8.7c0,10-4.9,44.8-14.6,44.8c-4.9,0-9.3-9.3-9.3-9.3
  					s4.5,4.2,9.4,4.2s10.5-22.8,10.5-39C460.8,225,460.9,225.6,459.4,221.4z"/>
  				<path class="Shade_x0020_7" d="M438,221.3c0,0-4.6,0-4.6,6.3c0,6.3,0.2,12.3,1,16.2C434.3,243.8,432.9,228.8,438,221.3z"/>
  				<path class="Highligh_x0020_7" d="M442.1,222.3h14.7c0,0-0.1,11.9-1.4,19.1c-1.2,7.2-3.7,12.3-8.9,12.3
  					C440.9,253.6,433.2,222.3,442.1,222.3z"/>
  				<path class="st77" d="M444.4,221.4l-1.2,0.2l-1.7-0.2c0,0,0.8,6.1,1.4,6.1C443.4,227.5,443.2,221.4,444.4,221.4z"/>
  				<path class="st77" d="M453.6,221.4l1.4,0.2l1.9-0.2c0,0-0.9,6.1-1.6,6.1C454.7,227.5,454.9,221.4,453.6,221.4z"/>
  			</g>
  		</g>
  		<g id="t31">
  			<path class="st1" d="M405.1,252.3c-1,43.2-2.2,42.6-2.2,50.6c0,4.5,3.2,11.5,3.2,17.3c0,8.7-3.4,13.5-3.4,14.2
  				c0,1.2,0.4,2.1,2.3,2.1c12.9,0,21.2-26.5,21.2-84L405.1,252.3z"/>
  			<g>
  				<path class="st70" d="M414.5,262.2c0,0-5.4,27.6-4.6,38.8c2,28.5-3.2,35.5-4.9,35.5c-3.7,0-2.3-2.1-2.3-2.1s3.4-5.9,3.4-13.3
  					c0-7.4-3.2-16-3.2-18.2c0-2.2,2.1-44.7,2.1-44.7L414.5,262.2z"/>
  				<path class="st70" d="M425.7,261.8c0,0,1,51.3-9.8,66.5c0,0,8.1-47.9,5.9-66.5H425.7z"/>
  			</g>
  			<g>
  				<path class="st71" d="M402.7,224.7c0-1.3,0.9-3.1,3.4-3.1c2.2,0,17.2,0,17.6,0c2.1,0,7.4,1.6,7.4,3.1c0,24.1-8.2,55.8-15.2,55.8
  					c-8.3,0-13.2-30.7-13.2-37.5C402.7,236.3,402.7,224.7,402.7,224.7z"/>
  				<path class="Shade_x0020_7" d="M402.7,228.4c0,31.4,5.8,52.1,13.2,52.1c3.9,0,7.7-10.4,8.8-14c1.1-3.6-3.2,7.9-9.5,7.9
  					c-8.9,0-12.4-55.1-12.4-50.6C402.9,225.7,402.7,228.4,402.7,228.4z"/>
  				<path class="Highligh_x0020_7" d="M407.1,225c0,0,3,10.6,4.2,15.6c1.8,7.8,1.2,18.7,7.4,18.7c5.5,0,8.5-34.7,3.9-35.7
  					C417.9,222.6,407.1,221.4,407.1,225z"/>
  				<path class="st77" d="M413.5,221.7l-1.2,0.3l-1.7-0.3c0,0,0.8,8.7,1.4,8.7C412.6,230.4,412.4,221.8,413.5,221.7z"/>
  				<path class="st77" d="M421,221.7l1.3,0.3l1.8-0.3c0,0-0.8,10-1.5,10C422,231.7,422.2,221.8,421,221.7z"/>
  			</g>
  		</g>
  	</g>
  	<g id="k2">
  		<g id="t28">
  			<path class="st1" d="M740.7,22.2c1.4,0,12.2,3.2,12.2,33.1c0,9.9-0.6,32.4-0.6,39.8c0,4.8,4.7,27.3,4.7,31.2c0,6.5-40.1,0-40.1,0
  				s5.5-21.5,5.5-28.1c0-6.6-5.5-25-5.5-35.4c0-10.4,10.7-35,10.7-37.2c0-2.2,1.9-3.8,2.8-3.8c0.9,0,3.9,2.5,3.9,8.7
  				s-1.5,15-1.5,20.9c0,5.9,3.6,20.4,3.6,20.4s6.1-23,6.1-28.5c0-5.4-3.9-12.7-3.9-16.1C738.6,23.9,739.1,22.2,740.7,22.2z"/>
  			<g>
  				<path class="st70" d="M730.5,21.9c0,0,1.8,3.8,1,7.8c-0.8,4-3,21.4-3,26.5c0,2,6.3,18.1,7.9,29.8c0,0,0.7-11.5,0-14
  					c0,0-3.6-15.9-3.6-21.1c0-5.2,1.5-14.5,1.5-21.2C734.4,23,730.5,21.9,730.5,21.9z"/>
  				<path class="st72" d="M732.6,54.3c0,0,0,0.1,0.1,0.4c0.4,3.7,3.6,30,4.1,33.3c0.5,3.6-0.1,5.6-0.1,5.6s0.9-6.5,0.3-14.7
  					c-0.7-8.2,4.1-15,5.8-32.7c0,0-5.5,24.1-6,25.1"/>
  				<path class="st70" d="M742.7,22.8c0,0,6.4,11.2,6.7,21.9c0.3,10.7-3.4,36.9-3.4,45s9.5,38.5,9.5,38.5l1.5-0.6
  					c0,0-4.8-27.8-4.8-31.5c0-3.8,0.4-35.3,0.4-48.5C752.6,30.8,742.7,22.8,742.7,22.8z"/>
  			</g>
  			<g>
  				<path class="st71" d="M759.6,133.3c0,12.9-4.4,19.6-8.3,19.6c-1.2,0-9-4.8-9.6-4.8c-1.8,0-11.2,7.2-13.5,7.2
  					c-2.3,0-4.5-2.6-5.5-3c-1-0.4-9-3.4-9-10.1c0-6.7,4.1-33.2,25.9-33.2C743.6,109,759.6,115.9,759.6,133.3z"/>
  				<path class="st75" d="M735.7,128.2c0,0,5.1,2,5.5,8.9c0.4,6.9,1.3,8.9-0.6,11.3c0,0,1.4-1.4,2.9,0.5c0,0-1.4-4-1-7.7
  					c0.4-3.8-0.9-7.3,2.4-10.3c0,0-2.8,1-3.2,3C741.6,133.9,740.7,130.2,735.7,128.2z"/>
  				<path class="Highligh_x0020_9" d="M743.6,138.3c0,0-0.9-3.2,2.5-6.2c3.4-3,6.5-7.3,7.8-6.1c1.2,1.2,3.2,12,2.5,14.8
  					c-0.8,2.8-1.2,7.9-3.8,8.7c-2.5,0.9-7-0.6-7.8-2.1C744.1,145.9,743.5,140.8,743.6,138.3z"/>
  				<path class="st76" d="M735.7,130.9c0,0,1.8,3.9,1.8,8.6c0,3-0.8,9.4-4,11.2c-1.5,0.8-5.8,3.8-7,2.3c-1.3-1.5-4.1-3.2-6-4
  					c-1.9-0.8-5.5-4.6-5.3-6.8c0.3-2.2,0.8-10.4,4-14C722.5,124.6,733.2,125.1,735.7,130.9z"/>
  				<path class="st78" d="M724.1,119.2c0,0,11,4.8,13.9,7.8c2.9,2.9,9.9-6.2,11.2-7.8c1.4-1.6-6.8-11.3-17.8-6.7
  					C722.4,116.2,724.1,119.2,724.1,119.2z"/>
  				<path class="Shade_x0020_10" d="M754.5,118c0,0,5.2,8.3,5.2,14.1c0,5.8-2.1,20.7-7.9,20.7c-5.8,0-6.9-4.2-10-4.9
  					c-3-0.7-11.3,8-13.5,7.3c-2.1-0.6-9.2-4.8-9.6-5.1s7.1,3.3,8.9,3.2c1.8-0.1,11.7-7.3,14.2-7.3s6.7,3.8,10,3.8
  					c3.3,0,6.4-5,6.4-16.7C758.1,128.9,754.5,118,754.5,118z"/>
  			</g>
  			<g>
  				<path class="st71" d="M742.5,43.4c0-4.2-2.4-9.6-3.4-13.4c-0.2,0.3-0.3,0.7-0.3,1.2c0,1.4,0.5,9.8,0.5,9.8
  					c0,4.5-2.8,14.8-4.9,21.5c1,4.9,2,9.3,2,9.3S742.5,48.9,742.5,43.4z"/>
  			</g>
  		</g>
  		<g id="t27">
  			<path class="st1" d="M690.6,27.3c0,3.4,3.9,10.7,3.9,16.1c0,5.4-6.1,28.5-6.1,28.5s-3.6-14.5-3.6-20.4c0-5.9,1.5-14.7,1.5-20.9
  				s-2.9-8.7-3.9-8.7s-2.8,1.6-2.8,3.8c0,2.2-10.8,26.7-10.8,37.2c0,10.4,5.5,28.9,5.5,35.4c0,6.5-5.5,28.1-5.5,28.1
  				s40.1,6.5,40.1,0c0-4-4.7-26.4-4.7-31.2c0-7.4,0.6-29.9,0.6-39.8c0-29.9-10.9-33.1-12.2-33.1C691.1,22.2,690.6,23.9,690.6,27.3z"
  				/>
  			<g>
  				<path class="st70" d="M682.5,21.9c0,0,1.8,3.8,1,7.8c-0.8,4-3,21.4-3,26.5c0,2,6.3,18.1,7.9,29.8c0,0,0.7-11.5,0-14
  					c0,0-3.6-15.9-3.6-21.1c0-5.2,1.5-14.5,1.5-21.2C686.4,23,682.5,21.9,682.5,21.9z"/>
  				<path class="st72" d="M684.6,54.3c0,0,0,0.1,0.1,0.4c0.4,3.7,3.6,30,4.1,33.3c0.5,3.6-0.1,5.6-0.1,5.6s0.9-6.5,0.3-14.7
  					c-0.7-8.2,4.1-15,5.8-32.7c0,0-5.5,24.1-6,25.1"/>
  				<path class="st70" d="M694.7,22.8c0,0,6.4,11.2,6.7,21.9c0.3,10.7-3.4,36.9-3.4,45s9.5,38.5,9.5,38.5l1.5-0.6
  					c0,0-4.8-27.8-4.8-31.5c0-3.8,0.4-35.3,0.4-48.5C704.6,30.8,694.7,22.8,694.7,22.8z"/>
  			</g>
  			<g>
  				<path class="st71" d="M711.6,133.3c0,12.9-4.4,19.6-8.3,19.6c-1.2,0-9-4.8-9.6-4.8c-1.8,0-11.2,7.2-13.5,7.2s-4.5-2.6-5.5-3
  					c-1-0.4-9-3.4-9-10.1c0-6.7,4.1-33.2,25.9-33.2C695.6,109,711.6,115.9,711.6,133.3z"/>
  				<path class="st75" d="M687.7,128.2c0,0,5.1,2,5.5,8.9c0.4,6.9,1.3,8.9-0.6,11.3c0,0,1.4-1.4,2.9,0.5c0,0-1.4-4-1-7.7
  					c0.4-3.8-0.9-7.3,2.4-10.3c0,0-2.8,1-3.2,3C693.6,133.9,692.7,130.2,687.7,128.2z"/>
  				<path class="Highligh_x0020_10" d="M695.6,138.3c0,0-0.9-3.2,2.5-6.2c3.4-3,6.5-7.3,7.8-6.1c1.2,1.2,3.2,12,2.5,14.8
  					c-0.8,2.8-1.2,7.9-3.8,8.7c-2.5,0.9-7-0.6-7.8-2.1C696.1,145.9,695.5,140.8,695.6,138.3z"/>
  				<path class="st76" d="M687.7,130.9c0,0,1.8,3.9,1.8,8.6c0,3-0.8,9.4-4,11.2c-1.5,0.8-5.8,3.8-7,2.3c-1.2-1.5-4.1-3.2-6-4
  					c-1.9-0.8-5.5-4.6-5.3-6.8c0.3-2.2,0.8-10.4,4-14C674.5,124.6,685.2,125.1,687.7,130.9z"/>
  				<path class="st78" d="M676.1,119.2c0,0,11,4.8,13.9,7.8c2.9,2.9,9.9-6.2,11.2-7.8c1.4-1.6-6.8-11.3-17.8-6.7
  					C674.4,116.2,676.1,119.2,676.1,119.2z"/>
  				<path class="Shade_x0020_11" d="M706.4,118c0,0,5.2,8.3,5.2,14.1c0,5.8-2.1,20.7-7.9,20.7c-5.8,0-6.9-4.2-10-4.9
  					c-3-0.7-11.3,8-13.5,7.3c-2.1-0.6-9.2-4.8-9.6-5.1s7.1,3.3,8.9,3.2c1.8-0.1,11.7-7.3,14.2-7.3s6.7,3.8,10,3.8
  					c3.3,0,6.4-5,6.4-16.7C710.1,128.9,706.4,118,706.4,118z"/>
  			</g>
  			<g>
  				<path class="st71" d="M694.5,43.4c0-4.2-2.4-9.6-3.4-13.4c-0.2,0.3-0.3,0.7-0.3,1.2c0,1.4,0.5,9.8,0.5,9.8
  					c0,4.5-2.8,14.8-4.9,21.5c1,4.9,2,9.3,2,9.3S694.5,48.9,694.5,43.4z"/>
  			</g>
  		</g>
  		<g id="t26">
  			<path class="st1" d="M622,110.2c0,5.3-0.3,6.8-0.3,6.8h35.6c-1.9-8.6,5-35.7,5-43c0-33.6-5.7-50.6-8-50.6c-1.1,0-2.4,2.8-2.4,4
  				c0,2.5,0.6,5.1,0.6,6.7c-0.4,31.5-8.7,47.7-12.2,47.7c-2.6,0-6.1-11.8-6.1-15.4c0-3.6,1.5-16.3,1.5-25.8c0-3-2-17-5.1-17
  				c-1.2,0-3.5,3-3.5,7.3c0,8.2-10.1,35.8-10.1,45.1C616.9,84.2,622,104.9,622,110.2z"/>
  			<g>
  				<path class="Shade_x0020_11" d="M631.2,24.8c0,0,2.2,10.2,2.2,15.2c0,4.9-2.2,17-2.2,27.1s6.3,20.7,9.3,22.6
  					c0,0,8.3-8.3,9.5-29.9c0,0-4.6,21.7-10.1,21.7c-2.9,0-6.2-14.5-6.2-15.4c0-0.8,2-20,2-24.9C635.7,36.4,633.6,25,631.2,24.8z"/>
  				<path class="st79" d="M636.2,77c3,6.7,2,12.2,4.3,15.3c0,0,1.1-8.9,3.8-15.3c0,0-2.5,4.9-3.8,4.9C639.2,82,636.2,77,636.2,77z"
  					/>
  				<path class="st70" d="M623,49.2c0,0-6.1,20.9-6.1,26.9c0,5.9,4.8,21.3,4.8,42h9.5C631.2,118,616.3,89.7,623,49.2z"/>
  				<path class="st70" d="M657.6,29.6c0,0,2.1,27.2,1.1,43.7s-9.7,42-9.7,42l7.1-1.7c0,0,1.5-13.3,2.2-14.4c0.7-1.1,4-20,4-25.4
  					S660.9,32.3,657.6,29.6z"/>
  			</g>
  			<g>
  				<path class="st71" d="M664,134.4c0,0,0.4,6.6-2.4,9.5c-2.9,2.9-7.1,7.1-7.1,7.1c-0.3,0.4-1.4,1.6-2.3,1.6c-0.9,0-8.6-6-9.3-6
  					c-0.7,0-8.7,8.8-14.9,8.8c-2.1,0-4.2-2.8-5.7-3.4c-1.5-0.5-8-2.4-8-9.1c0-4.8,3.4-9.6,8.1-28c1.8-6.8,14.4-16.3,18.7-16.3
  					C653.5,98.5,664,122.5,664,134.4z"/>
  				<path class="Shade_x0020_11" d="M646.1,102c0,0,4.8,5.7,5.1,8.3c0.4,2.7,2.2,8.8,5.9,12.5c3.6,3.8,6,14.3,3.9,18.2
  					c-2.1,3.9-6,8.6-6,8.6s6.7-4.7,7.8-7.7c1.2-2.9,1-6.2,1-9.8c0,0-1.7-22.3-17.7-32.3C646.1,99.8,643,97.8,646.1,102z"/>
  				<path class="Shade_x0020_11" d="M641.7,144.3c0,0-0.6-5.4-0.6-8.4c0-2.9-1.3-7-4-8.9c-2.8-1.8-1.8-1.8-1.8-1.8s5.7,1.9,6.7,5.6
  					c0,0,3.5-3.2,7.8-4c0,0-5.2,3-6.4,6.6c-1.1,3.6-0.7,9,0.2,10.8c0.8,1.8,6.9,6.7,8.3,7.3c1.4,0.6-1.8,0.1-8-4.9
  					c-0.3-0.3-0.9-0.4-0.9-0.4s-3.4,3.8-5.6,4.7C635.2,151.8,640.1,149,641.7,144.3z"/>
  				<path class="st73" d="M637.4,122.4c0,0,3.8,2.2,4.8,3.9c1,1.7,3.1-0.2,5.4-1c2.2-0.8,2.8-4.6,2.4-7.1c-0.4-2.5-2.8-7.5-6.2-10.8
  					c-3.4-3.3-2.8-1.6-3.6,0.8C639.4,110.5,633.9,119.9,637.4,122.4z"/>
  				<path class="Highligh_x0020_10" d="M635.1,127.9c0,0,4,2.1,4.5,4.3c0.5,2.2,0.4,6.6,0,9.4c-0.4,2.8-1.9,5.5-3.4,7.4
  					c-5.8,7.1-10.9,3-12.4,1.8c-1.5-1.3-9.7-3.6-5.8-12.3c1.5-3.3,7.4-11.7,9-12.2C628.7,125.7,633.6,126.9,635.1,127.9z"/>
  				<path class="st76" d="M643.1,139.5c0,0,0.5,4.2,6.9,10c2.9,2.7,4.3-0.7,4.3-0.7c0,0,3.6-4.8,4.2-10.4c0.6-5.6,0.1-12.5-2.9-12.5
  					c-1.8,0-7.1,2.5-8.6,4.1C645.5,131.6,643.4,132.6,643.1,139.5z"/>
  				<path class="st29" d="M656.9,111.1c0,0,7.1,16.8,7.1,24.4c0,7.6-10.9,17.1-11.8,17.1c-1,0-9.5-5.9-9.5-5.9s-10.8,8.7-14.7,8.7
  					s-5.7-3.4-5.7-3.4s-7.2-3.2-8-7.6c0,0,6.3,3.4,9.7,6.3c3.4,2.9,15.5-2.8,18.4-5.9c1.2-1.3,1.5,0,2.5,1c1,1,6,4,7.4,4.1
  					c1.4,0.1,9.5-7.6,9.5-14.8C661.7,127.8,657.6,113.1,656.9,111.1z"/>
  			</g>
  			<g>
  				<g>
  					<g>
  						<path class="st71" d="M634.1,66.3c0,3.6,3.6,15.4,6.1,15.4c2.9,0,8.9-10.9,11.3-32c-1.3-12.4-3-23.4-3.5-25.6
  							c-0.8-3.9-2.8-3.7-2.8-3.7c-0.5,0-0.9,0.1-1.3,0.3c-4.2,1.9-5,13-6.3,16.2c-0.4,1-1.2,2.1-2,3.2c0,0.1,0,0.3,0,0.4
  							C635.6,50,634.1,62.7,634.1,66.3z"/>
  					</g>
  					<g>
  						<path class="st79" d="M640.2,81.7c2.7,0,8.1-9.4,10.8-27.8c-3.2,14.1-9.2,21.7-10.1,22c-1,0.4-3.2-5.1-4.6-10.9
  							c-1.3-5.6-0.8-18-0.8-18.8c-0.4,8.3-1.4,17.2-1.4,20.1C634.1,69.9,637.6,81.7,640.2,81.7z"/>
  					</g>
  				</g>
  				<path class="Shade_x0020_11" d="M644.4,20.5C644.4,20.5,644.4,20.5,644.4,20.5c0,0.2,4.9,23.2,2.2,49.6c1.6-5,3.1-11.5,4-19.6
  					c-0.1-1.6-0.2-3.2-0.4-4.8c-1-8.5-2-15.8-2.7-19.4C646.7,22.7,645.7,20.5,644.4,20.5z"/>
  			</g>
  		</g>
  		<g id="t25">
  			<path class="st1" d="M580.8,90.1c0,12.9,0.4,40,0.4,40h26.6c0,0-5.1-59.4-5.3-62.6c-0.4-4.8-4.9-19.8-4.9-28
  				c0-6.6,0.5-8.6,0.5-10.7c0-1.8-1.8-6-4.4-6C584.7,22.8,580.8,63.6,580.8,90.1z"/>
  			<g>
  				<path class="st70" d="M596.3,30.1c0,0-2.7,10-3,26.9c-0.3,17,7.5,56.4,7.5,56.4l6.5,2l-2.4-25l-2.6-25.9c0,0-4.6-16.3-4.6-20.4
  					C597.7,40.2,598,28.7,596.3,30.1z"/>
  				<path class="st70" d="M583.8,124c0,0,0.1-74.7,1.4-82.8c0,0-4.2,26.2-4.3,38.1c-0.1,11.9,0.2,45.8,0.2,45.8L583.8,124z"/>
  			</g>
  			<g>
  				<path class="st71" d="M594,106.5c5.7,0,17.8,16.4,17.8,31.7c0,8.5-4,6.2-7.8,9.7c-3.8,3.6-7.7,7.4-10.7,7.4
  					c-1.6,0-16.9-5.1-16.9-11.6C576.4,136.9,584.1,106.5,594,106.5z"/>
  				<path class="Shade_x0020_11" d="M596.3,107.2c0,0,3.9,6.9,4.3,9.9c0.3,3,2.1,9.4,1.9,16.7c-0.2,7.3-4.7,13.7-3.4,15.5
  					c1.8,2.4,4.9-3.2,7.9-3.4c3-0.2,5.2-4.8,4.3-12.2C610.5,126.4,606.7,113.3,596.3,107.2z"/>
  				<path class="Highligh_x0020_10" d="M595,114.4c0,0,3.7,7.5,2.5,14.2c-1.2,6.7-0.7,13.3-1,16.9c-0.3,3.6-1.5,7.4-4.3,7.4
  					c-2.2,0-5-4-7.2-6.5c-2.2-2.5-4.3-4-4.3-8.2C580.7,135.6,590.8,102.4,595,114.4z"/>
  			</g>
  		</g>
  		<g id="t24">
  			<path class="st1" d="M562.8,21c1.4,0,1.9,1.6,1.9,3.3c0,6.2,4.6,24.7,4.6,43.7c0,7.6-0.3,52.2,0.3,55.6c1,5.7-24.7,0-24.7,0
  				s1.1-39.3,1.1-43.9C546,64,554.6,21,562.8,21z"/>
  			<g>
  				<path class="st70" d="M563.9,27.2c0,0-2.3,26.6-2,29.7l1,50.4l6.4,6.2l-0.1-26.9c0,0,0.7-30.1-1.3-36.5
  					C566,43.7,564.9,27.6,563.9,27.2z"/>
  				<path class="st70" d="M553.9,39.2c0,0-8.1,21.3-8.1,47.5c0,16.7,0,29.5,0,29.5l3.2-9.9C549,106.2,550.1,52.4,553.9,39.2z"/>
  			</g>
  			<g>
  				<path class="st71" d="M557.3,101.9c4.1,0,8.8,2.4,13.1,17.9c3,10.8,4.5,14,4.5,18.5c0,4.5-0.9,9.8-10.2,12.8
  					c-4.7,1.5-5.9,4.3-8.7,4.3c-3.8,0-8.1-4.1-11.1-4.9c-3-0.8-7.3-2.9-7.3-9.9C537.6,134.7,547.3,101.9,557.3,101.9z"/>
  				<path class="Shade_x0020_11" d="M557.5,104.5c0,0,3.8,1.9,4.7,6.9c0.8,5,6.3,13.6,6.5,14.6c0.2,1,1.4,12.3-2,16.7
  					c-3.3,4.4-7.7,6.7-9.2,8.2c-1.5,1.5-5.5-1.3-7.7-1.7c-2.2-0.4-4.7-3.1-7.3-2.5c-2.6,0.6-2.1,2,0.9,3.1c3,1.1,10.6,5.4,12.6,5.4
  					c2,0,10.3-5.8,13.3-6.3c3-0.5,5.6-8.1,5.6-10.7c0-2.6-8-36.3-16.3-36.3S557.5,104.5,557.5,104.5z"/>
  				<path class="Highligh_x0020_10" d="M552.5,106.5c0,0-6.3,10.4-7.8,16.1c-1.5,5.6-1.8,8.9-1.7,12.4c0.2,3.5,0,4.8,4.7,7.5
  					c4.8,2.7,6.6,6.5,8.5,5.4s1.6-13.2,1.6-19.3c0-6-0.2-10,0-13.4C558,111.9,556,104.4,552.5,106.5z"/>
  			</g>
  		</g>
  		<g id="t23">
  			<path class="st1" d="M506.9,56c-0.3,5.1-5.1,12.6-5.1,29.6c0,4.2,0,4.1,0.2,23.4h23.7c0,0,2.3-25.7,2.3-35.3
  				c0-9.6-4.9-35.9-4.9-38.7c0-2.8,2.1-12,2.1-13.2c0-1.1-0.9-2-2.1-2C515.9,19.8,507.4,45.8,506.9,56z"/>
  			<g>
  				<path class="st70" d="M523.6,20.8c0,0-6.4,26.3-5.4,33.5c1,7.2,3.5,30.6,2.6,41.7c-0.9,11.1,2.8,17.7,2.8,17.7l1.8-3.6l1.2-14.9
  					c0,0,1.4-17.8,1.4-24.5c0-6.7-4.8-33.9-4.8-38.1C523.2,28.4,524.2,18.5,523.6,20.8z"/>
  				<path class="st70" d="M506.1,58.2c0,0-1.4,46.6,2.4,59.9c0.9,3.1,0,1.3,0,1.3l-5.9,0.6c0,0-0.7-22.9-0.7-32.4
  					C501.9,72.2,506.1,58.2,506.1,58.2z"/>
  			</g>
  			<g>
  				<path class="st71" d="M514.2,87.6c7.5,0,15.2,12.5,15.2,23.7c0,4.9,7,19,7,24.3c0,5.7-9,10.8-9,10.8s-7.4,8.9-12.4,8.9
  					c-6.7,0-13.1-6.2-13.1-6.2s-8.1-2.4-8.1-5.6C493.8,140.2,499.6,87.6,514.2,87.6z"/>
  				<path class="Shade_x0020_11" d="M519.8,151.3c1.3-5.6,4.2-10,6-10.9c5.6-2.9,6.2-5,6.2-5.2c0.8-11.2-7.8-22.1-7.6-25.9
  					c0.2-3.8-5.3-14.4-8.2-15c-2.8-0.6-8,0-10.5,7.5c-0.8,2.4-8.2,34.6-9,38.6c-0.8,4.1-2.5,5-2.8,4c-0.3-1,0-4.1,0.2-6.2
  					c0.3-2,7-50.6,19.9-50.6c12.9,0,14.5,19,14.5,22c0,0,2.9,10,4.3,13.7c1.3,3.7,5.7,12.4,2,16.3c-3.7,3.9-6.6,5.7-7.6,6.7
  					C526.5,147.5,518.7,156.2,519.8,151.3z"/>
  				<path class="Highligh_x0020_10" d="M498.5,143.3c0,0,3.9-0.4,6.2,1.2c2.3,1.6,3.1,6,8.1,6.1c5,0.2,2.3-6.5,2.3-12.1
  					c0-5.5-1.3-17.5-1.8-21.5c-0.5-3.9-0.8-15-1.5-16.7c-0.7-1.8-3.8,3.2-4.9,7.9C505.8,113,495.5,140.8,498.5,143.3z"/>
  			</g>
  		</g>
  		<g id="t22">
  			<path class="st1" d="M461,125.3h25c0.7-9.3,1.3-43.3,1.3-53.4c0-12.2-3.1-22.4-3.1-25.6c0-1.3,0-20.9,0-23.6c0-2.7-2-2.8-2-2.8
  				c-2,0-3.3,2.4-3.9,3.6c-0.6,1.2-1.3,1.5-2.2,3C460.9,53.3,461,125.3,461,125.3z"/>
  			<g>
  				<path class="st70" d="M483.2,20.1c0,0-4.6,32.2-5.9,43.6C476,75.1,479.2,116,479,120c-0.2,4,5.3,6.4,7,5.2
  					c1.7-1.2,0-20.1,0-20.1s1.3-31.9,1.3-34.6c0-2.7-3.1-21.5-3.1-26.2C484.2,39.6,485.9,21.1,483.2,20.1z"/>
  				<path class="st70" d="M468.1,44.7c0,0-6.9,48-6.9,68c0,8.6-0.1,11.1,2.9,9.3c0,0,4.4-3,4-8.2C467.7,108.4,466.1,58.6,468.1,44.7
  					z"/>
  			</g>
  			<g>
  				<path class="st71" d="M452.1,148.3c0,3.6,1.2,5.2,3.6,5.2c3.6,0,6.8,0.5,7.8,0.5s4.2,1.3,6.7,1.3c3.7,0,6-2.7,7.2-2.7
  					c2.2,0,14.1-0.1,14.1-16.7c0-14-12.5-40.7-19-40.7C462.5,95.2,452.1,136.5,452.1,148.3z"/>
  				<path class="Shade_x0020_11" d="M456.6,123.7c0,0,6.9-19.5,15.1-20.6s13.6,16.6,14.3,22.1c2,16.2-4.4,25.1-6.3,26.9
  					c0,0,7.2-2.4,8.6-5.6c2.4-5.2,5.7-17.9-3.6-35.4C475.5,93.7,472,95,470.9,95.5C469.9,96.1,460.1,102.2,456.6,123.7z"/>
  				<path class="Highligh_x0020_10" d="M453.7,148c0,0,8.4-21.9,17.5-21.9c9,0,14.2,14,10.9,18.8c-3.3,4.8-8.8,8.6-12,8
  					c-3.2-0.7-8.3-0.8-11.5-0.8C455.3,152.2,452.2,151.5,453.7,148z"/>
  				<path class="st70" d="M473.8,150.9c0,0,3.6-2.2,4.3-7.4c0,0,1.1,4.6,0.9,6.8C478.8,152.6,471.1,153.8,473.8,150.9z"/>
  			</g>
  		</g>
  		<g id="t21">
  			<path class="st1" d="M447.3,129.2c0,0-3.9-25.3-4.1-29.3c-0.2-4,0.3-24.8,0.3-31.9c0-14.6-6.7-34.6-6.7-41.3
  				c0-2.9,0.8-3.2,0.8-5.5c0-1.2-1.4-1.8-2-1.8c-10.7,0-25.3,41.6-25.3,81.7c0,6.2-3.4,12.9-1.5,19.4L447.3,129.2z"/>
  			<g>
  				<g>
  					<path class="st70" d="M434.8,19.4c0,0-4.2,14.4-5.3,30.9c-1,16.5-2,59.4,0,65.9c2,6.5,13.2,9.9,13.9,5.8
  						c0.7-4.1-0.2-16.9-0.2-22.9c-0.1-6,0.2-21.2,0.2-28.5c0-14.9-6.6-43.7-6.6-46.5S438,19.8,434.8,19.4z"/>
  					<path class="st70" d="M417.2,49c0,0-4.7,53.2-1.3,63.6c0,0-1.5,9.3-3.9,3.6c-2.4-5.7-1.9-13.1-1.8-17.7
  						C410.4,93.9,413.5,52.8,417.2,49z"/>
  				</g>
  			</g>
  			<g>
  				<path class="st71" d="M403,153.9c0,0,8.9,2.1,14.8,0.7c0,0,9.8,1.6,15.4-0.1c0,0,11.6,0.7,14.4-1.7c2.8-2.4,2.9-9.2,2.9-11.9
  					c0-15.3-11.8-53.8-22.9-53.8c-10.5,0-24.5,22.2-24.5,49.5C403.1,141.7,403,147.8,403,153.9z"/>
  				<path class="Shade_x0020_11" d="M405.1,118.6c0,0,8.2-31,21.8-31c10.6,0,16.4,21,20.8,35.6c1.1,3.7,3.3,18.2,2,15.5
  					c-5.6-12-7.8-10.2-11.8-22.7c-15.3-48.1-29.6,0.3-34.3,11.1L405.1,118.6z"/>
  				<path class="Highligh_x0020_10" d="M406.2,149.4c0,0,4.5-26.1,17-30.9c5.9-2.3,7.2,7.5,11.6,14.2c4.3,6.8,9.4,10.5,10.5,14
  					c1.1,3.5-3.8,6.4-9.4,5.5c-5.6-0.9-7.8,0.8-12.5,0.2C418.6,151.9,403,155.4,406.2,149.4z"/>
  				<path class="st77" d="M416,154.9l1.8-0.3l2.4,0.3c0,0-1.1-10.1-2.1-10.1C417.3,144.8,417.6,154.8,416,154.9z"/>
  				<path class="st77" d="M431.2,154.9l1.7-0.3l2.4,0.3c0,0-1.1-10.1-2.1-10.1C432.5,144.8,432.8,154.8,431.2,154.9z"/>
  			</g>
  		</g>
  	</g>
  	<g id="k1">
  		<g id="t18">
  			<path class="st1" d="M59.3,22.2c-1.4,0-12.2,3.2-12.2,33.1c0,9.9,0.6,32.4,0.6,39.8c0,4.8-4.7,27.3-4.7,31.2c0,6.5,40.1,0,40.1,0
  				s-5.5-21.5-5.5-28.1c0-6.6,5.5-25,5.5-35.4c0-10.4-10.7-35-10.7-37.2c0-2.2-1.9-3.8-2.8-3.8c-0.9,0-3.9,2.5-3.9,8.7
  				s1.5,15,1.5,20.9c0,5.9-3.6,20.4-3.6,20.4s-6.1-23-6.1-28.5c0-5.4,3.9-12.7,3.9-16.1C61.4,23.9,60.9,22.2,59.3,22.2z"/>
  			<g>
  				<path class="st70" d="M69.5,21.9c0,0-1.8,3.8-1,7.8c0.8,4,3,21.4,3,26.5c0,2-6.3,18.1-7.9,29.8c0,0-0.7-11.5,0-14
  					c0,0,3.6-15.9,3.6-21.1c0-5.2-1.5-14.5-1.5-21.2C65.6,23,69.5,21.9,69.5,21.9z"/>
  				<path class="st72" d="M67.4,54.3c0,0,0,0.1-0.1,0.4c-0.4,3.7-3.6,30-4.1,33.3c-0.5,3.6,0.1,5.6,0.1,5.6s-0.9-6.5-0.3-14.7
  					c0.7-8.2-4.1-15-5.8-32.7c0,0,5.5,24.1,6,25.1"/>
  				<path class="st70" d="M57.3,22.8c0,0-6.4,11.2-6.7,21.9c-0.3,10.7,3.4,36.9,3.4,45s-9.5,38.5-9.5,38.5l-1.5-0.6
  					c0,0,4.8-27.8,4.8-31.5c0-3.8-0.4-35.3-0.4-48.5C47.4,30.8,57.3,22.8,57.3,22.8z"/>
  			</g>
  			<g>
  				<path class="st71" d="M40.4,133.3c0,12.9,4.4,19.6,8.3,19.6c1.2,0,9-4.8,9.6-4.8c1.8,0,11.2,7.2,13.5,7.2c2.3,0,4.5-2.6,5.5-3
  					c1-0.4,9-3.4,9-10.1c0-6.7-4.1-33.2-25.9-33.2C56.4,109,40.4,115.9,40.4,133.3z"/>
  				<path class="st75" d="M64.2,128.2c0,0-5.1,2-5.5,8.9c-0.4,6.9-1.3,8.9,0.6,11.3c0,0-1.4-1.4-2.9,0.5c0,0,1.4-4,1-7.7
  					c-0.4-3.8,0.9-7.3-2.4-10.3c0,0,2.8,1,3.2,3C58.4,133.9,59.2,130.2,64.2,128.2z"/>
  				<path class="Highligh_x0020_9" d="M56.4,138.3c0,0,0.9-3.2-2.5-6.2c-3.4-3-6.5-7.3-7.8-6.1c-1.2,1.2-3.2,12-2.5,14.8
  					c0.8,2.8,1.2,7.9,3.8,8.7c2.5,0.9,7-0.6,7.8-2.1C55.9,145.9,56.5,140.8,56.4,138.3z"/>
  				<path class="st76" d="M64.2,130.9c0,0-1.8,3.9-1.8,8.6c0,3,0.8,9.4,4,11.2c1.5,0.8,5.8,3.8,7,2.3c1.3-1.5,4.1-3.2,6-4
  					c1.9-0.8,5.5-4.6,5.3-6.8c-0.3-2.2-0.8-10.4-4-14C77.5,124.6,66.7,125.1,64.2,130.9z"/>
  				<path class="st78" d="M75.9,119.2c0,0-11,4.8-13.9,7.8c-2.9,2.9-9.9-6.2-11.2-7.8c-1.4-1.6,6.8-11.3,17.8-6.7
  					C77.6,116.2,75.9,119.2,75.9,119.2z"/>
  				<path class="Shade_x0020_10" d="M45.5,118c0,0-5.2,8.3-5.2,14.1c0,5.8,2.1,20.7,7.9,20.7c5.8,0,6.9-4.2,10-4.9
  					c3-0.7,11.3,8,13.5,7.3c2.1-0.6,9.2-4.8,9.6-5.1s-7.1,3.3-8.9,3.2c-1.8-0.1-11.7-7.3-14.2-7.3s-6.7,3.8-10,3.8
  					c-3.3,0-6.4-5-6.4-16.7C41.9,128.9,45.5,118,45.5,118z"/>
  			</g>
  			<g>
  				<path class="st71" d="M57.5,43.4c0-4.2,2.4-9.6,3.4-13.4c0.2,0.3,0.3,0.7,0.3,1.2c0,1.4-0.5,9.8-0.5,9.8
  					c0,4.5,2.8,14.8,4.9,21.5c-1,4.9-2,9.3-2,9.3S57.5,48.9,57.5,43.4z"/>
  			</g>
  		</g>
  		<g id="t17_1_">
  			<path class="st1" d="M107.3,22.2c-1.4,0-12.2,3.2-12.2,33.1c0,9.9,0.6,32.4,0.6,39.8c0,4.8-4.7,27.3-4.7,31.2
  				c0,6.5,40.1,0,40.1,0s-5.5-21.5-5.5-28.1c0-6.6,5.5-25,5.5-35.4c0-10.4-10.7-35-10.7-37.2c0-2.2-1.9-3.8-2.8-3.8
  				s-3.9,2.5-3.9,8.7s1.5,15,1.5,20.9c0,5.9-3.6,20.4-3.6,20.4s-6.1-23-6.1-28.5c0-5.4,3.9-12.7,3.9-16.1
  				C109.4,23.9,108.9,22.2,107.3,22.2z"/>
  			<g>
  				<path class="st70" d="M117.5,21.9c0,0-1.8,3.8-1,7.8c0.8,4,3,21.4,3,26.5c0,2-6.3,18.1-7.9,29.8c0,0-0.7-11.5,0-14
  					c0,0,3.6-15.9,3.6-21.1c0-5.2-1.5-14.5-1.5-21.2C113.6,23,117.5,21.9,117.5,21.9z"/>
  				<path class="st72" d="M115.4,54.3c0,0,0,0.1-0.1,0.4c-0.4,3.7-3.6,30-4.1,33.3c-0.5,3.6,0.1,5.6,0.1,5.6s-0.9-6.5-0.3-14.7
  					c0.7-8.2-4.1-15-5.8-32.7c0,0,5.5,24.1,6,25.1"/>
  				<path class="st70" d="M105.3,22.8c0,0-6.4,11.2-6.7,21.9c-0.3,10.7,3.4,36.9,3.4,45s-9.5,38.5-9.5,38.5l-1.5-0.6
  					c0,0,4.8-27.8,4.8-31.5c0-3.8-0.4-35.3-0.4-48.5C95.4,30.8,105.3,22.8,105.3,22.8z"/>
  			</g>
  			<g>
  				<path class="st71" d="M88.4,133.3c0,12.9,4.4,19.6,8.3,19.6c1.2,0,9-4.8,9.6-4.8c1.8,0,11.2,7.2,13.5,7.2s4.5-2.6,5.5-3
  					c1-0.4,9-3.4,9-10.1c0-6.7-4.1-33.2-25.9-33.2C104.4,109,88.4,115.9,88.4,133.3z"/>
  				<path class="st75" d="M112.3,128.2c0,0-5.1,2-5.5,8.9c-0.4,6.9-1.3,8.9,0.6,11.3c0,0-1.4-1.4-2.9,0.5c0,0,1.4-4,1-7.7
  					c-0.4-3.8,0.9-7.3-2.4-10.3c0,0,2.8,1,3.2,3C106.4,133.9,107.3,130.2,112.3,128.2z"/>
  				<path class="Highligh_x0020_10" d="M104.4,138.3c0,0,0.9-3.2-2.5-6.2c-3.4-3-6.5-7.3-7.8-6.1c-1.2,1.2-3.2,12-2.5,14.8
  					c0.8,2.8,1.2,7.9,3.8,8.7c2.5,0.9,7-0.6,7.8-2.1C103.9,145.9,104.5,140.8,104.4,138.3z"/>
  				<path class="st76" d="M112.3,130.9c0,0-1.8,3.9-1.8,8.6c0,3,0.8,9.4,4,11.2c1.5,0.8,5.8,3.8,7,2.3c1.2-1.5,4.1-3.2,6-4
  					c1.9-0.8,5.5-4.6,5.3-6.8c-0.3-2.2-0.8-10.4-4-14C125.5,124.6,114.8,125.1,112.3,130.9z"/>
  				<path class="st78" d="M123.9,119.2c0,0-11,4.8-13.9,7.8c-2.9,2.9-9.9-6.2-11.2-7.8c-1.4-1.6,6.8-11.3,17.8-6.7
  					C125.6,116.2,123.9,119.2,123.9,119.2z"/>
  				<path class="Shade_x0020_11" d="M93.5,118c0,0-5.2,8.3-5.2,14.1c0,5.8,2.1,20.7,7.9,20.7c5.8,0,6.9-4.2,10-4.9
  					c3-0.7,11.3,8,13.5,7.3c2.1-0.6,9.2-4.8,9.6-5.1s-7.1,3.3-8.9,3.2c-1.8-0.1-11.7-7.3-14.2-7.3s-6.7,3.8-10,3.8
  					c-3.3,0-6.4-5-6.4-16.7C89.9,128.9,93.5,118,93.5,118z"/>
  			</g>
  			<g>
  				<path class="st71" d="M105.5,43.4c0-4.2,2.4-9.6,3.4-13.4c0.2,0.3,0.3,0.7,0.3,1.2c0,1.4-0.5,9.8-0.5,9.8
  					c0,4.5,2.8,14.8,4.9,21.5c-1,4.9-2,9.3-2,9.3S105.5,48.9,105.5,43.4z"/>
  			</g>
  		</g>
  		<g id="t16">
  			<path class="st1" d="M183.1,76c0-9.3-10.1-36.9-10.1-45.1c0-4.3-2.3-7.3-3.5-7.3c-3.1,0-5.1,14-5.1,17c0,9.4,1.5,22.2,1.5,25.8
  				c0,3.6-3.6,15.4-6.1,15.4c-3.6,0-11.8-16.3-12.2-47.7c0-1.7,0.6-4.2,0.6-6.7c0-1.2-1.3-4-2.4-4c-2.3,0-8,17-8,50.6
  				c0,7.3,7,34.4,5,43h35.6c0,0-0.3-1.5-0.3-6.8C178,104.9,183.1,84.2,183.1,76z"/>
  			<g>
  				<path class="Shade_x0020_11" d="M168.8,24.8c0,0-2.2,10.2-2.2,15.2c0,4.9,2.2,17,2.2,27.1s-6.3,20.7-9.3,22.6
  					c0,0-8.3-8.3-9.5-29.9c0,0,4.6,21.7,10.1,21.7c2.9,0,6.2-14.5,6.2-15.4c0-0.8-2-20-2-24.9C164.3,36.4,166.4,25,168.8,24.8z"/>
  				<path class="st79" d="M163.8,77c-3,6.7-2,12.2-4.3,15.3c0,0-1.1-8.9-3.8-15.3c0,0,2.5,4.9,3.8,4.9C160.8,82,163.8,77,163.8,77z"
  					/>
  				<path class="st70" d="M177,49.2c0,0,6.1,20.9,6.1,26.9c0,5.9-4.8,21.3-4.8,42h-9.5C168.7,118,183.7,89.7,177,49.2z"/>
  				<path class="st70" d="M142.4,29.6c0,0-2.1,27.2-1.1,43.7s9.7,42,9.7,42l-7.1-1.7c0,0-1.5-13.3-2.2-14.4c-0.7-1.1-4-20-4-25.4
  					S139.1,32.3,142.4,29.6z"/>
  			</g>
  			<g>
  				<path class="st71" d="M136,134.4c0,0-0.4,6.6,2.4,9.5c2.9,2.9,7.1,7.1,7.1,7.1c0.3,0.4,1.4,1.6,2.3,1.6c0.9,0,8.6-6,9.3-6
  					c0.7,0,8.7,8.8,14.9,8.8c2.1,0,4.2-2.8,5.7-3.4c1.5-0.5,8-2.4,8-9.1c0-4.8-3.4-9.6-8.1-28c-1.8-6.8-14.4-16.3-18.7-16.3
  					C146.5,98.5,136,122.5,136,134.4z"/>
  				<path class="Shade_x0020_11" d="M153.9,102c0,0-4.8,5.7-5.1,8.3c-0.4,2.7-2.2,8.8-5.9,12.5c-3.6,3.8-6,14.3-3.9,18.2
  					c2.1,3.9,6,8.6,6,8.6s-6.7-4.7-7.8-7.7c-1.2-2.9-1-6.2-1-9.8c0,0,1.7-22.3,17.7-32.3C153.9,99.8,157,97.8,153.9,102z"/>
  				<path class="Shade_x0020_11" d="M158.3,144.3c0,0,0.6-5.4,0.6-8.4c0-2.9,1.3-7,4-8.9c2.8-1.8,1.8-1.8,1.8-1.8s-5.7,1.9-6.7,5.6
  					c0,0-3.5-3.2-7.8-4c0,0,5.2,3,6.4,6.6c1.1,3.6,0.7,9-0.2,10.8c-0.8,1.8-6.9,6.7-8.3,7.3c-1.4,0.6,1.8,0.1,8-4.9
  					c0.3-0.3,0.9-0.4,0.9-0.4s3.4,3.8,5.6,4.7C164.8,151.8,159.8,149,158.3,144.3z"/>
  				<path class="st73" d="M162.6,122.4c0,0-3.8,2.2-4.8,3.9c-1,1.7-3.1-0.2-5.4-1c-2.2-0.8-2.8-4.6-2.4-7.1
  					c0.4-2.5,2.8-7.5,6.2-10.8c3.4-3.3,2.8-1.6,3.6,0.8C160.6,110.5,166.1,119.9,162.6,122.4z"/>
  				<path class="Highligh_x0020_10" d="M164.8,127.9c0,0-4,2.1-4.5,4.3c-0.5,2.2-0.4,6.6,0,9.4c0.4,2.8,1.9,5.5,3.4,7.4
  					c5.8,7.1,10.9,3,12.4,1.8c1.5-1.3,9.7-3.6,5.8-12.3c-1.5-3.3-7.4-11.7-9-12.2C171.3,125.7,166.4,126.9,164.8,127.9z"/>
  				<path class="st76" d="M156.9,139.5c0,0-0.5,4.2-6.9,10c-2.9,2.7-4.3-0.7-4.3-0.7c0,0-3.6-4.8-4.2-10.4
  					c-0.6-5.6-0.1-12.5,2.9-12.5c1.8,0,7.1,2.5,8.6,4.1C154.5,131.6,156.6,132.6,156.9,139.5z"/>
  				<path class="st29" d="M143.1,111.1c0,0-7.1,16.8-7.1,24.4c0,7.6,10.9,17.1,11.8,17.1s9.5-5.9,9.5-5.9s10.8,8.7,14.7,8.7
  					c3.9,0,5.7-3.4,5.7-3.4s7.2-3.2,8-7.6c0,0-6.3,3.4-9.7,6.3c-3.4,2.9-15.5-2.8-18.4-5.9c-1.2-1.3-1.5,0-2.5,1c-1,1-6,4-7.4,4.1
  					c-1.4,0.1-9.5-7.6-9.5-14.8C138.3,127.8,142.4,113.1,143.1,111.1z"/>
  			</g>
  			<g>
  				<g>
  					<g>
  						<path class="st71" d="M165.9,66.3c0,3.6-3.6,15.4-6.1,15.4c-2.9,0-8.9-10.9-11.3-32c1.3-12.4,3-23.4,3.5-25.6
  							c0.8-3.9,2.8-3.7,2.8-3.7c0.5,0,0.9,0.1,1.3,0.3c4.2,1.9,5,13,6.3,16.2c0.4,1,1.2,2.1,2,3.2c0,0.1,0,0.3,0,0.4
  							C164.4,50,165.9,62.7,165.9,66.3z"/>
  					</g>
  					<g>
  						<path class="st79" d="M159.8,81.7c-2.7,0-8.1-9.4-10.8-27.8c3.2,14.1,9.2,21.7,10.1,22c1,0.4,3.2-5.1,4.6-10.9
  							c1.3-5.6,0.8-18,0.8-18.8c0.4,8.3,1.4,17.2,1.4,20.1C165.9,69.9,162.4,81.7,159.8,81.7z"/>
  					</g>
  				</g>
  				<path class="Shade_x0020_11" d="M155.6,20.5C155.6,20.5,155.6,20.5,155.6,20.5c0,0.2-4.9,23.2-2.2,49.6c-1.6-5-3.1-11.5-4-19.6
  					c0.1-1.6,0.2-3.2,0.4-4.8c1-8.5,2-15.8,2.7-19.4C153.2,22.7,154.3,20.5,155.6,20.5z"/>
  			</g>
  		</g>
  		<g id="t15">
  			<path class="st1" d="M206.3,22.8c-2.6,0-4.4,4.2-4.4,6c0,2,0.5,4.1,0.5,10.7c0,8.1-4.5,23.1-4.9,28c-0.3,3.2-5.3,62.6-5.3,62.6
  				h26.6c0,0,0.4-27.1,0.4-40C219.2,63.6,215.3,22.8,206.3,22.8z"/>
  			<g>
  				<path class="st70" d="M203.7,30.1c0,0,2.7,10,3,26.9c0.3,17-7.5,56.4-7.5,56.4l-6.5,2l2.4-25l2.6-25.9c0,0,4.6-16.3,4.6-20.4
  					C202.3,40.2,202,28.7,203.7,30.1z"/>
  				<path class="st70" d="M216.2,124c0,0-0.1-74.7-1.4-82.8c0,0,4.2,26.2,4.3,38.1c0.1,11.9-0.2,45.8-0.2,45.8L216.2,124z"/>
  			</g>
  			<g>
  				<path class="st71" d="M206,106.5c-5.7,0-17.8,16.4-17.8,31.7c0,8.5,4,6.2,7.8,9.7c3.8,3.6,7.7,7.4,10.7,7.4
  					c1.6,0,16.9-5.1,16.9-11.6C223.6,136.9,215.9,106.5,206,106.5z"/>
  				<path class="Shade_x0020_11" d="M203.7,107.2c0,0-3.9,6.9-4.3,9.9c-0.3,3-2.1,9.4-1.9,16.7c0.2,7.3,4.7,13.7,3.4,15.5
  					c-1.8,2.4-4.9-3.2-7.9-3.4c-3-0.2-5.2-4.8-4.3-12.2C189.5,126.4,193.3,113.3,203.7,107.2z"/>
  				<path class="Highligh_x0020_10" d="M205,114.4c0,0-3.7,7.5-2.5,14.2c1.2,6.7,0.7,13.3,1,16.9c0.3,3.6,1.5,7.4,4.3,7.4
  					c2.2,0,5-4,7.2-6.5c2.2-2.5,4.3-4,4.3-8.2C219.3,135.6,209.2,102.4,205,114.4z"/>
  			</g>
  		</g>
  		<g id="t14">
  			<path class="st1" d="M254,79.7c0,4.6,1.1,43.9,1.1,43.9s-25.7,5.7-24.7,0c0.6-3.5,0.3-48,0.3-55.6c0-19,4.6-37.4,4.6-43.7
  				c0-1.7,0.5-3.3,1.9-3.3C245.4,21,254,64,254,79.7z"/>
  			<g>
  				<path class="st70" d="M236.1,27.2c0,0,2.3,26.6,2,29.7l-1,50.4l-6.4,6.2l0.1-26.9c0,0-0.7-30.1,1.3-36.5
  					C234,43.7,235,27.6,236.1,27.2z"/>
  				<path class="st70" d="M246.1,39.2c0,0,8.1,21.3,8.1,47.5c0,16.7,0,29.5,0,29.5l-3.2-9.9C251,106.2,249.9,52.4,246.1,39.2z"/>
  			</g>
  			<g>
  				<path class="st71" d="M242.7,101.9c-4.1,0-8.8,2.4-13.1,17.9c-3,10.8-4.5,14-4.5,18.5c0,4.5,0.9,9.8,10.3,12.8
  					c4.7,1.5,5.9,4.3,8.7,4.3c3.8,0,8.1-4.1,11.1-4.9c3-0.8,7.3-2.9,7.3-9.9C262.4,134.7,252.7,101.9,242.7,101.9z"/>
  				<path class="Shade_x0020_11" d="M242.5,104.5c0,0-3.8,1.9-4.7,6.9c-0.8,5-6.3,13.6-6.5,14.6c-0.2,1-1.4,12.3,2,16.7
  					c3.3,4.4,7.7,6.7,9.2,8.2c1.5,1.5,5.5-1.3,7.7-1.7c2.2-0.4,4.7-3.1,7.3-2.5c2.6,0.6,2.1,2-0.9,3.1c-3,1.1-10.6,5.4-12.6,5.4
  					c-2,0-10.3-5.8-13.3-6.3c-3-0.5-5.6-8.1-5.6-10.7c0-2.6,8-36.3,16.3-36.3S242.5,104.5,242.5,104.5z"/>
  				<path class="Highligh_x0020_10" d="M247.5,106.5c0,0,6.3,10.4,7.8,16.1c1.5,5.6,1.8,8.9,1.7,12.4c-0.2,3.5,0,4.8-4.7,7.5
  					c-4.8,2.7-6.6,6.5-8.5,5.4s-1.6-13.2-1.6-19.3c0-6,0.2-10,0-13.4C242,111.9,244,104.4,247.5,106.5z"/>
  			</g>
  		</g>
  		<g id="t13">
  			<path class="st1" d="M276.8,19.8c-1.3,0-2.1,0.9-2.1,2c0,1.2,2.1,10.4,2.1,13.2c0,2.8-4.9,29.1-4.9,38.7c0,9.6,2.3,35.3,2.3,35.3
  				H298c0.2-19.3,0.2-19.2,0.2-23.4c0-17.1-4.8-24.5-5.1-29.6C292.6,45.8,284.1,19.8,276.8,19.8z"/>
  			<g>
  				<path class="st70" d="M276.3,20.8c0,0,6.4,26.3,5.4,33.5c-1,7.2-3.5,30.6-2.6,41.7c0.9,11.1-2.8,17.7-2.8,17.7l-1.8-3.6
  					l-1.2-14.9c0,0-1.4-17.8-1.4-24.5c0-6.7,4.8-33.9,4.8-38.1C276.8,28.4,275.8,18.5,276.3,20.8z"/>
  				<path class="st70" d="M293.9,58.2c0,0,1.4,46.6-2.4,59.9c-0.9,3.1,0,1.3,0,1.3l5.9,0.6c0,0,0.7-22.9,0.7-32.4
  					C298.1,72.2,293.9,58.2,293.9,58.2z"/>
  			</g>
  			<g>
  				<path class="st71" d="M285.8,87.6c-7.5,0-15.2,12.5-15.2,23.7c0,4.9-7,19-7,24.3c0,5.7,9,10.8,9,10.8s7.4,8.9,12.4,8.9
  					c6.7,0,13.1-6.2,13.1-6.2s8.1-2.4,8.1-5.6C306.2,140.2,300.4,87.6,285.8,87.6z"/>
  				<path class="Shade_x0020_11" d="M280.2,151.3c-1.3-5.6-4.2-10-6-10.9c-5.6-2.9-6.2-5-6.2-5.2c-0.8-11.2,7.8-22.1,7.6-25.9
  					c-0.2-3.8,5.3-14.4,8.2-15c2.8-0.6,8,0,10.5,7.5c0.8,2.4,8.2,34.6,9,38.6c0.8,4.1,2.5,5,2.8,4c0.3-1,0-4.1-0.2-6.2
  					c-0.3-2-7-50.6-19.9-50.6c-12.9,0-14.5,19-14.5,22c0,0-2.9,10-4.3,13.7c-1.3,3.7-5.7,12.4-2,16.3c3.7,3.9,6.6,5.7,7.6,6.7
  					C273.5,147.5,281.3,156.2,280.2,151.3z"/>
  				<path class="Highligh_x0020_10" d="M301.5,143.3c0,0-3.9-0.4-6.2,1.2c-2.3,1.6-3.1,6-8.1,6.1c-5,0.2-2.3-6.5-2.3-12.1
  					c0-5.5,1.3-17.5,1.8-21.5c0.5-3.9,0.8-15,1.5-16.7c0.7-1.8,3.8,3.2,4.9,7.9C294.2,113,304.5,140.8,301.5,143.3z"/>
  			</g>
  		</g>
  		<g id="t12">
  			<path class="st1" d="M324,26.6c-0.9-1.5-1.6-1.8-2.2-3c-0.7-1.2-1.9-3.6-3.9-3.6c0,0-2,0.2-2,2.8c0,2.7,0,22.3,0,23.6
  				c0,3.2-3.1,13.4-3.1,25.6c0,10,0.6,44.1,1.3,53.4h25C339,125.3,339.1,53.3,324,26.6z"/>
  			<g>
  				<path class="st70" d="M316.9,20.1c0,0,4.5,32.1,5.8,43.6c1.3,11.4-1.9,52.3-1.7,56.3c0.2,4-5.3,6.4-7,5.2
  					c-1.7-1.2,0-20.1,0-20.1s-1.3-31.9-1.3-34.6c0-2.7,3.1-21.5,3.1-26.2C315.8,39.6,314.1,21.1,316.9,20.1z"/>
  				<path class="st70" d="M330.8,44.7c0,0,7.5,34.2,8,68c0.1,8.6,0.1,11.1-2.9,9.3c0,0-4.4-3-4-8.2
  					C332.3,108.4,333.6,57.8,330.8,44.7z"/>
  			</g>
  			<g>
  				<path class="st71" d="M347.9,148.3c0,3.6-1.2,5.2-3.6,5.2c-3.6,0-6.8,0.5-7.8,0.5s-4.2,1.3-6.7,1.3c-3.7,0-6-2.7-7.2-2.7
  					c-2.2,0-14.1-0.1-14.1-16.7c0-14,12.5-40.7,19-40.7C337.5,95.2,347.9,136.5,347.9,148.3z"/>
  				<path class="Shade_x0020_11" d="M343.4,123.7c0,0-6.9-19.5-15.1-20.6s-13.6,16.6-14.3,22.1c-2,16.2,4.4,25.1,6.3,26.9
  					c0,0-7.2-2.4-8.6-5.6c-2.4-5.2-5.7-17.9,3.6-35.4C324.5,93.7,328,95,329,95.5C330.1,96.1,339.9,102.2,343.4,123.7z"/>
  				<path class="Highligh_x0020_10" d="M346.3,148c0,0-8.4-21.9-17.5-21.9c-9,0-14.2,14-10.9,18.8c3.3,4.8,8.8,8.6,12,8
  					c3.2-0.7,8.3-0.8,11.5-0.8C344.7,152.2,347.8,151.5,346.3,148z"/>
  				<path class="st70" d="M326.2,150.9c0,0-3.6-2.2-4.3-7.4c0,0-1.1,4.6-0.9,6.8C321.2,152.6,328.9,153.8,326.2,150.9z"/>
  			</g>
  		</g>
  		<g id="t11">
  			<path class="st1" d="M391.2,120.5c2-6.5-1.5-13.2-1.5-19.4c0-40-14.7-81.7-25.3-81.7c-0.6,0-2,0.6-2,1.8c0,2.3,0.8,2.6,0.8,5.5
  				c0,6.6-6.7,26.7-6.7,41.3c0,7.1,0.6,27.9,0.3,31.9c-0.3,4-4.1,29.3-4.1,29.3L391.2,120.5z"/>
  			<g>
  				<g>
  					<path class="st70" d="M365.2,19.4c0,0,4.2,14.4,5.3,30.9c1,16.5,2,59.4,0,65.9c-2,6.5-13.2,9.9-13.9,5.8
  						c-0.7-4.1,0.2-16.9,0.2-22.9c0.1-6-0.2-21.2-0.2-28.5c0-14.9,6.6-43.7,6.6-46.5S362,19.8,365.2,19.4z"/>
  					<path class="st70" d="M382.8,49c0,0,4.7,53.2,1.3,63.6c0,0,1.5,9.3,3.9,3.6s1.9-13.1,1.8-17.7C389.6,93.9,386.5,52.8,382.8,49z
  						"/>
  				</g>
  			</g>
  			<g>
  				<path class="st71" d="M397,153.9c0,0-8.9,2.1-14.8,0.7c0,0-9.8,1.6-15.4-0.1c0,0-11.6,0.7-14.4-1.7c-2.8-2.4-2.9-9.2-2.9-11.9
  					c0-15.3,11.8-53.8,22.9-53.8c10.5,0,24.5,22.2,24.5,49.5C396.9,141.7,397,147.8,397,153.9z"/>
  				<path class="Shade_x0020_11" d="M394.9,118.6c0,0-8.2-31-21.8-31c-10.6,0-16.4,21-20.8,35.6c-1.1,3.7-3.3,18.2-2,15.5
  					c5.6-12,7.8-10.2,11.8-22.7c15.3-48.1,29.6,0.3,34.3,11.1L394.9,118.6z"/>
  				<path class="Highligh_x0020_10" d="M393.8,149.4c0,0-4.5-26.1-17-30.9c-5.9-2.3-7.2,7.5-11.6,14.2c-4.3,6.8-9.4,10.5-10.5,14
  					c-1.1,3.5,3.8,6.4,9.4,5.5c5.6-0.9,7.8,0.8,12.5,0.2C381.3,151.9,397,155.4,393.8,149.4z"/>
  				<path class="st77" d="M384,154.9l-1.7-0.3l-2.4,0.3c0,0,1.1-10.1,2.1-10.1C382.7,144.8,382.4,154.8,384,154.9z"/>
  				<path class="st77" d="M368.8,154.9l-1.7-0.3l-2.4,0.3c0,0,1.1-10.1,2.1-10.1C367.5,144.8,367.2,154.8,368.8,154.9z"/>
  			</g>
  		</g>
  	</g>
  </g>
  <g id="numbers">
  	<g id="numbers_x5F_k4">
  		<g id="n48">
  			<g>
  				<path class="st80" d="M60.2,206.9h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M57.6,205.8v-3.3c0-0.7,0-1.4,0.1-2.2
  					h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H57.6z"/>
  				<path class="st80" d="M64.4,199c0.9,0,1.6,0.2,2.2,0.6c0.5,0.4,0.8,1,0.8,1.8c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.4-0.8,0.8-1.5,1.1
  					c0.8,0.4,1.4,0.8,1.7,1.2c0.3,0.4,0.5,0.9,0.5,1.5c0,0.8-0.3,1.5-0.9,2c-0.6,0.5-1.4,0.7-2.4,0.7c-1.1,0-1.9-0.2-2.5-0.7
  					c-0.6-0.5-0.9-1.1-0.9-2c0-1.1,0.7-2,2.1-2.7c-0.6-0.4-1.1-0.7-1.4-1.2c-0.3-0.4-0.4-0.9-0.4-1.4c0-0.7,0.3-1.3,0.8-1.7
  					C62.8,199.2,63.6,199,64.4,199z M62.3,206.6c0,0.5,0.2,1,0.6,1.3c0.4,0.3,0.9,0.5,1.6,0.5c0.7,0,1.2-0.2,1.6-0.5
  					c0.4-0.3,0.6-0.8,0.6-1.3c0-0.4-0.2-0.8-0.5-1.2c-0.4-0.3-1-0.7-1.9-1c-0.7,0.3-1.2,0.6-1.5,1C62.4,205.7,62.3,206.2,62.3,206.6
  					z M64.4,200c-0.6,0-1,0.1-1.3,0.4c-0.3,0.3-0.5,0.6-0.5,1.1c0,0.4,0.1,0.8,0.4,1.1c0.3,0.3,0.8,0.6,1.5,0.9
  					c0.7-0.3,1.1-0.6,1.4-0.9c0.3-0.3,0.4-0.7,0.4-1.1c0-0.5-0.2-0.8-0.5-1.1C65.5,200.1,65,200,64.4,200z"/>
  			</g>
  		</g>
  		<g id="n47">
  			<g>
  				<path class="st80" d="M119.9,206.9h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M117.3,205.8v-3.3
  					c0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H117.3z"/>
  				<path class="st80" d="M122.1,209.2l4.1-8.9h-5.4v-1h6.7v0.9l-4.1,9.1H122.1z"/>
  			</g>
  		</g>
  		<g id="n46">
  			<g>
  				<path class="st80" d="M180.7,206.9h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M178.1,205.8v-3.3
  					c0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H178.1z"/>
  				<path class="st80" d="M181.8,204.9c0-2,0.4-3.4,1.1-4.4c0.8-1,1.9-1.5,3.4-1.5c0.5,0,0.9,0,1.2,0.1v1c-0.4-0.1-0.8-0.2-1.2-0.2
  					c-1.1,0-1.9,0.3-2.5,1c-0.6,0.7-0.9,1.7-0.9,3.1h0.1c0.5-0.8,1.3-1.2,2.4-1.2c0.9,0,1.6,0.3,2.1,0.8c0.5,0.5,0.8,1.3,0.8,2.2
  					c0,1-0.3,1.9-0.9,2.5c-0.6,0.6-1.3,0.9-2.3,0.9c-1,0-1.9-0.4-2.5-1.2C182.1,207.4,181.8,206.3,181.8,204.9z M185.2,208.3
  					c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.5-1,0.5-1.8c0-0.7-0.2-1.2-0.5-1.6c-0.3-0.4-0.8-0.6-1.5-0.6c-0.4,0-0.8,0.1-1.1,0.3
  					c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.3,0.9c0,0.5,0.1,0.9,0.3,1.3s0.4,0.7,0.8,1C184.3,208.2,184.7,208.3,185.2,208.3z
  					"/>
  			</g>
  		</g>
  		<g id="n45">
  			<g>
  				<path class="st80" d="M233.1,206.9h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M230.5,205.8v-3.3
  					c0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H230.5z"/>
  				<path class="st80" d="M237.2,203.1c1.1,0,1.9,0.3,2.5,0.8c0.6,0.5,0.9,1.2,0.9,2.1c0,1-0.3,1.8-1,2.4c-0.7,0.6-1.6,0.9-2.7,0.9
  					c-1.1,0-2-0.2-2.6-0.5v-1.1c0.3,0.2,0.7,0.4,1.2,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.8,0,1.4-0.2,1.9-0.6c0.4-0.4,0.7-0.9,0.7-1.6
  					c0-1.4-0.9-2.1-2.6-2.1c-0.4,0-1,0.1-1.7,0.2l-0.6-0.4l0.4-4.7h5v1h-4l-0.3,3C236.1,203.1,236.6,203.1,237.2,203.1z"/>
  			</g>
  		</g>
  		<g id="n44">
  			<g>
  				<path class="st80" d="M273.4,206.9h-1.5v2.3h-1.1v-2.3H266v-1l4.7-6.8h1.2v6.7h1.5V206.9z M270.8,205.8v-3.3
  					c0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H270.8z"/>
  				<path class="st80" d="M281.4,206.9h-1.5v2.3h-1.1v-2.3H274v-1l4.7-6.8h1.2v6.7h1.5V206.9z M278.8,205.8v-3.3
  					c0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H278.8z"/>
  			</g>
  		</g>
  		<g id="n43">
  			<g>
  				<path class="st80" d="M313.6,206.9h-1.5v2.3H311v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M311,205.8v-3.3c0-0.7,0-1.4,0.1-2.2
  					H311c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H311z"/>
  				<path class="st80" d="M320.7,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8
  					c0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1
  					c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5
  					c0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7
  					l-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C320.4,200.1,320.7,200.8,320.7,201.5z"/>
  			</g>
  		</g>
  		<g id="n42">
  			<g>
  				<path class="st80" d="M348.5,206.9H347v2.3h-1.1v-2.3H341v-1l4.7-6.8h1.2v6.7h1.5V206.9z M345.9,205.8v-3.3c0-0.7,0-1.4,0.1-2.2
  					h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H345.9z"/>
  				<path class="st80" d="M356,209.2h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1
  					c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8
  					c0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1
  					v0.1h5.1V209.2z"/>
  			</g>
  		</g>
  		<g id="n41">
  			<g>
  				<path class="st80" d="M381.8,206.9h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M379.3,205.8v-3.3
  					c0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H379.3z"/>
  				<path class="st80" d="M387,209.2h-1.1V202c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8
  					l2.6-2h1V209.2z"/>
  			</g>
  		</g>
  	</g>
  	<g id="numbers_x5F_k3_1_">
  		<g id="n38">
  			<g>
  				<path class="st80" d="M738.2,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8
  					c0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1
  					c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5
  					c0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7
  					l-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C738,200.1,738.2,200.8,738.2,201.5z"/>
  				<path class="st80" d="M743.4,199c0.9,0,1.6,0.2,2.2,0.6c0.5,0.4,0.8,1,0.8,1.8c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.4-0.8,0.8-1.5,1.1
  					c0.8,0.4,1.4,0.8,1.7,1.2c0.3,0.4,0.5,0.9,0.5,1.5c0,0.8-0.3,1.5-0.9,2c-0.6,0.5-1.4,0.7-2.4,0.7c-1.1,0-1.9-0.2-2.5-0.7
  					c-0.6-0.5-0.9-1.1-0.9-2c0-1.1,0.7-2,2.1-2.7c-0.6-0.4-1.1-0.7-1.4-1.2c-0.3-0.4-0.4-0.9-0.4-1.4c0-0.7,0.3-1.3,0.8-1.7
  					C741.8,199.2,742.5,199,743.4,199z M741.2,206.6c0,0.5,0.2,1,0.6,1.3c0.4,0.3,0.9,0.5,1.6,0.5c0.7,0,1.2-0.2,1.6-0.5
  					c0.4-0.3,0.6-0.8,0.6-1.3c0-0.4-0.2-0.8-0.5-1.2c-0.4-0.3-1-0.7-1.9-1c-0.7,0.3-1.2,0.6-1.5,1
  					C741.4,205.7,741.2,206.2,741.2,206.6z M743.4,200c-0.6,0-1,0.1-1.3,0.4c-0.3,0.3-0.5,0.6-0.5,1.1c0,0.4,0.1,0.8,0.4,1.1
  					c0.3,0.3,0.8,0.6,1.5,0.9c0.7-0.3,1.1-0.6,1.4-0.9c0.3-0.3,0.4-0.7,0.4-1.1c0-0.5-0.2-0.8-0.5-1.1
  					C744.4,200.1,743.9,200,743.4,200z"/>
  			</g>
  		</g>
  		<g id="n37">
  			<g>
  				<path class="st80" d="M678.6,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8
  					c0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1
  					c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5
  					c0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7
  					l-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C678.3,200.1,678.6,200.8,678.6,201.5z"/>
  				<path class="st80" d="M681.6,209.2l4.1-8.9h-5.4v-1h6.7v0.9l-4.1,9.1H681.6z"/>
  			</g>
  		</g>
  		<g id="n36">
  			<g>
  				<path class="st80" d="M617.7,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8
  					c0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1
  					c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5
  					c0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7
  					l-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C617.4,200.1,617.7,200.8,617.7,201.5z"/>
  				<path class="st80" d="M619.6,204.9c0-2,0.4-3.4,1.1-4.4c0.8-1,1.9-1.5,3.4-1.5c0.5,0,0.9,0,1.2,0.1v1c-0.4-0.1-0.8-0.2-1.2-0.2
  					c-1.1,0-1.9,0.3-2.5,1c-0.6,0.7-0.9,1.7-0.9,3.1h0.1c0.5-0.8,1.3-1.2,2.4-1.2c0.9,0,1.6,0.3,2.1,0.8c0.5,0.5,0.8,1.3,0.8,2.2
  					c0,1-0.3,1.9-0.9,2.5c-0.6,0.6-1.3,0.9-2.3,0.9c-1,0-1.9-0.4-2.5-1.2C619.9,207.4,619.6,206.3,619.6,204.9z M623,208.3
  					c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.5-1,0.5-1.8c0-0.7-0.2-1.2-0.5-1.6c-0.3-0.4-0.8-0.6-1.5-0.6c-0.4,0-0.8,0.1-1.1,0.3
  					c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.3,0.9c0,0.5,0.1,0.9,0.3,1.3c0.2,0.4,0.4,0.7,0.8,1
  					C622.2,208.2,622.6,208.3,623,208.3z"/>
  			</g>
  		</g>
  		<g id="n35">
  			<g>
  				<path class="st80" d="M565.3,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8
  					c0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1
  					c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5
  					c0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7
  					l-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C565.1,200.1,565.3,200.8,565.3,201.5z"/>
  				<path class="st80" d="M570.3,203.1c1.1,0,1.9,0.3,2.5,0.8c0.6,0.5,0.9,1.2,0.9,2.1c0,1-0.3,1.8-1,2.4c-0.7,0.6-1.6,0.9-2.7,0.9
  					c-1.1,0-2-0.2-2.6-0.5v-1.1c0.3,0.2,0.7,0.4,1.2,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.8,0,1.4-0.2,1.9-0.6c0.4-0.4,0.7-0.9,0.7-1.6
  					c0-1.4-0.9-2.1-2.6-2.1c-0.4,0-1,0.1-1.7,0.2l-0.6-0.4l0.4-4.7h5v1h-4l-0.3,3C569.2,203.1,569.8,203.1,570.3,203.1z"/>
  			</g>
  		</g>
  		<g id="n34">
  			<g>
  				<path class="st80" d="M525,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8
  					c0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1
  					c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5
  					c0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7
  					l-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C524.8,200.1,525,200.8,525,201.5z"/>
  				<path class="st80" d="M533.9,206.9h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M531.3,205.8v-3.3
  					c0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H531.3z"/>
  			</g>
  		</g>
  		<g id="n33">
  			<g>
  				<path class="st80" d="M484.9,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8
  					c0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1
  					c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5
  					c0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7
  					l-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C484.6,200.1,484.9,200.8,484.9,201.5z"/>
  				<path class="st80" d="M492.9,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8
  					c0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1
  					c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5
  					c0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7
  					l-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C492.6,200.1,492.9,200.8,492.9,201.5z"/>
  			</g>
  		</g>
  		<g id="n32">
  			<g>
  				<path class="st80" d="M450,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8
  					c0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1
  					c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5
  					c0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7
  					l-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C449.7,200.1,450,200.8,450,201.5z"/>
  				<path class="st80" d="M458.3,209.2h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1
  					c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8
  					c0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1
  					v0.1h5.1V209.2z"/>
  			</g>
  		</g>
  		<g id="n31">
  			<g>
  				<path class="st80" d="M416.6,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8
  					c0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1
  					c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5
  					c0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7
  					l-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C416.3,200.1,416.6,200.8,416.6,201.5z"/>
  				<path class="st80" d="M422.6,209.2h-1.1V202c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8
  					l2.6-2h1V209.2z"/>
  			</g>
  		</g>
  	</g>
  	<g id="numbers_x5F_k2">
  		<g id="n28">
  			<g>
  				<path class="st80" d="M735.9,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1
  					c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8
  					c0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1
  					v0.1h5.1V178.8z"/>
  				<path class="st80" d="M740.7,168.6c0.9,0,1.6,0.2,2.2,0.6c0.5,0.4,0.8,1,0.8,1.8c0,0.5-0.2,0.9-0.5,1.3
  					c-0.3,0.4-0.8,0.8-1.5,1.1c0.8,0.4,1.4,0.8,1.7,1.2s0.5,0.9,0.5,1.5c0,0.8-0.3,1.5-0.9,2c-0.6,0.5-1.4,0.7-2.4,0.7
  					c-1.1,0-1.9-0.2-2.5-0.7c-0.6-0.5-0.9-1.1-0.9-2c0-1.1,0.7-2,2.1-2.7c-0.6-0.4-1.1-0.7-1.4-1.2c-0.3-0.4-0.4-0.9-0.4-1.4
  					c0-0.7,0.3-1.3,0.8-1.7C739.1,168.9,739.8,168.6,740.7,168.6z M738.5,176.3c0,0.5,0.2,1,0.6,1.3c0.4,0.3,0.9,0.5,1.6,0.5
  					c0.7,0,1.2-0.2,1.6-0.5c0.4-0.3,0.6-0.8,0.6-1.3c0-0.4-0.2-0.8-0.5-1.2c-0.4-0.3-1-0.7-1.9-1c-0.7,0.3-1.2,0.6-1.5,1
  					C738.7,175.3,738.5,175.8,738.5,176.3z M740.7,169.6c-0.6,0-1,0.1-1.3,0.4c-0.3,0.3-0.5,0.6-0.5,1.1c0,0.4,0.1,0.8,0.4,1.1
  					c0.3,0.3,0.8,0.6,1.5,0.9c0.7-0.3,1.1-0.6,1.4-0.9c0.3-0.3,0.4-0.7,0.4-1.1c0-0.5-0.2-0.8-0.5-1.1
  					C741.7,169.7,741.3,169.6,740.7,169.6z"/>
  			</g>
  		</g>
  		<g id="n27">
  			<g>
  				<path class="st80" d="M687,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1
  					c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8
  					c0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1
  					v0.1h5.1V178.8z"/>
  				<path class="st80" d="M689.7,178.8l4.1-8.9h-5.4v-1h6.7v0.9l-4.1,9.1H689.7z"/>
  			</g>
  		</g>
  		<g id="n26">
  			<g>
  				<path class="st80" d="M639.2,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1
  					c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8
  					c0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1
  					v0.1h5.1V178.8z"/>
  				<path class="st80" d="M640.7,174.5c0-2,0.4-3.4,1.1-4.4c0.8-1,1.9-1.5,3.4-1.5c0.5,0,0.9,0,1.2,0.1v1c-0.4-0.1-0.8-0.2-1.2-0.2
  					c-1.1,0-1.9,0.3-2.5,1c-0.6,0.7-0.9,1.7-0.9,3.1h0.1c0.5-0.8,1.3-1.2,2.4-1.2c0.9,0,1.6,0.3,2.1,0.8c0.5,0.5,0.8,1.3,0.8,2.2
  					c0,1-0.3,1.9-0.8,2.4c-0.6,0.6-1.3,0.9-2.3,0.9c-1,0-1.9-0.4-2.5-1.2C641.1,177,640.7,175.9,640.7,174.5z M644.1,178
  					c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.5-1,0.5-1.8c0-0.7-0.2-1.2-0.5-1.6c-0.3-0.4-0.8-0.6-1.5-0.6c-0.4,0-0.8,0.1-1.1,0.3
  					c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.3,0.9c0,0.5,0.1,0.9,0.3,1.3c0.2,0.4,0.4,0.7,0.8,1
  					C643.3,177.8,643.7,178,644.1,178z"/>
  			</g>
  		</g>
  		<g id="n25">
  			<g>
  				<path class="st80" d="M594,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1
  					c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8
  					c0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1
  					v0.1h5.1V178.8z"/>
  				<path class="st80" d="M598.5,172.7c1.1,0,1.9,0.3,2.5,0.8c0.6,0.5,0.9,1.2,0.9,2.1c0,1-0.3,1.8-1,2.4c-0.7,0.6-1.6,0.9-2.7,0.9
  					c-1.1,0-2-0.2-2.6-0.5v-1.1c0.3,0.2,0.7,0.4,1.2,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.8,0,1.4-0.2,1.9-0.6c0.4-0.4,0.7-0.9,0.7-1.6
  					c0-1.4-0.9-2.1-2.6-2.1c-0.4,0-1,0.1-1.7,0.2l-0.6-0.4l0.4-4.7h5v1h-4l-0.3,3C597.5,172.7,598,172.7,598.5,172.7z"/>
  			</g>
  		</g>
  		<g id="n24">
  			<g>
  				<path class="st80" d="M556.1,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1
  					c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8
  					c0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7s0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1v0.1h5.1
  					V178.8z"/>
  				<path class="st80" d="M564.6,176.5h-1.5v2.3H562v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V176.5z M562,175.5v-3.3c0-0.7,0-1.4,0.1-2.2
  					H562c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H562z"/>
  			</g>
  		</g>
  		<g id="n23">
  			<g>
  				<path class="st80" d="M514.3,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1
  					c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8
  					c0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7s0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1v0.1h5.1
  					V178.8z"/>
  				<path class="st80" d="M522,171.1c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8
  					c0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1
  					c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5
  					c0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7
  					l-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C521.7,169.8,522,170.4,522,171.1z"/>
  			</g>
  		</g>
  		<g id="n22">
  			<g>
  				<path class="st80" d="M473,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1
  					c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8
  					c0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1
  					v0.1h5.1V178.8z"/>
  				<path class="st80" d="M481,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1
  					c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8
  					c0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1
  					v0.1h5.1V178.8z"/>
  			</g>
  		</g>
  		<g id="n21">
  			<g>
  				<path class="st80" d="M426,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1
  					c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8
  					c0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7s0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1v0.1h5.1
  					V178.8z"/>
  				<path class="st80" d="M431.6,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8
  					l2.6-2h1V178.8z"/>
  			</g>
  		</g>
  	</g>
  	<g id="numbers_x5F_k1">
  		<g id="n18">
  			<g>
  				<path class="st80" d="M60,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8
  					l2.6-2h1V178.8z"/>
  				<path class="st80" d="M67.1,168.6c0.9,0,1.6,0.2,2.2,0.6c0.5,0.4,0.8,1,0.8,1.8c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.4-0.8,0.8-1.5,1.1
  					c0.8,0.4,1.4,0.8,1.7,1.2c0.3,0.4,0.5,0.9,0.5,1.5c0,0.8-0.3,1.5-0.9,2c-0.6,0.5-1.4,0.7-2.4,0.7c-1.1,0-1.9-0.2-2.5-0.7
  					c-0.6-0.5-0.9-1.1-0.9-2c0-1.1,0.7-2,2.1-2.7c-0.6-0.4-1.1-0.7-1.4-1.2c-0.3-0.4-0.4-0.9-0.4-1.4c0-0.7,0.3-1.3,0.8-1.7
  					C65.5,168.9,66.2,168.6,67.1,168.6z M65,176.3c0,0.5,0.2,1,0.6,1.3c0.4,0.3,0.9,0.5,1.6,0.5c0.7,0,1.2-0.2,1.6-0.5
  					c0.4-0.3,0.6-0.8,0.6-1.3c0-0.4-0.2-0.8-0.5-1.2c-0.4-0.3-1-0.7-1.9-1c-0.7,0.3-1.2,0.6-1.5,1C65.1,175.3,65,175.8,65,176.3z
  					 M67.1,169.6c-0.6,0-1,0.1-1.3,0.4c-0.3,0.3-0.5,0.6-0.5,1.1c0,0.4,0.1,0.8,0.4,1.1c0.3,0.3,0.8,0.6,1.5,0.9
  					c0.7-0.3,1.1-0.6,1.4-0.9c0.3-0.3,0.4-0.7,0.4-1.1c0-0.5-0.2-0.8-0.5-1.1C68.1,169.7,67.7,169.6,67.1,169.6z"/>
  			</g>
  		</g>
  		<g id="n17">
  			<g>
  				<path class="st80" d="M109.2,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8
  					l2.6-2h1V178.8z"/>
  				<path class="st80" d="M114.3,178.8l4.1-8.9H113v-1h6.7v0.9l-4.1,9.1H114.3z"/>
  			</g>
  		</g>
  		<g id="n16">
  			<g>
  				<path class="st80" d="M156.7,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8
  					l2.6-2h1V178.8z"/>
  				<path class="st80" d="M160.6,174.5c0-2,0.4-3.4,1.1-4.4c0.8-1,1.9-1.5,3.4-1.5c0.5,0,0.9,0,1.2,0.1v1c-0.4-0.1-0.8-0.2-1.2-0.2
  					c-1.1,0-1.9,0.3-2.5,1c-0.6,0.7-0.9,1.7-0.9,3.1h0.1c0.5-0.8,1.3-1.2,2.4-1.2c0.9,0,1.6,0.3,2.1,0.8c0.5,0.5,0.8,1.3,0.8,2.2
  					c0,1-0.3,1.9-0.9,2.4c-0.6,0.6-1.3,0.9-2.3,0.9c-1,0-1.9-0.4-2.5-1.2C160.9,177,160.6,175.9,160.6,174.5z M164,178
  					c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.5-1,0.5-1.8c0-0.7-0.2-1.2-0.5-1.6c-0.3-0.4-0.8-0.6-1.5-0.6c-0.4,0-0.8,0.1-1.1,0.3
  					c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.3,0.9c0,0.5,0.1,0.9,0.3,1.3c0.2,0.4,0.4,0.7,0.8,1
  					C163.1,177.8,163.5,178,164,178z"/>
  			</g>
  		</g>
  		<g id="n15">
  			<g>
  				<path class="st80" d="M201.9,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8
  					l2.6-2h1V178.8z"/>
  				<path class="st80" d="M208.8,172.7c1.1,0,1.9,0.3,2.5,0.8c0.6,0.5,0.9,1.2,0.9,2.1c0,1-0.3,1.8-1,2.4c-0.7,0.6-1.6,0.9-2.7,0.9
  					c-1.1,0-2-0.2-2.6-0.5v-1.1c0.3,0.2,0.7,0.4,1.2,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.8,0,1.4-0.2,1.9-0.6c0.4-0.4,0.7-0.9,0.7-1.6
  					c0-1.4-0.9-2.1-2.6-2.1c-0.4,0-1,0.1-1.7,0.2l-0.6-0.4l0.4-4.7h5v1h-4l-0.3,3C207.7,172.7,208.3,172.7,208.8,172.7z"/>
  			</g>
  		</g>
  		<g id="n14">
  			<g>
  				<path class="st80" d="M240.2,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8
  					l2.6-2h1V178.8z"/>
  				<path class="st80" d="M251,176.5h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V176.5z M248.5,175.5v-3.3c0-0.7,0-1.4,0.1-2.2
  					h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H248.5z"/>
  			</g>
  		</g>
  		<g id="n13">
  			<g>
  				<path class="st80" d="M281.8,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8
  					l2.6-2h1V178.8z"/>
  				<path class="st80" d="M291.8,171.1c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8
  					c0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1
  					c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5
  					c0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7
  					l-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C291.5,169.8,291.8,170.4,291.8,171.1z"/>
  			</g>
  		</g>
  		<g id="n12">
  			<g>
  				<path class="st80" d="M323.4,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8
  					l2.6-2h1V178.8z"/>
  				<path class="st80" d="M333.8,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1
  					c0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8
  					c0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7s0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1v0.1h5.1
  					V178.8z"/>
  			</g>
  		</g>
  		<g id="n11">
  			<g>
  				<path class="st80" d="M369.6,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8
  					l2.6-2h1V178.8z"/>
  				<path class="st80" d="M377.6,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8
  					l2.6-2h1V178.8z"/>
  			</g>
  		</g>
  	</g>
  </g>
  <g id="lines">
  	<line id="horiz" class="st81" x1="2" y1="189.6" x2="798" y2="189.6"/>
  	<line id="vert" class="st81" x1="400" y1="13.7" x2="400" y2="346.3"/>
  </g>
  <g id="teeth_x5F_dark_x5F_overlays">
  	<path v-on:click="toothClick(48)" v-bind:class="((tooth[48]) ? 'active' : '')" id="dark_x5F_48" class="st82" d="M91.4,232.2C91.4,232.1,91.4,232.1,91.4,232.2c-1.3-5-4.5-7.4-6.5-8.8l-0.4-0.3
  		c-0.6-0.5-1.2-1-1.9-1.7c-1.7-1.7-3.7-3.5-6.7-3.5c-3.3,0-11.1,4.5-14.5,6.5c-0.5,0.3-0.9,0.5-1.1,0.6c-0.3-0.1-1-0.6-1.7-1
  		c-2.9-1.8-8.4-5.1-12.6-5.1c-3,0-5.9,1.5-8.1,4.1c-2.8,3.3-4.2,8.3-4.2,14.4c0,1.4,0.2,2.8,0.5,4.1c0.3,3.1,1.2,6.6,2.2,10.4
  		c1.6,6.3,3.5,13.5,3.5,21.9c0,7-1.8,14.3-3.5,20.6c-1.2,4.8-2.3,9-2.3,12.1c0,9.5,4.2,23.5,7.9,23.5c2.7,0,4.4-4.4,4.4-7.4
  		c0-5.1,2-10.8,3.6-15.4c0.9-2.5,1.7-4.7,1.8-6.2c0.5-4.2,4.5-20.6,6-24c0,0,0.1,0,0.1,0c0.4,2.7-0.1,12.6-0.5,19.4
  		c-0.3,4.4-0.5,8.2-0.5,10.2c0,4.1,0.6,10.9,1,15.4c0.2,2.2,0.3,3.9,0.3,4.4v3.7c0,1.6,0.8,3.4,3.2,3.4c4.4,0,16.4-28.7,16.4-50.7
  		c0-0.5,0.9-12,0.9-15.5c0-2.2,2.6-7,5-11.7c1-1.9,2-3.8,2.9-5.6c3.2-4.4,5.3-9.1,5.3-13.8C91.9,234.9,91.7,233.5,91.4,232.2z"/>
  	<path v-on:click="toothClick(47)" v-bind:class="((tooth[47]) ? 'active' : '')" id="dark_x5F_47" class="st82" d="M150.4,232.2C150.4,232.1,150.4,232.1,150.4,232.2c-1.3-5-4.5-7.4-6.5-8.8l-0.4-0.3
  		c-0.6-0.5-1.2-1-1.9-1.7c-1.7-1.7-3.7-3.5-6.7-3.5c-3.3,0-11.1,4.5-14.5,6.5c-0.5,0.3-0.9,0.5-1.1,0.6c-0.3-0.1-1-0.6-1.7-1
  		c-2.9-1.8-8.4-5.1-12.6-5.1c-3,0-5.9,1.5-8.1,4.1c-2.8,3.3-4.2,8.3-4.2,14.4c0,1.4,0.2,2.8,0.5,4.1c0.3,3.1,1.2,6.6,2.2,10.4
  		c1.6,6.3,3.5,13.5,3.5,21.9c0,7-1.8,14.3-3.5,20.6c-1.2,4.8-2.3,9-2.3,12.1c0,9.5,4.2,23.5,7.9,23.5c2.7,0,4.4-4.4,4.4-7.4
  		c0-5.1,2-10.8,3.6-15.4c0.9-2.5,1.7-4.7,1.8-6.2c0.5-4.2,4.5-20.6,6-24c0,0,0.1,0,0.1,0c0.4,2.7-0.1,12.6-0.5,19.4
  		c-0.3,4.4-0.5,8.2-0.5,10.2c0,4.1,0.6,10.9,1,15.4c0.2,2.2,0.3,3.9,0.3,4.4v3.7c0,1.6,0.8,3.4,3.2,3.4c4.4,0,16.4-28.7,16.4-50.7
  		c0-0.5,0.9-12,0.9-15.5c0-2.2,2.6-7,5-11.7c1-1.9,2-3.8,2.9-5.6c3.2-4.4,5.3-9.1,5.3-13.8C150.9,234.9,150.7,233.5,150.4,232.2z"/>
  	<path v-on:click="toothClick(46)" v-bind:class="((tooth[46]) ? 'active' : '')" id="dark_x5F_46" class="st82" d="M206.7,221.2l-0.3-0.1c-1.3-0.7-2.3-1.2-3.1-1.7c-1.4-0.9-2.3-1.4-4-1.4
  		c-2.5,0-9.2,2.8-10.8,3.5c-1.2,0.5-2.7,1.9-3.5,3.1c-1.9-2.1-7-3.5-10.4-3.5c-4.9,0-7.2,2.1-9.4,5.7c-0.9-1.2-3.2-3.5-6.3-3.5
  		c-3.9,0-6.8,4.8-6.8,11.1c0,5.6,4.2,17.9,5.2,19.4c0.2,0.3,0.5,0.6,0.7,0.9c1.5,4.8,3.2,10.7,3.2,13.7c0,4.1-2.3,15.2-4.8,27
  		c-2.6,12.2-5.2,24.8-5.2,29.7c0,6.3,1.5,10.6,3.7,10.6c2,0,5.9-6.2,5.9-9.3c0-0.3,0.7-1.6,1.5-3c2.3-4.3,6.5-12.2,10.5-25.2
  		c2.6-8.6,7.5-10.4,8.7-10.4c1.7,0,4.3,6.5,4.3,15.1c0,8.3-2.7,25.8-3.1,27.3c-0.5,1.6-0.8,2.7-0.8,3.5c0,2.8,1.4,3.4,2.5,3.4
  		c4.7,0,20.1-24,20.1-39.6c0-11.7-0.5-15.5-0.9-18.6c-0.3-2-0.5-3.7-0.5-7.2c0-3.2,2-7.9,4.1-12.8c1-2.3,2-4.7,2.8-7
  		c3.2-7.7,3.9-16.6,3.9-19.7C214,224.7,210.5,223,206.7,221.2z"/>
  	<path v-on:click="toothClick(45)" v-bind:class="((tooth[45]) ? 'active' : '')" id="dark_x5F_45" class="st82" d="M246.8,221.9c-0.6-0.2-1.2-0.4-1.8-0.6c-0.4-0.2-0.9-0.4-1.5-0.6c-2.5-1.1-6.4-2.8-10.6-2.8
  		c-3.6,0-5.5,0.9-9.8,3.9c-0.8,0.5-1.7,0.9-2.6,1.4c-2.2,1-4.4,2-5.1,4.4c-0.7,2.5-0.7,4.2-0.7,5.9c0,1.7,1.9,11.4,5.3,20.3
  		c0.9,8.9,1.2,18.3,0.9,26.1c-0.2,4.8-0.6,9.2-0.9,12.4c-0.2,2.4-0.4,4.1-0.4,5c0,1.6,0.2,3.1,0.5,5.4c0.2,1.2,0.3,2.7,0.5,4.3
  		c0.2,3.9,0.5,8.2,0.8,12c0.1,2.3,0.1,4.8,0.1,7.7c0,2.7-0.6,4.9-1.1,6.8c-0.4,1.4-0.7,2.7-0.7,3.8c0,1.8,0,4.4,2.3,4.4
  		c4.1,0,8.3-7.8,11-13.7c0.2-0.5,0.7-1.3,1.2-2.3c3.2-5.8,10.6-19.5,10.6-32c0-1.2,0.5-29.3,0.5-30.9c0-0.7,0.6-4.3,1.3-8.1
  		c4.2-8.7,6.8-19.1,6.8-23.9C253.4,224.2,250.9,223.4,246.8,221.9z"/>
  	<path v-on:click="toothClick(44)" v-bind:class="((tooth[44]) ? 'active' : '')" id="dark_x5F_44" class="st82" d="M286.2,225.3c-1.3-0.9-2.6-1.8-3.9-2.9c-0.2-0.2-0.5-0.5-0.8-0.7c-1.6-1.5-4.1-3.8-7.3-3.8
  		c-3.4,0-4.4,0.7-5.9,2.3l-0.5,0.5c-1.5,1.6-3.3,3.4-5.6,4.4c-2.5,1-6.8,7.1-6.8,11.6c0,3,1.6,11.4,4.4,18.9
  		c0.2,0.6,0.5,1.2,0.7,1.8c0.8,3.3,1.5,6.9,1.7,9c0.2,2.6-0.4,7-0.9,11.2c-0.5,3.8-1,7.7-1,10.4c0,3.2,1.2,13.1,2.3,21.8
  		c0.8,6.7,1.6,13,1.6,14.6c0,2-0.2,3.2-0.4,4.2c-0.1,0.9-0.3,1.7-0.3,2.8c0,2,0.6,6.2,2.6,6.2c2.7,0,6.8-7.1,10.5-18
  		c0.1-0.4,0.3-0.9,0.4-1.3c0.1-0.3,0.2-0.6,0.3-1c0.1-0.3,0.2-0.6,0.3-0.9c4.3-13.8,7.9-32.7,7.9-51.5c0-3.5,0.3-6.4,0.7-8.8
  		c4.1-7.3,7.3-15.8,7.3-20.9C293.4,230.3,289.9,227.9,286.2,225.3z"/>
  	<path v-on:click="toothClick(43)" v-bind:class="((tooth[43]) ? 'active' : '')" id="dark_x5F_43" class="st82" d="M326.2,222.8c-0.9-0.7-8.2-6.6-11.7-6.6c-3,0-8,2.4-12,9.3c-0.9,0.7-8.3,6.3-8.3,10.8
  		c0,5.4,2.6,13.3,4.4,19c0.4,1.2,0.8,2.3,1,3.2c0.3,2.5,0.6,5,0.6,6.1c0,1.2-0.2,4.1-0.5,7.3c-0.4,4.2-0.8,9.1-0.8,11.9
  		c0,8.4,2,20.8,3.5,29.8c0.8,5,1.5,8.9,1.5,10.4c0,2.6-0.6,6.7-1,9.7c-0.3,1.8-0.4,3-0.4,3.5c0,1.7,1.1,2.6,2.2,2.6
  		c5,0,14.7-19.6,14.7-24.1c0-4.7,1.8-11.2,3.3-16.5c1.1-4,2.1-7.4,2.1-9.3c0-1.9,0.3-9.3,0.7-17.1c5.1-14.6,8.4-35.4,8.4-42.7
  		C333.8,225.4,327.1,223.1,326.2,222.8z"/>
  	<path v-on:click="toothClick(42)" v-bind:class="((tooth[42]) ? 'active' : '')" id="dark_x5F_42" class="st82" d="M361.1,220.9l-19.3,0c-3.2-0.2-6.5,0.5-7,6.6c-0.3,3.5,0.8,20.3,4.5,33
  		c-0.3,12.9-1.1,44-1.4,45.9c-0.3,2.5,3.6,17.3,4.3,18.9c0.4,1,0.1,7.8,0,10.3c0,0.7-0.1,1.2-0.1,1.4c0,1.2,1.8,2.9,3.3,2.9
  		c4.7,0,16.4-24.2,16.9-81.1c0.1-0.4,0.2-0.7,0.4-1.1c2.9-9,4.5-18.6,4.5-21v-10.4C367.1,224.7,366.5,220.9,361.1,220.9z"/>
  	<path v-on:click="toothClick(41)" v-bind:class="((tooth[41]) ? 'active' : '')" id="dark_x5F_41" class="st82" d="M397.3,333.2c-0.9-1.9-3-6.2-3-12.9c0-3,0.9-6.3,1.8-9.6c0.8-2.9,1.5-5.6,1.5-7.7
  		c0-2.7-0.1-4.5-0.4-7.2c-0.4-5.1-1.1-13.4-1.7-37.1c1.4-6.8,2.2-13.2,2.2-15.6v-18.3c0-1.7-1.2-3.6-3.9-3.6h-17.6
  		c-1.9,0-7.9,1.5-7.9,3.6c0,11.5,1.9,25.3,5,37c1,61.9,12.2,75.2,21.6,75.2c2.5,0,2.8-1.4,2.8-2.6
  		C397.8,334.1,397.7,333.8,397.3,333.2z"/>
  	<path v-on:click="toothClick(38)" v-bind:class="((tooth[38]) ? 'active' : '')" id="dark_x5F_38" class="st82" d="M760.1,273.8c0-8.4,1.8-15.5,3.5-21.9c1-3.9,1.9-7.3,2.2-10.4c0.3-1.4,0.5-2.8,0.5-4.1
  		c0-6.1-1.5-11.1-4.2-14.4c-2.2-2.6-5.1-4.1-8.1-4.1c-4.2,0-9.6,3.3-12.6,5.1c-0.7,0.4-1.5,0.9-1.7,1c-0.2-0.1-0.7-0.4-1.1-0.6
  		c-3.3-1.9-11.1-6.5-14.5-6.5c-3,0-4.9,1.9-6.7,3.5c-0.6,0.6-1.3,1.2-1.9,1.7l-0.4,0.3c-2,1.4-5.2,3.8-6.5,8.8c0-0.1,0-0.1,0,0
  		c-0.3,1.3-0.5,2.7-0.5,4.4c0,4.6,2.1,9.4,5.3,13.8c0.8,1.7,1.9,3.6,2.9,5.6c2.5,4.7,5,9.5,5,11.7c0,3.5,0.9,15,0.9,15.4
  		c0,22,12,50.7,16.4,50.7c2.3,0,3.2-1.8,3.2-3.4v-3.7c0-0.5,0.1-2.2,0.3-4.4c0.4-4.5,1-11.3,1-15.4c0-2-0.2-5.8-0.5-10.2
  		c-0.4-6.8-1-16.7-0.5-19.4c0,0,0.1,0,0.1,0c1.5,3.4,5.5,19.8,6,24c0.2,1.5,1,3.6,1.8,6.2c1.6,4.6,3.6,10.2,3.6,15.4
  		c0,3,1.7,7.4,4.4,7.4c3.8,0,7.9-14,7.9-23.5c0-3.1-1.1-7.2-2.3-12.1C762,288.1,760.1,280.9,760.1,273.8z"/>
  	<path v-on:click="toothClick(37)" v-bind:class="((tooth[37]) ? 'active' : '')" id="dark_x5F_37" class="st82" d="M706.8,241.6c0.3-1.4,0.5-2.8,0.5-4.1c0-6.1-1.5-11.1-4.2-14.4c-2.2-2.6-5.1-4.1-8.1-4.1
  		c-4.2,0-9.7,3.3-12.6,5.1c-0.7,0.4-1.5,0.9-1.7,1c-0.2-0.1-0.7-0.4-1.1-0.6c-3.3-1.9-11.1-6.5-14.5-6.5c-3,0-4.9,1.9-6.7,3.5
  		c-0.6,0.6-1.3,1.2-1.9,1.7l-0.4,0.3c-2,1.4-5.2,3.8-6.5,8.8c0-0.1,0-0.1,0,0c-0.3,1.3-0.5,2.7-0.5,4.4c0,4.6,2.1,9.4,5.3,13.8
  		c0.8,1.7,1.9,3.6,2.9,5.6c2.5,4.7,5,9.5,5,11.7c0,3.5,0.9,15,0.9,15.4c0,22,12,50.7,16.4,50.7c2.3,0,3.2-1.8,3.2-3.4v-3.7
  		c0-0.5,0.1-2.2,0.3-4.4c0.4-4.5,1-11.3,1-15.4c0-2-0.2-5.8-0.5-10.2c-0.4-6.8-1-16.7-0.5-19.4c0,0,0.1,0,0.1,0
  		c1.5,3.4,5.5,19.8,6,24c0.2,1.5,1,3.6,1.8,6.2c1.6,4.6,3.6,10.2,3.6,15.4c0,3,1.7,7.4,4.4,7.4c3.8,0,7.9-14,7.9-23.5
  		c0-3.1-1.1-7.2-2.3-12.1c-1.6-6.4-3.5-13.6-3.5-20.6c0-8.4,1.8-15.5,3.5-21.9C705.6,248.1,706.5,244.7,706.8,241.6z"/>
  	<path v-on:click="toothClick(36)" v-bind:class="((tooth[36]) ? 'active' : '')" id="dark_x5F_36" class="st82" d="M638.5,268.4c0-3,1.7-8.8,3.2-13.7c0.2-0.3,0.5-0.6,0.7-0.9c1-1.5,5.2-13.9,5.2-19.4
  		c0-6.3-2.9-11.1-6.8-11.1c-3.1,0-5.4,2.3-6.3,3.5c-2.2-3.6-4.5-5.7-9.4-5.7c-3.4,0-8.5,1.3-10.4,3.5c-0.7-1.2-2.3-2.5-3.5-3.1
  		c-1.5-0.7-8.2-3.5-10.8-3.5c-1.7,0-2.6,0.6-4,1.4c-0.8,0.5-1.7,1.1-3.1,1.7l-0.3,0.1c-3.7,1.8-7.2,3.6-7.2,11
  		c0,3.1,0.8,12,3.9,19.7c0.8,2.3,1.8,4.7,2.8,7c2.1,4.9,4.1,9.6,4.1,12.8c0,3.5-0.2,5.2-0.5,7.2c-0.4,3.1-0.9,6.9-0.9,18.6
  		c0,15.5,15.4,39.6,20.1,39.6c1.1,0,2.5-0.6,2.5-3.4c0-0.7-0.3-1.9-0.8-3.5c-0.4-1.5-3.1-19-3.1-27.3c0-8.6,2.6-15.1,4.3-15.1
  		c1.2,0,6.1,1.8,8.7,10.4c4,13,8.2,20.9,10.5,25.2c0.8,1.5,1.5,2.7,1.5,3c0,3.1,3.9,9.3,5.9,9.3c2.2,0,3.7-4.3,3.7-10.6
  		c0-4.9-2.7-17.5-5.2-29.7C640.9,283.6,638.5,272.5,638.5,268.4z"/>
  	<path v-on:click="toothClick(35)" v-bind:class="((tooth[35]) ? 'active' : '')" id="dark_x5F_35" class="st82" d="M585.2,233.5c0-1.8,0-3.5-0.7-5.9c-0.7-2.5-2.9-3.5-5.1-4.4c-1-0.4-1.9-0.8-2.6-1.4
  		c-4.3-3-6.2-3.9-9.8-3.9c-4.3,0-8.1,1.7-10.6,2.8c-0.6,0.2-1.1,0.5-1.5,0.6c-0.6,0.2-1.2,0.4-1.8,0.6c-4.1,1.4-6.6,2.3-6.6,9
  		c0,4.8,2.7,15.2,6.8,23.9c0.7,3.7,1.3,7.4,1.3,8.1c0,1.5,0.4,29.7,0.5,30.8c0,12.5,7.4,26.1,10.6,32c0.6,1,1,1.8,1.2,2.4
  		c2.8,5.9,6.9,13.7,11,13.7c2.3,0,2.3-2.5,2.3-4.4c0-1.1-0.3-2.4-0.7-3.8c-0.5-1.9-1.1-4.1-1.1-6.8c0-2.8,0-5.4,0.1-7.7
  		c0.2-3.8,0.5-8.2,0.8-12.1c0.2-1.7,0.3-3.1,0.5-4.3c0.3-2.2,0.5-3.8,0.5-5.4c0-0.9-0.2-2.6-0.4-5c-0.3-3.2-0.7-7.6-0.9-12.4
  		c-0.4-7.8,0-17.2,0.9-26.1C583.3,245,585.2,235.2,585.2,233.5z"/>
  	<path v-on:click="toothClick(34)" v-bind:class="((tooth[34]) ? 'active' : '')" id="dark_x5F_34" class="st82" d="M537.9,225c-2.3-0.9-4.1-2.8-5.6-4.4l-0.5-0.5c-1.6-1.6-2.6-2.3-5.9-2.3
  		c-3.3,0-5.7,2.3-7.3,3.8c-0.3,0.3-0.6,0.5-0.8,0.7c-1.3,1.1-2.6,2-3.9,2.9c-3.7,2.5-7.2,4.9-7.2,10c0,5.1,3.2,13.6,7.3,20.9
  		c0.4,2.4,0.7,5.3,0.7,8.8c0,18.8,3.6,37.7,7.9,51.5c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0.3,0.2,0.7,0.3,1c0.1,0.4,0.3,0.9,0.4,1.3
  		c3.7,11,7.8,18,10.5,18c2,0,2.6-4.2,2.6-6.2c0-1.1-0.1-1.9-0.3-2.8c-0.2-1.1-0.4-2.3-0.4-4.2c0-1.6,0.8-7.9,1.6-14.6
  		c1.1-8.7,2.3-18.6,2.3-21.8c0-2.7-0.5-6.6-1-10.4c-0.5-4.3-1.1-8.7-0.9-11.2c0.1-2.2,0.9-5.8,1.7-9c0.3-0.6,0.5-1.2,0.7-1.8
  		c2.8-7.5,4.4-15.9,4.4-18.9C544.7,232.1,540.4,226,537.9,225z"/>
  	<path v-on:click="toothClick(33)" v-bind:class="((tooth[33]) ? 'active' : '')" id="dark_x5F_33" class="st82" d="M497.5,225.5c-4-6.9-9-9.3-12-9.3c-3.5,0-10.8,5.9-11.7,6.6c-0.9,0.3-7.6,2.6-7.6,7.5
  		c0,7.3,3.3,28.2,8.4,42.7c0.3,7.8,0.7,15.2,0.7,17.1c0,1.9,1,5.3,2.1,9.3c1.5,5.2,3.3,11.8,3.3,16.5c0,4.5,9.6,24.1,14.7,24.1
  		c1,0,2.2-0.9,2.2-2.6c0-0.5-0.2-1.8-0.4-3.5c-0.4-3-1-7.1-1-9.7c0-1.5,0.6-5.4,1.5-10.4c1.5-9,3.5-21.4,3.5-29.8
  		c0-2.8-0.4-7.6-0.8-11.9c-0.3-3.3-0.5-6.1-0.5-7.3c0-1.1,0.3-3.6,0.6-6.1c0.3-0.9,0.6-2,1-3.2c1.9-5.7,4.4-13.6,4.4-19
  		C505.8,231.8,498.5,226.2,497.5,225.5z"/>
  	<path v-on:click="toothClick(32)" v-bind:class="((tooth[32]) ? 'active' : '')" id="dark_x5F_32" class="st82" d="M465.2,227.5c-0.5-6.1-3.8-6.8-7-6.6h-19.3c-5.5,0-6.1,3.8-6.1,5.5v10.4
  		c0,2.4,1.6,12,4.5,21c0.1,0.4,0.2,0.7,0.4,1.1c0.5,56.9,12.2,81.1,16.9,81.1c1.5,0,3.3-1.8,3.3-2.9c0-0.2,0-0.7-0.1-1.4
  		c-0.1-2.5-0.4-9.3,0-10.3c0.6-1.5,4.6-16.3,4.3-18.9c-0.2-1.9-1-33-1.4-45.9C464.4,247.8,465.5,231,465.2,227.5z"/>
  	<path v-on:click="toothClick(31)" v-bind:class="((tooth[31]) ? 'active' : '')" id="dark_x5F_31" class="st82" d="M423.8,221.2h-17.6c-2.7,0-3.9,1.9-3.9,3.6V243c0,2.4,0.7,8.8,2.2,15.6
  		c-0.6,23.7-1.3,32-1.7,37.1c-0.2,2.7-0.4,4.5-0.4,7.2c0,2.2,0.7,4.9,1.5,7.7c0.9,3.2,1.8,6.6,1.8,9.6c0,6.7-2.1,11.1-3,12.9
  		c-0.3,0.7-0.5,1-0.5,1.2c0,1.2,0.3,2.6,2.8,2.6c9.5,0,20.6-13.3,21.6-75.2c3.1-11.7,5-25.5,5-37
  		C431.6,222.6,425.7,221.2,423.8,221.2z"/>
  	<path v-on:click="toothClick(28)" v-bind:class="((tooth[28]) ? 'active' : '')" id="dark_x5F_28" class="st82" d="M756.9,120.8c-0.4-2.6-1-5.7-1.5-8.9c-1.2-7.1-2.5-14.4-2.5-16.9c0-3.4,0.1-10.1,0.3-17.3
  		c0.2-8.5,0.4-17.2,0.4-22.5c0-32.1-12.6-33.6-12.7-33.6c-2.3,0-2.6,2.7-2.6,5.6c0,0.8,0.2,1.7,0.5,2.7c-0.2,0.3-0.3,0.8-0.3,1.3
  		c0,1.4,0.5,9.5,0.5,9.8c0,4.1-2.4,13.2-4.3,19.4c-0.6-3.4-1.1-6.8-1.1-9c0-2.9,0.4-6.6,0.7-10.2c0.4-3.7,0.8-7.6,0.8-10.7
  		c0-6.5-3.1-9.2-4.4-9.2c-1.3,0-3.3,1.9-3.3,4.3c0,0.6-1.2,3.7-2.5,7.4c-3.3,9-8.3,22.5-8.3,29.8c0,5.9,1.7,14.2,3.2,21.6
  		c1.2,5.6,2.3,11,2.3,13.8c0,6.4-5.4,27.7-5.5,27.9l-0.1,0.5l0.1,0c-2.4,6.4-3.1,12.7-3.1,15.5c0,6.3,6.5,9.5,9.3,10.6
  		c0.2,0.1,0.7,0.4,1.2,0.8c1.2,0.9,2.8,2.2,4.5,2.2c1.3,0,3.9-1.6,7.7-4c2.3-1.4,5.1-3.2,5.8-3.2c0.3,0.1,1.8,0.9,3.1,1.6
  		c0.4,0.2,0.7,0.4,1,0.6c0.9,0.7,1.9,1.3,3.2,1.7c1.1,0.6,1.9,0.9,2.3,0.9c4.3,0,8.8-7,8.8-20.1
  		C760.1,128.3,758.8,124.2,756.9,120.8z"/>
  	<path v-on:click="toothClick(27)" v-bind:class="((tooth[27]) ? 'active' : '')" id="dark_x5F_27" class="st82" d="M707.3,111.9c-1.2-7.1-2.5-14.4-2.5-16.9c0-3.4,0.1-10.1,0.3-17.3
  		c0.2-8.5,0.4-17.2,0.4-22.5c0-32.1-12.6-33.6-12.7-33.6c-2.3,0-2.6,2.7-2.6,5.6c0,0.8,0.2,1.7,0.5,2.7c-0.2,0.3-0.3,0.8-0.3,1.3
  		c0,1.4,0.5,9.5,0.5,9.8c0,4.1-2.4,13.2-4.2,19.4c-0.6-3.4-1.1-6.8-1.1-9c0-2.9,0.4-6.6,0.7-10.2c0.4-3.7,0.8-7.6,0.8-10.7
  		c0-6.5-3.1-9.2-4.4-9.2c-1.3,0-3.3,1.9-3.3,4.3c0,0.6-1.2,3.7-2.5,7.4c-3.3,9-8.3,22.5-8.3,29.8c0,5.9,1.7,14.2,3.2,21.6
  		c1.2,5.6,2.3,11,2.3,13.8c0,6.4-5.4,27.7-5.5,27.9l-0.1,0.5l0.1,0c-2.4,6.4-3.1,12.7-3.1,15.5c0,6.3,6.5,9.5,9.3,10.6
  		c0.2,0.1,0.7,0.4,1.2,0.8c1.2,0.9,2.8,2.2,4.5,2.2c1.3,0,3.9-1.6,7.7-4c2.3-1.4,5.1-3.2,5.8-3.2c0.3,0.1,1.8,0.9,3.1,1.6
  		c0.4,0.2,0.7,0.4,1,0.6c0.9,0.7,1.9,1.3,3.2,1.7c1.1,0.6,1.9,0.9,2.3,0.9c4.3,0,8.8-7,8.8-20.1c0-4.9-1.3-9-3.3-12.4
  		C708.4,118.2,707.9,115.1,707.3,111.9z"/>
  	<path v-on:click="toothClick(26)" v-bind:class="((tooth[26]) ? 'active' : '')" id="dark_x5F_26" class="st82" d="M657.5,111.5c0.2-6.2,1.8-15.1,3.2-22.6c1.2-6.5,2.2-12.1,2.2-14.9c0-17.9-1.6-31.3-3.6-40
  		c-0.2-0.7-0.3-1.4-0.5-2c-1.5-6-3.2-9.2-4.4-9.2c-1.5,0-2.9,3.2-2.9,4.5c0,1.4,0.2,2.8,0.3,4c0.1,1,0.2,2,0.2,2.7
  		c-0.1,3.8-0.2,7.4-0.5,10.8c-1.2-10.4-2.6-18.9-3-20.7c-0.9-4.2-3.2-4.1-3.3-4.1c-0.5,0-1,0.1-1.5,0.3c-3.2,1.5-4.4,7.4-5.5,12.1
  		c-0.4,1.8-0.7,3.4-1.1,4.3c-0.2,0.6-0.6,1.3-1.2,2.1c-0.5-4.6-2.3-15.7-5.5-15.7c-1.6,0-4,3.3-4,7.8c0,3.9-2.3,12.3-4.8,21.2
  		c-2.6,9.4-5.3,19.1-5.3,24c0,4.6,1.6,13,2.9,20.5c0.9,5.1,1.8,9.9,2.1,12.6c0,0.2,0,0.4,0,0.7c0,0.2,0,0.3,0,0.5
  		c0,5.2-0.3,6.7-0.3,6.7l-0.1,0.6h0.1c-2.1,7.7-3.8,12.7-5.1,16.4c-1.4,4-2.3,6.5-2.3,8.9c0,6.7,6,8.8,8,9.5l0.3,0.1
  		c0.3,0.1,0.6,0.3,0.9,0.5c0.5,0.5,1.2,1.2,2.1,1.7c0.9,0.7,1.9,1.2,2.9,1.2c4.9,0,10.5-4.9,13.5-7.5c0.6-0.5,1.2-1.1,1.5-1.2
  		c0.6,0.3,2.4,1.6,3.9,2.6c3.6,2.6,4.8,3.4,5.4,3.4c0.8,0,1.6-0.6,2.7-1.7c0,0,4.2-4.2,7.1-7.1c3-3,2.6-9.4,2.6-9.8
  		C664.4,128.2,661.8,119,657.5,111.5z"/>
  	<path v-on:click="toothClick(25)" v-bind:class="((tooth[25]) ? 'active' : '')" id="dark_x5F_25" class="st82" d="M607,115.4l0.3,0.1l-2.2-22.4c-1.1-12.8-2.1-24.3-2.2-25.7c-0.2-1.9-0.9-5.2-1.8-9
  		c-1.4-6.2-3.1-13.9-3.1-18.9c0-4.2,0.2-6.5,0.3-8.2c0.1-0.9,0.1-1.7,0.1-2.4c0-1.9-1.9-6.5-4.9-6.5c-10.1,0-13.3,45.7-13.3,67.8
  		c0,8.8,0.2,24.4,0.3,33.3c-3,8.4-4.7,17.3-4.7,20.3c0,6.9,15.4,12.1,17.4,12.1c3.1,0,6.9-3.6,10.5-7.1l0.5-0.5
  		c1.1-1.1,2.3-1.6,3.4-2.1c2.4-1,4.5-1.9,4.5-8c0-6.2-2-12.7-4.8-18.2C607.3,118.5,607.2,117,607,115.4z"/>
  	<path v-on:click="toothClick(24)" v-bind:class="((tooth[24]) ? 'active' : '')" id="dark_x5F_24" class="st82" d="M570.8,119.6c-0.3-1.2-0.7-2.3-1-3.4c-0.2-11.1-0.1-31.6-0.1-41.9c0-2.9,0-5.1,0-6.4
  		c0-12.1-1.9-24-3.2-32.6c-0.8-4.9-1.4-8.8-1.4-11c0-2.4-0.9-3.8-2.4-3.8c-8.7,0-17.2,43.5-17.2,59.2c0,3.2-0.6,24.2-0.9,36
  		c-4.5,9.8-7.5,21.7-7.5,24.7c0,5.5,2.6,9,7.6,10.4c1.1,0.3,2.5,1.1,4,2c2.3,1.4,4.8,2.9,7.2,2.9c1.6,0,2.7-0.8,4-1.7
  		c1.2-0.9,2.6-1.9,4.8-2.6c9.3-2.9,10.6-8.3,10.6-13.2c0-3.3-0.8-5.8-2.3-10.9C572.5,125.3,571.7,122.7,570.8,119.6z"/>
  	<path v-on:click="toothClick(23)" v-bind:class="((tooth[23]) ? 'active' : '')" id="dark_x5F_23" class="st82" d="M529.9,111.3c0-4.3-1.1-8.6-2.8-12.5c0.7-8.3,1.5-19.5,1.5-25.2c0-6.3-2-19.3-3.5-28.9
  		c-0.8-5-1.4-8.9-1.4-9.8c0-1.7,0.8-5.8,1.4-8.8c0.5-2.4,0.7-3.8,0.7-4.3c0-1.4-1.1-2.5-2.6-2.5c-7.8,0-16.2,26.4-16.7,36.7
  		c-0.1,1.6-0.7,3.6-1.4,6c-1.5,5.1-3.7,12.2-3.7,23.6c0,3.7,0,4,0.1,16.8c-6,16.5-8.2,40.6-8.2,41c0,3.4,7.1,5.7,8.4,6.1
  		c0.8,0.8,7,6.3,13.4,6.3c4.9,0,11.9-8.1,12.7-9c1-0.6,9.2-5.5,9.2-11.2c0-2.8-1.8-7.8-3.6-12.7
  		C531.6,118.4,529.9,113.6,529.9,111.3z"/>
  	<path v-on:click="toothClick(22)" v-bind:class="((tooth[22]) ? 'active' : '')" id="dark_x5F_22" class="st82" d="M487.8,71.9c0-8.1-1.4-15.4-2.3-20.2c-0.5-2.4-0.8-4.3-0.8-5.4c0-0.5,0-4.1,0-8.4
  		c0-6.1,0-13.6,0-15.2c0-1-0.3-1.7-0.6-2.2c-0.3-0.7-0.9-0.9-1.1-0.9c-0.3-0.1-0.6-0.2-0.8-0.2c-2.3,0-3.7,2.5-4.4,3.9
  		c-0.3,0.6-0.6,0.9-1,1.3c-0.4,0.4-0.8,0.9-1.2,1.7c-3.3,5.8-5.9,13.8-7.9,22.7c0.1-1.7,0.3-3.2,0.5-4.4c0,0-0.3,2.4-0.9,6.2
  		c-4.1,19.3-5.8,42.5-6.4,57.8c-1.2,2.7-2.3,6-3.2,9.8c-3.7,11.6-6.1,24.2-6.1,29.8c0,2.4,0.4,5.7,4.1,5.7c2.4,0,4.5,0.2,6,0.3
  		c0.8,0.1,1.4,0.1,1.8,0.1c0.3,0,1.1,0.2,1.9,0.4c1.4,0.4,3.2,0.9,4.8,0.9c2.5,0,4.4-1.1,5.7-1.9c0.6-0.4,1.2-0.7,1.5-0.7
  		c13.2,0,14.6-12,14.6-17.2c0-5.7-2.1-13.5-5-20.8C487.4,101.2,487.8,79.6,487.8,71.9z"/>
  	<path v-on:click="toothClick(21)" v-bind:class="((tooth[21]) ? 'active' : '')" id="dark_x5F_21" class="st82" d="M443.7,99.9c-0.2-2.4,0-11.3,0.2-19.2c0.1-5.1,0.2-9.9,0.2-12.7c0-8.8-2.4-19.5-4.3-28.1
  		c-0.2-0.8-0.3-1.5-0.5-2.3c-0.7-3.9-1.4-7.2-1.8-9.7c0-0.5-0.1-0.9-0.1-1.3c0-1.5,0.2-2.2,0.4-3c0.2-0.7,0.4-1.4,0.4-2.5
  		c0-1.5-1.6-2.3-2.5-2.3c-5.4,0-11.8,9.8-17.1,26.2c-0.4,1.4-0.9,2.8-1.3,4.2c0-0.2,0-0.2,0-0.2c-1.3,1.3-2.6,7.4-3.6,14.8
  		c-2.5,12.2-3.8,25.1-3.8,37.2c0,1-0.1,2-0.2,3c-4.1,8.8-6.9,20.2-6.9,32.4c0,2.5,0,5.1-0.1,7.9c0,3.1-0.1,6.2-0.1,9.5v0.4l0.4,0.1
  		c0.4,0.1,9,2.1,14.9,0.7c0.7,0.1,4.5,0.7,8.6,0.7c2.4,0,4.9-0.2,6.9-0.8c1.2,0.1,11.8,0.6,14.7-1.8c3.1-2.6,3.1-9.9,3.1-12.3
  		c0-6.1-2.1-16.9-5.4-27.2C444.6,107.6,443.8,101.6,443.7,99.9z"/>
  	<path v-on:click="toothClick(18)" v-bind:class="((tooth[18]) ? 'active' : '')" id="dark_x5F_18" class="st82" d="M83.6,126.7l-0.1-0.5c-0.1-0.2-5.5-21.5-5.5-27.9c0-2.8,1.1-8.2,2.3-13.8
  		c1.5-7.4,3.2-15.7,3.2-21.6c0-7.3-5-20.8-8.3-29.8c-1.3-3.6-2.5-6.8-2.5-7.4c0-2.4-2-4.3-3.3-4.3c-1.2,0-4.4,2.7-4.4,9.2
  		c0,3.1,0.4,7,0.8,10.7c0.4,3.6,0.7,7.3,0.7,10.2c0,2.2-0.5,5.6-1.1,9c-1.8-6.2-4.3-15.2-4.3-19.3c0-0.3,0.5-8.5,0.5-9.8
  		c0-0.5-0.1-0.9-0.3-1.3c0.3-1,0.5-1.9,0.5-2.7c0-2.9-0.3-5.6-2.6-5.6c-1,0-4.1,1-7,5.6c-3.8,5.9-5.7,15.4-5.7,28
  		c0,5.3,0.2,14,0.4,22.5c0.1,7.1,0.3,13.8,0.3,17.3c0,2.5-1.3,9.8-2.5,16.9c-0.6,3.2-1.1,6.4-1.5,8.9c-2,3.4-3.3,7.5-3.3,12.4
  		c0,13.1,4.5,20.1,8.8,20.1c0.4,0,1.2-0.3,2.3-0.9c1.3-0.4,2.3-1,3.2-1.7c0.3-0.2,0.7-0.4,1-0.6c1.3-0.7,2.8-1.6,3-1.6
  		c0.7,0,3.6,1.8,5.8,3.2c3.8,2.4,6.4,4,7.7,4c1.8,0,3.4-1.3,4.5-2.2c0.5-0.4,0.9-0.7,1.2-0.8c2.8-1.1,9.3-4.3,9.3-10.6
  		C86.7,139.4,86,133.1,83.6,126.7L83.6,126.7z"/>
  	<path v-on:click="toothClick(17)" v-bind:class="((tooth[17]) ? 'active' : '')" id="dark_x5F_17" class="st82" d="M131.7,126.7l-0.1-0.5c-0.1-0.2-5.5-21.5-5.5-27.9c0-2.8,1.1-8.2,2.3-13.8
  		c1.5-7.4,3.2-15.7,3.2-21.6c0-7.3-5-20.8-8.3-29.8c-1.3-3.6-2.5-6.8-2.5-7.4c0-2.4-2-4.3-3.3-4.3c-1.2,0-4.4,2.7-4.4,9.2
  		c0,3.1,0.4,7,0.8,10.7c0.4,3.6,0.7,7.3,0.7,10.2c0,2.2-0.5,5.6-1.1,9c-1.8-6.2-4.2-15.2-4.3-19.3c0-0.3,0.5-8.5,0.5-9.8
  		c0-0.5-0.1-0.9-0.3-1.3c0.3-1,0.5-1.9,0.5-2.7c0-2.9-0.3-5.6-2.6-5.6c-1,0-4.1,1-7,5.6c-3.8,5.9-5.7,15.4-5.7,28
  		c0,5.3,0.2,14,0.4,22.5c0.1,7.1,0.3,13.8,0.3,17.3c0,2.5-1.3,9.8-2.5,16.9c-0.6,3.2-1.1,6.4-1.5,8.9c-2,3.4-3.3,7.5-3.3,12.4
  		c0,13.1,4.5,20.1,8.8,20.1c0.4,0,1.2-0.3,2.3-0.9c1.3-0.4,2.3-1,3.2-1.7c0.3-0.2,0.7-0.4,1-0.6c1.3-0.7,2.8-1.6,3-1.6
  		c0.7,0,3.6,1.8,5.8,3.2c3.8,2.4,6.4,4,7.7,4c1.8,0,3.4-1.3,4.5-2.2c0.5-0.4,0.9-0.7,1.2-0.8c2.8-1.1,9.3-4.3,9.3-10.6
  		C134.7,139.4,134,133.1,131.7,126.7L131.7,126.7z"/>
  	<path v-on:click="toothClick(16)" v-bind:class="((tooth[16]) ? 'active' : '')" id="dark_x5F_16" class="st82" d="M178.9,117.5L178.9,117.5l0-0.6c0,0-0.3-1.5-0.3-6.7c0-0.1,0-0.3,0-0.4c0-0.2,0-0.4,0-0.7
  		c0.2-2.7,1.1-7.5,2.1-12.6c1.4-7.4,2.9-15.9,2.9-20.5c0-4.9-2.7-14.6-5.3-24c-2.5-8.9-4.8-17.2-4.8-21.2c0-4.5-2.4-7.8-4-7.8
  		c-3.2,0-5,11.1-5.5,15.7c-0.5-0.8-0.9-1.5-1.2-2.1c-0.4-0.9-0.7-2.5-1.1-4.3c-1-4.8-2.3-10.7-5.5-12.1c-0.5-0.2-1-0.3-1.5-0.3
  		c0,0,0,0,0,0c-0.1,0-2.4-0.1-3.3,4.1c-0.4,1.8-1.8,10.3-3,20.7c-0.3-3.4-0.4-7-0.5-10.8c0-0.7,0.1-1.7,0.2-2.7
  		c0.2-1.2,0.3-2.6,0.3-4c0-1.2-1.4-4.5-2.9-4.5c-1.2,0-2.9,3.1-4.4,9.2c-0.2,0.6-0.3,1.2-0.5,2c-2,8.6-3.6,22.1-3.6,40
  		c0,2.8,1,8.4,2.2,14.9c1.3,7.5,2.9,16.4,3.2,22.6c-4.3,7.6-7,16.7-7,22.9c0,0.5-0.4,6.8,2.6,9.8c2.9,2.9,7,7.1,7,7.1
  		c1,1.2,1.9,1.7,2.7,1.7c0.6,0,1.8-0.8,5.4-3.4c1.5-1.1,3.4-2.4,3.9-2.6c0.3,0.2,0.9,0.7,1.5,1.2c3,2.6,8.6,7.5,13.5,7.5
  		c1,0,2-0.5,2.9-1.2c0.9-0.5,1.6-1.1,2.1-1.7c0.3-0.2,0.6-0.4,0.9-0.5l0.3-0.1c2-0.7,8-2.8,8-9.5c0-2.5-0.9-4.9-2.3-8.9
  		C182.7,130.1,180.9,125.1,178.9,117.5z"/>
  	<path v-on:click="toothClick(15)" v-bind:class="((tooth[15]) ? 'active' : '')" id="dark_x5F_15" class="st82" d="M219.7,90.1c0-22.1-3.3-67.8-13.3-67.8c-3,0-4.9,4.6-4.9,6.5c0,0.7,0.1,1.5,0.1,2.4
  		c0.1,1.7,0.3,4,0.3,8.2c0,5-1.7,12.7-3.1,18.9c-0.9,3.8-1.6,7.1-1.8,9c-0.1,1.4-1.1,12.9-2.2,25.7l-2.2,22.4l0.3-0.1
  		c-0.1,1.6-0.3,3.1-0.4,4.5c-2.8,5.5-4.8,12-4.8,18.2c0,6.1,2.1,7,4.5,8c1.1,0.5,2.3,1,3.4,2.1l0.5,0.5c3.7,3.5,7.5,7.1,10.5,7.1
  		c2,0,17.4-5.2,17.4-12.1c0-3.5-1.9-12.3-4.7-20.3C219.5,114.5,219.7,98.9,219.7,90.1z"/>
  	<path v-on:click="toothClick(14)" v-bind:class="((tooth[14]) ? 'active' : '')" id="dark_x5F_14" class="st82" d="M254.5,79.7c0-15.7-8.6-59.2-17.2-59.2c-1.5,0-2.4,1.4-2.4,3.8c0,2.2-0.6,6.1-1.4,11
  		c-1.4,8.7-3.2,20.5-3.2,32.6c0,1.2,0,3.5,0,6.4c0,10.3,0.1,30.8-0.1,41.9c-0.3,1.1-0.7,2.2-1,3.4c-0.9,3.1-1.6,5.7-2.2,7.7
  		c-1.5,5.1-2.3,7.7-2.3,10.9c0,4.9,1.3,10.3,10.6,13.2c2.2,0.7,3.6,1.7,4.8,2.6c1.3,0.9,2.4,1.7,4,1.7c2.4,0,5-1.5,7.3-2.9
  		c1.5-0.9,2.8-1.7,4-2c5.1-1.4,7.6-4.9,7.6-10.4c0-3.1-3-14.9-7.5-24.8C255,104,254.5,83,254.5,79.7z"/>
  	<path v-on:click="toothClick(13)" v-bind:class="((tooth[13]) ? 'active' : '')" id="dark_x5F_13" class="st82" d="M298.9,85.6c0-11.5-2.1-18.5-3.7-23.6c-0.7-2.4-1.3-4.4-1.4-6c-0.5-10.3-8.9-36.7-16.7-36.7
  		c-1.5,0-2.6,1.1-2.6,2.5c0,0.5,0.3,1.9,0.7,4.3c0.6,3,1.4,7.2,1.4,8.8c0,0.9-0.6,4.9-1.4,9.8c-1.5,9.5-3.5,22.6-3.5,28.9
  		c0,5.6,0.8,16.9,1.5,25.2c-1.7,3.8-2.8,8.2-2.8,12.5c0,2.3-1.7,7.1-3.4,11.6c-1.8,4.9-3.6,9.9-3.6,12.7c0,5.7,8.2,10.7,9.2,11.2
  		c0.8,0.9,7.8,9,12.7,9c6.4,0,12.6-5.5,13.4-6.3c1.3-0.4,8.4-2.7,8.4-6.1c0-0.4-2.2-24.5-8.2-41C298.9,89.6,298.9,89.2,298.9,85.6z"
  		/>
  	<path v-on:click="toothClick(12)" v-bind:class="((tooth[12]) ? 'active' : '')" id="dark_x5F_12" class="st82" d="M339.1,108.7c-0.6-15.3-2.3-38.5-6.4-57.8c-0.1-0.7-0.3-1.3-0.4-1.9
  		c-2-8.9-4.6-16.9-7.9-22.7l0,0c-0.5-0.8-0.9-1.2-1.2-1.6c-0.4-0.4-0.7-0.8-1-1.3c-0.7-1.4-2-3.9-4.4-3.9c0,0,0,0,0,0
  		c-0.2,0-0.5,0.1-0.7,0.2c-0.5,0.3-1,0.6-1.1,0.9c-0.4,0.5-0.6,1.2-0.6,2.2c0,1.6,0,9,0,15.2c0,4.3,0,7.9,0,8.4c0,1-0.4,2.9-0.8,5.4
  		c-0.9,4.8-2.3,12.1-2.3,20.2c0,7.6,0.4,29.3,0.8,43.3c-2.9,7.3-5,15-5,20.8c0,5.2,1.4,17.2,14.6,17.2c0.3,0,0.9,0.3,1.5,0.7
  		c1.3,0.8,3.2,1.9,5.7,1.9c1.6,0,3.4-0.5,4.8-0.9c0.8-0.2,1.6-0.4,1.9-0.4c0.4,0,1-0.1,1.8-0.1c1.4-0.1,3.6-0.3,6-0.3
  		c3.7,0,4.1-3.2,4.1-5.7c0-5.6-2.4-18.2-6.1-29.8C341.4,114.6,340.3,111.4,339.1,108.7z"/>
  	<path v-on:click="toothClick(11)" v-bind:class="((tooth[11]) ? 'active' : '')" id="dark_x5F_11" class="st82" d="M397.5,144.5c0-2.8-0.1-5.5-0.1-7.9c0-12.2-2.8-23.6-6.9-32.4c-0.1-1-0.2-2-0.2-3
  		c0-12.1-1.4-25-3.8-37.2c-1.1-7.5-2.3-13.5-3.6-14.9c0,0,0,0.1,0,0.2c-0.4-1.4-0.8-2.8-1.3-4.2c-5.3-16.4-11.7-26.2-17.1-26.2
  		c-0.9,0-2.5,0.8-2.5,2.3c0,1.1,0.2,1.8,0.4,2.5c0.2,0.7,0.4,1.5,0.4,3c0,0.4,0,0.8-0.1,1.3c-0.4,2.4-1.1,5.8-1.8,9.7
  		c-0.2,0.7-0.3,1.5-0.5,2.3c-1.9,8.6-4.3,19.3-4.3,28.1c0,2.8,0.1,7.6,0.2,12.7c0.1,7.9,0.3,16.8,0.2,19.2
  		c-0.1,1.7-0.9,7.7-1.8,13.8c-3.3,10.3-5.4,21.1-5.4,27.2c0,2.4,0,9.7,3.1,12.3c2.9,2.4,13.5,1.9,14.7,1.8c2,0.6,4.5,0.8,6.9,0.8
  		c4.1,0,7.9-0.6,8.6-0.7c5.9,1.4,14.5-0.6,14.9-0.7l0.4-0.1v-0.4C397.5,150.7,397.5,147.5,397.5,144.5z"/>
  </g>
  <g id="separator_marks_deselcted">
  	<g id="sep_x5F_42" v-on:click="separatorClick(42)">
  		<rect x="362.1" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[42]) ? 'active' : '')" points="367.1,207.3 371.1,199.3 363.1,199.3 		"/>
  	</g>
  	<g id="sep_x5F_43" v-on:click="separatorClick(43)">
  		<rect x="328.3" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[43]) ? 'active' : '')" points="333.3,207.3 337.3,199.3 329.3,199.3 		"/>
  	</g>
  	<g id="sep_x5F_44" v-on:click="separatorClick(44)">
  		<rect x="289.2" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[44]) ? 'active' : '')" points="294.2,207.3 298.2,199.3 290.2,199.3 		"/>
  	</g>
  	<g id="sep_x5F_45" v-on:click="separatorClick(45)">
  		<rect x="250.1" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[45]) ? 'active' : '')" points="255.1,207.3 259.1,199.3 251.1,199.3 		"/>
  	</g>
  	<g id="sep_x5F_46" v-on:click="separatorClick(46)">
  		<rect x="207.5" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[46]) ? 'active' : '')" points="212.5,207.3 216.5,199.3 208.5,199.3 		"/>
  	</g>
  	<g id="sep_x5F_47" v-on:click="separatorClick(47)">
  		<rect x="145.4" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[47]) ? 'active' : '')" points="150.4,207.3 154.4,199.3 146.4,199.3 		"/>
  	</g>
  	<g id="sep_x5F_48" v-on:click="separatorClick(48)">
  		<rect x="86.4" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[48]) ? 'active' : '')" points="91.4,207.3 95.4,199.3 87.4,199.3 		"/>
  	</g>
  	<g id="sep_x5F_31-41" v-on:click="separatorClick(31)">
  		<rect x="395" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[31] || separators[41]) ? 'active' : '')" points="400,207.3 396,199.3 404,199.3 		"/>
  	</g>
  	<g id="sep_x5F_32" v-on:click="separatorClick(32)">
  		<rect x="428.1" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[32]) ? 'active' : '')" points="433.1,207.3 429.1,199.3 437.1,199.3 		"/>
  	</g>
  	<g id="sep_x5F_33" v-on:click="separatorClick(33)">
  		<rect x="461.9" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[33]) ? 'active' : '')" points="466.9,207.3 462.9,199.3 470.9,199.3 		"/>
  	</g>
  	<g id="sep_x5F_34" v-on:click="separatorClick(34)">
  		<rect x="501" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[34]) ? 'active' : '')" points="506,207.3 502,199.3 510,199.3 		"/>
  	</g>
  	<g id="sep_x5F_35" v-on:click="separatorClick(35)">
  		<rect x="540.1" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[35]) ? 'active' : '')" points="545.1,207.3 541.1,199.3 549.1,199.3 		"/>
  	</g>
  	<g id="sep_x5F_36" v-on:click="separatorClick(36)">
  		<rect x="582.7" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[36]) ? 'active' : '')" points="587.7,207.3 583.7,199.3 591.7,199.3 		"/>
  	</g>
  	<g id="sep_x5F_37" v-on:click="separatorClick(37)">
  		<rect x="644.8" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[37]) ? 'active' : '')" points="649.8,207.3 645.8,199.3 653.8,199.3 		"/>
  	</g>
  	<g id="sep_x5F_38" v-on:click="separatorClick(38)">
  		<rect x="703.8" y="199.3" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[38]) ? 'active' : '')" points="708.8,207.3 704.8,199.3 712.8,199.3 		"/>
  	</g>
  	<g id="sep_x5F_22" v-on:click="separatorClick(22)">
  		<rect x="446.1" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[22]) ? 'active' : '')" points="451.1,171 447.1,179 455.1,179 		"/>
  	</g>
  	<g id="sep_x5F_23" v-on:click="separatorClick(23)">
  		<rect x="488.2" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[23]) ? 'active' : '')" points="493.2,171 489.2,179 497.2,179 		"/>
  	</g>
  	<g id="sep_x5F_24" v-on:click="separatorClick(24)">
  		<rect x="531.9" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[24]) ? 'active' : '')" points="536.9,171 532.9,179 540.9,179 		"/>
  	</g>
  	<g id="sep_x5F_25" v-on:click="separatorClick(25)">
  		<rect x="570.6" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[25]) ? 'active' : '')" points="575.6,171 571.6,179 579.6,179 		"/>
  	</g>
  	<g id="sep_x5F_26" v-on:click="separatorClick(26)">
  		<rect x="610.6" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[26]) ? 'active' : '')" points="615.6,171 611.6,179 619.6,179 		"/>
  	</g>
  	<g id="sep_x5F_27" v-on:click="separatorClick(27)">
  		<rect x="661" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[27]) ? 'active' : '')" points="666,171 662,179 670,179 		"/>
  	</g>
  	<g id="sep_x5F_28" v-on:click="separatorClick(28)">
  		<rect x="707.3" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[28]) ? 'active' : '')" points="712.3,171 708.3,179 716.3,179 		"/>
  	</g>
  	<g id="sep_x5F_11-21" v-on:click="separatorClick(11)">
  		<rect x="395" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[11] || separators[21]) ? 'active' : '')" points="400,171 404,179 396,179 		"/>
  	</g>
  	<g id="sep_x5F_12" v-on:click="separatorClick(12)">
  		<rect x="344" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[12]) ? 'active' : '')" points="349,171 353,179 345,179 		"/>
  	</g>
  	<g id="sep_x5F_13" v-on:click="separatorClick(13)">
  		<rect x="302" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[13]) ? 'active' : '')" points="307,171 311,179 303,179 		"/>
  	</g>
  	<g id="sep_x5F_14" v-on:click="separatorClick(14)">
  		<rect x="258.3" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[14]) ? 'active' : '')" points="263.3,171 267.3,179 259.3,179 		"/>
  	</g>
  	<g id="sep_x5F_15" v-on:click="separatorClick(15)">
  		<rect x="219.6" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[15]) ? 'active' : '')" points="224.6,171 228.6,179 220.6,179 		"/>
  	</g>
  	<g id="sep_x5F_16" v-on:click="separatorClick(16)">
  		<rect x="179.6" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[16]) ? 'active' : '')" points="184.6,171 188.6,179 180.6,179 		"/>
  	</g>
  	<g id="sep_x5F_17" v-on:click="separatorClick(17)">
  		<rect x="129.2" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[17]) ? 'active' : '')" points="134.2,171 138.2,179 130.2,179 		"/>
  	</g>
  	<g id="sep_x5F_18" v-on:click="separatorClick(18)">
  		<rect x="82.9" y="169" class="st76" width="10" height="10"/>
  		<polygon class="st83" v-bind:class="((separators[18]) ? 'active' : '')" points="87.9,171 91.9,179 83.9,179 		"/>
  	</g>
  </g>
  <g id="separator_Lines">
  	<rect id="line_x5F_48" v-if="((separators[48]) ? 'active' : '')" x="90.4" y="200.2" class="st84" width="2" height="151.8"/>
  	<rect id="line_x5F_47" v-if="((separators[47]) ? 'active' : '')" x="149.4" y="200.2" class="st84" width="2" height="151.8"/>
  	<rect id="line_x5F_46" v-if="((separators[46]) ? 'active' : '')" x="211.5" y="200.2" class="st84" width="2" height="151.8"/>
  	<rect id="line_x5F_45" v-if="((separators[45]) ? 'active' : '')" x="254.1" y="200.2" class="st84" width="2" height="151.8"/>
  	<rect id="line_x5F_44" v-if="((separators[44]) ? 'active' : '')" x="293.2" y="200.2" class="st84" width="2" height="151.8"/>
  	<rect id="line_x5F_43" v-if="((separators[43]) ? 'active' : '')" x="332.3" y="200.3" class="st84" width="2" height="151.8"/>
  	<rect id="line_x5F_42" v-if="((separators[42]) ? 'active' : '')" x="366.1" y="200.2" class="st84" width="2" height="151.8"/>

  		<rect id="line_x5F_38" v-if="((separators[38]) ? 'active' : '')" x="707.8" y="200.2" transform="matrix(-1 -4.456536e-11 4.456536e-11 -1 1417.5228 552.213)" class="st84" width="2" height="151.8"/>

  		<rect id="line_x5F_37" v-if="((separators[37]) ? 'active' : '')" x="648.8" y="200.2" transform="matrix(-1 -4.547486e-11 4.547486e-11 -1 1299.511 552.213)" class="st84" width="2" height="151.8"/>

  		<rect id="line_x5F_36" v-if="((separators[36]) ? 'active' : '')" x="586.6" y="200.2" transform="matrix(-1 -4.547486e-11 4.547486e-11 -1 1175.2864 552.213)" class="st84" width="2" height="151.8"/>

  		<rect id="line_x5F_35" v-if="((separators[35]) ? 'active' : '')" x="544.1" y="200.2" transform="matrix(-1 -4.547486e-11 4.547486e-11 -1 1090.1263 552.213)" class="st84" width="2" height="151.8"/>

  		<rect id="line_x5F_34" v-if="((separators[34]) ? 'active' : '')" x="505" y="200.2" transform="matrix(-1 -5.093182e-11 5.093182e-11 -1 1011.9271 552.213)" class="st84" width="2" height="151.8"/>

  		<rect id="line_x5F_33" v-if="((separators[33]) ? 'active' : '')" x="465.9" y="200.3" transform="matrix(-1 -4.547486e-11 4.547486e-11 -1 933.7532 552.338)" class="st84" width="2" height="151.8"/>

  		<rect id="line_x5F_32" v-if="((separators[32]) ? 'active' : '')" x="432" y="200.2" transform="matrix(-1 -4.456536e-11 4.456536e-11 -1 866.0775 552.213)" class="st84" width="2" height="151.8"/>

  		<rect id="line_x5F_31-41" v-if="((separators[31] || separators[41]) ? 'active' : '')" x="399" y="200.2" transform="matrix(-1 -4.547486e-11 4.547486e-11 -1 799.9603 552.213)" class="st84" width="2" height="151.8"/>

  		<rect id="line_x5F_28" v-if="((separators[28]) ? 'active' : '')" x="711.3" y="8" transform="matrix(-1 -4.456536e-11 4.456536e-11 -1 1424.5892 185.9112)" class="st84" width="2" height="170"/>

  		<rect id="line_x5F_27" v-if="((separators[27]) ? 'active' : '')" x="664.9" y="8" transform="matrix(-1 -4.456536e-11 4.456536e-11 -1 1331.8704 185.9112)" class="st84" width="2" height="170"/>

  		<rect id="line_x5F_26" v-if="((separators[26]) ? 'active' : '')" x="614.6" y="8" transform="matrix(-1 -4.456536e-11 4.456536e-11 -1 1231.1702 185.9112)" class="st84" width="2" height="170"/>

  		<rect id="line_x5F_25" v-if="((separators[25]) ? 'active' : '')" x="574.5" y="8" transform="matrix(-1 -4.365587e-11 4.365587e-11 -1 1151.0912 185.9112)" class="st84" width="2" height="170"/>

  		<rect id="line_x5F_24" v-if="((separators[24]) ? 'active' : '')" x="535.9" y="8" transform="matrix(-1 -4.456536e-11 4.456536e-11 -1 1073.7596 185.9112)" class="st84" width="2" height="170"/>

  		<rect id="line_x5F_23" v-if="((separators[23]) ? 'active' : '')" x="492.2" y="8" transform="matrix(-1 -4.547486e-11 4.547486e-11 -1 986.4089 186.0362)" class="st84" width="2" height="170"/>

  		<rect id="line_x5F_22" v-if="((separators[22]) ? 'active' : '')" x="450.1" y="8" transform="matrix(-1 -4.456536e-11 4.456536e-11 -1 902.2572 185.9112)" class="st84" width="2" height="170"/>
  	<rect id="line_x5F_18" v-if="((separators[18]) ? 'active' : '')" x="86.9" y="8" class="st84" width="2" height="170"/>
  	<rect id="line_x5F_17" v-if="((separators[17]) ? 'active' : '')" x="133.2" y="8" class="st84" width="2" height="170"/>
  	<rect id="line_x5F_16" v-if="((separators[16]) ? 'active' : '')" x="183.6" y="8" class="st84" width="2" height="170"/>
  	<rect id="line_x5F_15" v-if="((separators[15]) ? 'active' : '')" x="223.6" y="8" class="st84" width="2" height="170"/>
  	<rect id="line_x5F_14" v-if="((separators[14]) ? 'active' : '')" x="262.3" y="8" class="st84" width="2" height="170"/>
  	<rect id="line_x5F_13" v-if="((separators[13]) ? 'active' : '')" x="306" y="8" class="st84" width="2" height="170"/>
  	<rect id="line_x5F_12" v-if="((separators[12]) ? 'active' : '')" x="348" y="8" class="st84" width="2" height="170"/>
  	<rect id="line_x5F_11-21" v-if="((separators[11] || separators[21]) ? 'active' : '')" x="399" y="8" class="st84" width="2" height="170"/>
  </g>
  </svg>


</template>

<style scoped>
.Shade_x0020_6{opacity:0.1;}
.Highligh_x0020_6{fill:#FFFFFF;}
.Shade_x0020_7{opacity:0.1;}
.Highligh_x0020_7{fill:#FFFFFF;}
.Shade_x0020_9{opacity:0.1;}
.Shade_x0020_10{opacity:0.1;}
.Highligh_x0020_9{fill:#FFFFFF;}
.Shade_x0020_11{opacity:0.1;}
.Highligh_x0020_10{fill:#FFFFFF;}
.st0{fill:url(#SVGID_1_);}
.st1{fill:none;stroke:#99A0B5;stroke-miterlimit:10;}
.st2{fill:url(#SVGID_2_);}
.st3{fill:url(#SVGID_3_);}
.st4{fill:url(#SVGID_4_);}
.st5{fill:url(#SVGID_5_);}
.st6{fill:url(#SVGID_6_);}
.st7{fill:url(#SVGID_7_);}
.st8{fill:url(#SVGID_8_);}
.st9{fill:url(#SVGID_9_);}
.st10{fill:#99A0B5;}
.st11{fill:url(#SVGID_10_);}
.st12{fill:url(#SVGID_11_);}
.st13{fill:url(#SVGID_12_);}
.st14{fill:url(#SVGID_13_);}
.st15{fill:url(#SVGID_14_);}
.st16{fill:url(#SVGID_15_);}
.st17{fill:url(#SVGID_16_);}
.st18{fill:url(#SVGID_17_);}
.st19{fill:url(#SVGID_18_);}
.st20{fill:none;stroke:#FF0000;stroke-width:0.25;stroke-miterlimit:10;}
.st21{fill:url(#SVGID_19_);}
.st22{fill:url(#SVGID_20_);}
.st23{fill:url(#SVGID_21_);}
.st24{fill:url(#SVGID_22_);}
.st25{fill:url(#SVGID_23_);}
.st26{fill:url(#SVGID_24_);}
.st27{fill:url(#SVGID_25_);}
.st28{fill:url(#SVGID_26_);}
.st29{opacity:5.000000e-02;}
.st30{fill:url(#SVGID_27_);}
.st31{fill:url(#SVGID_28_);}
.st32{fill:url(#SVGID_29_);}
.st33{fill:url(#SVGID_30_);}
.st34{fill:url(#SVGID_31_);}
.st35{fill:url(#SVGID_32_);}
.st36{fill:url(#SVGID_33_);}
.st37{fill:url(#SVGID_34_);}
.st38{fill:url(#g48_1_);}
.st39{fill:url(#g47_1_);}
.st40{fill:url(#g46_1_);}
.st41{fill:url(#g45_1_);}
.st42{fill:url(#g44_1_);}
.st43{fill:url(#g43_1_);}
.st44{fill:url(#g42_1_);}
.st45{fill:url(#g41_1_);}
.st46{fill:url(#g38_1_);}
.st47{fill:url(#g37_1_);}
.st48{fill:url(#g36_1_);}
.st49{fill:url(#g35_1_);}
.st50{fill:url(#g34_1_);}
.st51{fill:url(#g33_1_);}
.st52{fill:url(#g32_1_);}
.st53{fill:url(#g31_1_);}
.st54{fill:url(#g28_1_);}
.st55{fill:url(#g27_1_);}
.st56{fill:url(#g26_1_);}
.st57{fill:url(#g25_1_);}
.st58{fill:url(#g24_1_);}
.st59{fill:url(#g23_1_);}
.st60{fill:url(#g22_1_);}
.st61{fill:url(#g21_1_);}
.st62{fill:url(#g18_1_);}
.st63{fill:url(#g17_1_);}
.st64{fill:url(#g16_1_);}
.st65{fill:url(#g15_1_);}
.st66{fill:url(#g14_1_);}
.st67{fill:url(#g13_1_);}
.st68{fill:url(#g12_1_);}
.st69{fill:url(#g11_1_);}
.st70{opacity:7.000000e-02;}
.st71{fill:#F4F4F4;stroke:#99A0B5;stroke-miterlimit:10;}
.st72{opacity:0.2;}
.st73{opacity:0.7;fill:#FFFFFF;}
.st74{fill:#F4F4F4;stroke:#99A0B5;stroke-linejoin:round;stroke-miterlimit:10;}
.st75{opacity:0.15;}
.st76{fill:#FFFFFF;}
.st77{opacity:8.000000e-02;}
.st78{opacity:0.5;fill:#FFFFFF;}
.st79{opacity:0.1;}
.st80{fill:#828799;}
.st81{fill:none;stroke:#CFD4E6;stroke-miterlimit:10;}
.st82{opacity:0.5;fill:#0AA1E6;}
.st83{fill-rule:evenodd;clip-rule:evenodd;fill:#CFD3D8;}
.st84{fill-rule:evenodd;clip-rule:evenodd;fill:#02BC78;}

.st82{opacity:0;fill:#0AA1E6;}
.st82:hover { opacity: 0.3; }
.st82.active { opacity: 0.5; }

.st83:hover{fill:#02BC78; cursor: pointer;}
.st76.active{cursor: pointer;}
.st83.active {fill:#02BC78;}

</style>

<script>

export default {
  name: 'Teeth',
  props: ['tooth', 'separators'],
  methods:
  {
    toothClick(tooth)
    {
      var me = this;
      me.$emit('teethclick', [tooth]);
    },
    separatorClick(separator)
    {
      var me = this;
      me.$emit('separatorclick', [separator]);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Teeth.vue